module.exports = /******/function (modules) {
  // webpackBootstrap
  /******/ // The module cache
  /******/
  var installedModules = {};
  /******/
  /******/ // The require function
  /******/
  function __webpack_require__(moduleId) {
    /******/
    /******/ // Check if module is in cache
    /******/if (installedModules[moduleId]) {
      /******/return installedModules[moduleId].exports;
      /******/
    }
    /******/ // Create a new module (and put it into the cache)
    /******/
    var module = installedModules[moduleId] = {
      /******/i: moduleId,
      /******/l: false,
      /******/exports: {}
      /******/
    };
    /******/
    /******/ // Execute the module function
    /******/
    modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
    /******/
    /******/ // Flag the module as loaded
    /******/
    module.l = true;
    /******/
    /******/ // Return the exports of the module
    /******/
    return module.exports;
    /******/
  }
  /******/
  /******/
  /******/ // expose the modules object (__webpack_modules__)
  /******/
  __webpack_require__.m = modules;
  /******/
  /******/ // expose the module cache
  /******/
  __webpack_require__.c = installedModules;
  /******/
  /******/ // define getter function for harmony exports
  /******/
  __webpack_require__.d = function (exports, name, getter) {
    /******/if (!__webpack_require__.o(exports, name)) {
      /******/Object.defineProperty(exports, name, {
        enumerable: true,
        get: getter
      });
      /******/
    }
    /******/
  };
  /******/
  /******/ // define __esModule on exports
  /******/
  __webpack_require__.r = function (exports) {
    /******/if (typeof Symbol !== 'undefined' && Symbol.toStringTag) {
      /******/Object.defineProperty(exports, Symbol.toStringTag, {
        value: 'Module'
      });
      /******/
    }
    /******/
    Object.defineProperty(exports, '__esModule', {
      value: true
    });
    /******/
  };
  /******/
  /******/ // create a fake namespace object
  /******/ // mode & 1: value is a module id, require it
  /******/ // mode & 2: merge all properties of value into the ns
  /******/ // mode & 4: return value when already ns object
  /******/ // mode & 8|1: behave like require
  /******/
  __webpack_require__.t = function (value, mode) {
    /******/if (mode & 1) value = __webpack_require__(value);
    /******/
    if (mode & 8) return value;
    /******/
    if (mode & 4 && typeof value === 'object' && value && value.__esModule) return value;
    /******/
    var ns = Object.create(null);
    /******/
    __webpack_require__.r(ns);
    /******/
    Object.defineProperty(ns, 'default', {
      enumerable: true,
      value: value
    });
    /******/
    if (mode & 2 && typeof value != 'string') for (var key in value) __webpack_require__.d(ns, key, function (key) {
      return value[key];
    }.bind(null, key));
    /******/
    return ns;
    /******/
  };
  /******/
  /******/ // getDefaultExport function for compatibility with non-harmony modules
  /******/
  __webpack_require__.n = function (module) {
    /******/var getter = module && module.__esModule ? /******/function getDefault() {
      return module['default'];
    } : /******/function getModuleExports() {
      return module;
    };
    /******/
    __webpack_require__.d(getter, 'a', getter);
    /******/
    return getter;
    /******/
  };
  /******/
  /******/ // Object.prototype.hasOwnProperty.call
  /******/
  __webpack_require__.o = function (object, property) {
    return Object.prototype.hasOwnProperty.call(object, property);
  };
  /******/
  /******/ // __webpack_public_path__
  /******/
  __webpack_require__.p = "";
  /******/
  /******/
  /******/ // Load entry module and return exports
  /******/
  return __webpack_require__(__webpack_require__.s = 8);
  /******/
}
/************************************************************************/
/******/([(/* 0 */
/***/function (module, exports) {
  var g;

  // This works in non-strict mode
  g = function () {
    return this;
  }();
  try {
    // This works if eval is allowed (see CSP)
    g = g || new Function("return this")();
  } catch (e) {
    // This works if the window reference is available
    if (typeof window === "object") g = window;
  }

  // g can still be undefined, but nothing to do about it...
  // We return undefined, instead of nothing here, so it's
  // easier to handle this case. if(!global) { ...}

  module.exports = g;

  /***/
}), (/* 1 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  /* WEBPACK VAR INJECTION */
  (function (global) {
    /* eslint-disable no-console */
    var env = __webpack_require__(2);
    function toLogStore(message, publisher, eventType, label, isDebugEnabled) {
      try {
        if (typeof isDebugEnabled === 'boolean' && isDebugEnabled) {
          // for browser automation tests
          addMetaTagWithDebugInfo(message, publisher, eventType, label);
          console.log('[PlatformAnalyticsPrimeJs-publishing-event] Publisher: ' + publisher + ', evenType: ' + eventType + ', message: ' + JSON.stringify(message, null, 2));
          if (typeof global.uisPrimeLogStore === 'undefined') {
            global.uisPrimeLogStore = {};
          }
        }
        if (typeof global.uisPrimeLogStore !== 'undefined') {
          // for unit tests
          addDebugInfoToGlobalVariable(message, publisher, eventType, label, isDebugEnabled);
        }
      } catch (err) {
        console.log('An error occurred while logging debug info: ' + err);
      }
    }
    function addMetaTagWithDebugInfo(message, publisher, eventType, label) {
      try {
        var meta = document.createElement('meta');
        meta.id = 'uis_debug_' + publisher + '_' + eventType + '_' + label;
        meta.dataset.type = 'uis-prime-debug';
        meta.dataset.publisher = publisher;
        meta.dataset.event_type = eventType;
        meta.dataset.timestamp = getCurrentTimestamp();
        meta.dataset.debug = JSON.stringify(message);
        document.getElementsByTagName('head')[0].appendChild(meta);
      } catch (err) {
        console.log('error logging to meta tags: ' + err);
      }
    }
    function addDebugInfoToGlobalVariable(message, publisher, eventType, label, isDebugEnabled) {
      if (typeof global.uisPrimeLogStore[publisher] === 'undefined') {
        global.uisPrimeLogStore[publisher] = {};
      }
      if (typeof global.uisPrimeLogStore[publisher][eventType] === 'undefined') {
        global.uisPrimeLogStore[publisher][eventType] = [];
      }
      global.uisPrimeLogStore[publisher][eventType].push({
        timestamp: getCurrentTimestamp(),
        message: JSON.parse(JSON.stringify(message)),
        // deep copy
        publisher: publisher,
        eventType: eventType,
        label: label,
        isDebugEnabled: isDebugEnabled
      });
    }
    function log(message) {
      if (env.isTestEnvironment()) {
        console.log(message);
      }
    }
    function logError(error, message) {
      var logged = [];
      if (message) {
        logged.push(message);
      }
      logged.push(error);
      if (error.stack) {
        logged.push(error.stack);
      }
      log(logged.join('\n'));
    }
    function getCurrentTimestamp() {
      return typeof Date.now === 'function' ? Date.now() : Number(new Date());
    }
    module.exports = {
      toLogStore: toLogStore,
      log: log,
      logError: logError
    };
    /* WEBPACK VAR INJECTION */
  }).call(this, __webpack_require__(0));

  /***/
}), (/* 2 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  /* WEBPACK VAR INJECTION */
  (function (global) {
    var devConfig = __webpack_require__(12);
    var testConfig = __webpack_require__(13);
    var prodConfig = __webpack_require__(14);
    var intConfig = __webpack_require__(15);
    var TEST_ENVIRONMENT_REGEX = /(?:(?:test|int|stress)\.expedia\.com|exp-(?:test|int)\.net|karmalab\.net|expedmz.com|staging.*\.(?:traveltainment\.de|myersmediagroup\.com)|localhost|127\.0\.0\.1|[a-z]+\.staging1-[a-z]+\.[a-z]+|docweb\.exp-test\.net|wwwexpediacom\.sandbox\.dev\.sb\.karmalab\.net)$/i; // eslint-disable-line max-len

    var INTEGRATION_ENVIRONMENT_REGEX = /.int.*\.sb\.karmalab\.net/i;
    function isTestEnvironment() {
      var isTestEnv = false;
      if (isBrowser() && typeof global.location !== 'undefined') {
        isTestEnv = Boolean(global.location.hostname.match(TEST_ENVIRONMENT_REGEX));
      } else {
        isTestEnv = ['prod', 'production'].indexOf("production") === -1;
      }
      return isTestEnv;
    }
    function isIntEnvironment() {
      return typeof global.location !== 'undefined' ? Boolean(global.location.hostname.match(INTEGRATION_ENVIRONMENT_REGEX)) : false;
    }
    function isLocalEnvironment() {
      if (typeof global.location !== 'undefined') {
        return global.location.hostname === 'localhost' || global.location.hostname === '127.0.0.1' || global.location.hostname.indexOf('dev') > 0;
      }
      return false;
    }
    function getConfiguration() {
      if (isLocalEnvironment()) {
        return devConfig;
      }
      if (isIntEnvironment()) {
        return intConfig;
      }
      if (isTestEnvironment()) {
        return testConfig;
      }
      return prodConfig;
    }
    var isPerformanceTimingSupported = function isPerformanceTimingSupported() {
      return isPerformanceSupported() && window.performance.timing && typeof window.performance.timing.navigationStart !== 'undefined';
    };
    var isPerformanceMarkSupported = function isPerformanceMarkSupported() {
      return isPerformanceSupported() && (typeof window.performance.mark === 'function' || typeof window.performance.webkitMark === 'function');
    };
    function isBrowser() {
      return typeof window !== 'undefined';
    }
    function isPerformanceSupported() {
      return isBrowser() && window.performance;
    }
    module.exports = {
      isTestEnvironment: isTestEnvironment,
      isLocalEnvironment: isLocalEnvironment,
      isBrowser: isBrowser,
      isPerformanceTimingSupported: isPerformanceTimingSupported,
      isPerformanceMarkSupported: isPerformanceMarkSupported,
      isTrackingDisabled: function isTrackingDisabled() {
        return isBrowser() && navigator.doNotTrack === '1';
      },
      isBeaconSupported: function isBeaconSupported() {
        return isBrowser() && typeof navigator.sendBeacon === 'function';
      },
      getConfiguration: getConfiguration
    };
    /* WEBPACK VAR INJECTION */
  }).call(this, __webpack_require__(0));

  /***/
}), (/* 3 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  /* WEBPACK VAR INJECTION */
  (function (global) {
    var domainList = ['chase.com', 'ml.com', 'bankofamerica.com'];
    function getDomain() {
      var cookieDomain = void 0;
      if (typeof window !== 'undefined') {
        cookieDomain = global.location.hostname;
        if (cookieDomain.match(/([^.]+(\.(co|com|web|ne|net))?\.[^.]+)$/) && !cookieDomain.match(RegExp('.*' + domainList.join('|') + '$', 'g'))) {
          cookieDomain = RegExp.$1;
        }
      }
      return cookieDomain;
    }
    function getCookie(cname) {
      var name = cname + '=';
      var decodedCookie = decodeURIComponent(document.cookie);
      var ca = decodedCookie.split(';');
      for (var i = 0; i < ca.length; i += 1) {
        var c = ca[i];
        while (c.charAt(0) === ' ') {
          c = c.substring(1);
        }
        if (c.indexOf(name) === 0) {
          return c.substring(name.length, c.length);
        }
      }
      return '';
    }
    function getCurrentDate() {
      return new Date();
    }
    function fetchHours(currentDate) {
      return currentDate.getHours();
    }
    function fetchMinutes(currentDate) {
      return currentDate.getMinutes();
    }
    function fetchDay(currentDate) {
      return currentDate.getDay();
    }
    function getPointOfSale() {
      // copied from older datacapture analytics.js#getPointOfSale(domain)
      var domain = window.location.hostname;
      if (domain === 'secure2.traveltainment.de') return 'expedia.at';
      if (domainBelongsTo(domain, 'traveltainment.de')) return 'expedia.de';

      // POSes being exactly one of the listed domains (e.g. travel.hotels.com →
      // travel.hotels.com)
      var exactDomains = ['travel.hotels.com', 'vacations.alaskaair.com', 'reservations.meliapackages.com', 'travel.riu.com', 'getaway.bjs.com', 'travel.uk.hotels.com', 'travel.se.hotels.com', 'travel.fr.hotels.com', 'travel.no.hotels.com', 'travel.ca.hotels.com', 'travel.jp.hotels.com', 'us.expedia.cn'];
      if (exactDomains.filter(function (exactDomain) {
        return exactDomain === domain;
      }).length > 0) return domain;
      // POSes being the wildcard domain if it belongs to one of the listed ones
      // (e.g. www.thailand.airasiago.com → thailand.airasiago.com)
      var wildcardDomains = ['thailand.airasiago.com', 'china.airasiago.com'];
      var filteredDomains = wildcardDomains.filter(function (wildcardDomain) {
        return domainBelongsTo(domain, wildcardDomain);
      });
      if (filteredDomains && filteredDomains.length > 0) return filteredDomains[0];
      // POSes being the domain if it belongs to one of the listed wildcard domains
      // (e.g. expedia.eurostar.com → expedia.eurostar.com)
      var moreWildcardDomains = ['karmalab.net', 'eurostar.com', 'poweredbygps.com', 'citibanamex.expedia.mx'];
      var belongsToAWildcardDomain = moreWildcardDomains.filter(function (wildcardDomain) {
        return domainBelongsTo(domain, wildcardDomain);
      }).length > 0;
      // POS being the domain if it contains any of the listed genericDomains
      // (e.g. BARCELO.POWEREDBYGPS.CO.UK -> BARCELO.POWEREDBYGPS.CO.UK , POWEREDBYGPS.CO.JP -> POWEREDBYGPS.CO.JP)
      var genericDomains = ['poweredbygps'];
      var belongsToAGenericdDomain = genericDomains.filter(function (wildcardDomain) {
        return domainIncluded(domain, wildcardDomain);
      }).length > 0;
      if (belongsToAWildcardDomain || belongsToAGenericdDomain) return domain;
      // POSes being the primary domain (e.g. www.expedia.com → expedia.com)
      return getPrimaryDomain(domain);
    }
    function domainBelongsTo(domain, otherDomain) {
      return new RegExp('(^|\\.)' + otherDomain + '$', 'i').test(domain);
    }
    function domainIncluded(domain, otherDomain) {
      return new RegExp('(^|\\.)' + otherDomain + '|\\.$', 'i').test(domain);
    }
    function getPrimaryDomain(hostname) {
      if (hostname.match(RegExp('.*' + domainList.join('|') + '$', 'g'))) return hostname;
      if (hostname.match(/(^|\.)(localhost)$/)) return RegExp.$2;
      if (hostname.match(/([^.]+(\.(co|com|web|ne))?\.[^.]+)$/)) return RegExp.$1;
      return hostname;
    }
    function getMobileOrientation() {
      var isMobile = /iphone|ipad|ipod|android|blackberry|mini|windows\sce|palm/i.test(window.navigator.userAgent.toLowerCase());
      var orientation = '';
      if (isMobile) {
        orientation = window.innerHeight > window.innerWidth ? 'Portrait' : 'Landscape';
      }
      return orientation;
    }
    function uniqueArray(OrigArr) {
      var returnArr = [];
      var i = 0;
      OrigArr.forEach(function (value) {
        if (returnArr.indexOf(value) === -1) {
          returnArr[i] = value;
          i += 1;
        }
      });
      return returnArr;
    }
    function mark(name) {
      if (typeof performance.mark === 'function') {
        performance.mark(name);
      } else if (typeof performance.webkitMark === 'function') {
        performance.webkitMark(name);
      }
    }
    function getMarkEntries() {
      var returnArr = {};
      if (typeof performance.getEntriesByType === 'function') {
        returnArr = performance.getEntriesByType('mark');
      } else if (typeof performance.webkitGetEntriesByType === 'function') {
        returnArr = performance.webkitGetEntriesByType('mark');
      }
      return returnArr;
    }
    function clearMarks(markName) {
      if (typeof performance.clearMarks === 'function') {
        performance.clearMarks(markName);
      }
    }
    function findMark(markName) {
      return findSpecificRow(getMarkEntries(), markName);
    }
    function findSpecificRow(OrigArr, markName) {
      var filteredArray = OrigArr.filter(function (sRow) {
        return sRow.name === markName;
      });
      return filteredArray.length > 0 ? filteredArray[0] : undefined;
    }
    function getQueryParameterByName(key, url) {
      if (key && url) {
        var param = decodeURIComponent(url.replace(new RegExp('^(?:.*[&\\?]' + encodeURIComponent(key).replace(/[\\.\\+\\*]/g, '\\$&') + '(?:\\=([^&]*))?)?.*$', 'i'), '$1'));
        return param !== '' ? param : null;
      }
      return null;
    }
    function fetchMarketingIdFromCookie(cookieName) {
      cookieName = encodeURIComponent(cookieName);
      var regExpStr = cookieName + '=([^;]*)';
      var regexp = new RegExp(regExpStr);
      var alreadyLoadedInCookie = regexp.exec(document.cookie);
      var marketingVar = '';
      if (alreadyLoadedInCookie && alreadyLoadedInCookie.length >= 1) {
        var value = decodeURIComponent(alreadyLoadedInCookie[1]);
        var mid = value.match(/MCMID\|([^|]*)/) ? RegExp.$1 : 'unknown';
        if (mid && mid.length >= 1) {
          marketingVar = mid;
        }
      }
      return marketingVar;
    }
    module.exports = {
      getPointOfSale: getPointOfSale,
      getMobileOrientation: getMobileOrientation,
      getCookie: getCookie,
      getDomain: getDomain,
      getCurrentDate: getCurrentDate,
      fetchHours: fetchHours,
      fetchMinutes: fetchMinutes,
      fetchDay: fetchDay,
      uniqueArray: uniqueArray,
      findMark: findMark,
      clearMarks: clearMarks,
      mark: mark,
      findSpecificRow: findSpecificRow,
      getMarkEntries: getMarkEntries,
      getQueryParameterByName: getQueryParameterByName,
      fetchMarketingIdFromCookie: fetchMarketingIdFromCookie
    };
    /* WEBPACK VAR INJECTION */
  }).call(this, __webpack_require__(0));

  /***/
}), (/* 4 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  /* WEBPACK VAR INJECTION */
  (function (global) {
    var config = __webpack_require__(7);
    var browser = __webpack_require__(3);
    var visitorApiLocal = __webpack_require__(11);
    var _require = __webpack_require__(1),
      toLogStore = _require.toLogStore,
      log = _require.log;
    module.exports = {
      load: loadVisitorApi,
      initVisitorAPI: initVisitorAPI
    };
    var visitorApiLibrary = void 0;
    function loadVisitorApi() {
      if (!visitorApiLibrary) {
        visitorApiLibrary = loadMarketingCloudIdService();
      }
      return visitorApiLibrary;
    }
    var marketingCloudIdService = void 0;
    var isCGPCallDone = false;
    function fireAmcvBeacon(traceIdOfClientSidePayload, visitor) {
      setTimeout(function () {
        return fireAmcvSet(traceIdOfClientSidePayload, visitor, 1);
      }, 50);
    }
    function fireAmcvSet(traceIdOfClientSidePayload, visitor, numOfRetries) {
      // this has to fire only when the amcvid is fetched the first time from Adobe
      if (traceIdOfClientSidePayload && !isCGPCallDone && !visitor.isClientSideMarketingCloudVisitorID()) {
        var mcmId = browser.fetchMarketingIdFromCookie('AMCV_' + config.ADOBE_MARKETING_CLOUD_ORGANIZATION_ID);
        if (mcmId) {
          sendBeaconUrl('/cgp/simple/amcv.set?traceIdOfTheView=' + traceIdOfClientSidePayload);
          isCGPCallDone = true;
        } else {
          numOfRetries += 1;
          if (numOfRetries < 4) {
            setTimeout(function () {
              return fireAmcvSet(traceIdOfClientSidePayload, visitor, numOfRetries);
            }, 50);
          } else {
            sendBeaconUrl('/cgp/simple/amcv.set?traceIdOfTheView=' + traceIdOfClientSidePayload + '&missingAmcvCookie=true');
            isCGPCallDone = true;
          }
        }
      }
    }
    function sendBeaconUrl(amcvBeaconUrl) {
      var xmlHttp = window.uisDebugXmlHttpRequest ? window.uisDebugXmlHttpRequest : new XMLHttpRequest();
      xmlHttp.onreadystatechange = function () {
        if (xmlHttp.readyState === 4) {
          console.log('sent call to CGP on visitor ID generation %o', xmlHttp.status);
        }
      };
      xmlHttp.open('GET', amcvBeaconUrl, true);
      xmlHttp.withCredentials = true;
      xmlHttp.send();
      isCGPCallDone = true;
      toLogStore(amcvBeaconUrl, 'papj', 'load', 'fireAmcvBeacon', true);
    }
    function initVisitorAPI(traceIdOfClientSidePayload) {
      log('fetching visitor');
      var visitor = global.Visitor.getInstance(config.ADOBE_MARKETING_CLOUD_ORGANIZATION_ID, {
        trackingServer: config.OMNITURE_TRACKING_SERVER,
        trackingServerSecure: config.OMNITURE_TRACKING_SERVER_SECURE,
        marketingCloudServer: config.OMNITURE_TRACKING_SERVER,
        marketingCloudServerSecure: config.OMNITURE_TRACKING_SERVER_SECURE,
        loadTimeout: 5000,
        cookieDomain: browser.getDomain(),
        takeTimeoutMetrics: true,
        overwriteCrossDomainMCIDAndAID: true
      });
      log('visitor found!');
      toLogStore('Visitor', 'papj', 'load', 'visitorLoad', false);
      visitor.getMarketingCloudVisitorID(function () {
        fireAmcvBeacon(traceIdOfClientSidePayload, visitor);
      });
      return visitor;
    }

    // Documented here: https://marketing.adobe.com/resources/help/en_US/mcvid/mcvid-setup-analytics.html
    function loadMarketingCloudIdService() {
      if (!marketingCloudIdService) {
        log('loading visitor API');
        marketingCloudIdService = new Promise(function (resolve, reject) {
          try {
            if (typeof global.Visitor === 'undefined') {
              global.Visitor = visitorApiLocal.Visitor;
            }
            resolve(initVisitorAPI());
          } catch (err) {
            reject(err);
          }
        });
      }
      return marketingCloudIdService;
    }
    /* WEBPACK VAR INJECTION */
  }).call(this, __webpack_require__(0));

  /***/
}), (/* 5 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  var config = __webpack_require__(7);
  var environment = __webpack_require__(2);
  var _require = __webpack_require__(3),
    getDomain = _require.getDomain;
  var adobeApiLoader = __webpack_require__(4);
  var appMeasurementPatched = __webpack_require__(20);
  var appMeasurementLibrary = void 0;
  function loadAppMeasurementApi() {
    if (!appMeasurementLibrary) {
      appMeasurementLibrary = loadAppMeasurement(); // Promise.all([loadMarketingCloudIdService(), loadAppMeasurement()]);
    }
    return appMeasurementLibrary;
  }
  module.exports.load = loadAppMeasurementApi;
  var appMeasurement = void 0;

  // Documented here: https://marketing.adobe.com/resources/help/en_US/sc/implement/appmeasure_mjs.html
  function loadAppMeasurement() {
    if (!appMeasurement) {
      appMeasurement = new Promise(function (resolve, reject) {
        var onAppMeasurementApiReady = function onAppMeasurementApiReady() {
          adobeApiLoader.load().then(function () {
            try {
              var account = environment.getConfiguration().adobeAnalyticsAccount;
              var s = window.s_gi(account);
              s.trackingServer = config.OMNITURE_TRACKING_SERVER;
              s.trackingServerSecure = config.OMNITURE_TRACKING_SERVER_SECURE;
              s.trackDownloadLinks = true;
              s.trackExternalLinks = false;
              s.trackInlineStats = false;
              s.linkDownloadFileTypes = 'exe,zip,wav,mp3,mov,mpg,avi,wmv,doc,pdf,xls';
              // eslint-disable-next-line no-script-url
              s.linkInternalFilters = ['javascript:', document.domain, getDomain].join(',');
              s.linkLeaveQueryString = false;
              s.linkTrackVars = 'None';
              s.linkTrackEvents = 'None';
              s.server = document.domain;
              s.usePlugins = true;
              s.loadModule('AudienceManagement');
              s.doPlugins = function (appMeasurement_) {
                appMeasurement_.AudienceManagement.setup({
                  partner: 1745,
                  containerNSID: 0,
                  uuidCookie: {
                    name: 'aam_uuid',
                    days: 30
                  }
                });
                if (appMeasurement_.prop14) {
                  appMeasurement_.visitor.setCustomerIDs({
                    hasheml: {
                      id: appMeasurement_.prop14,
                      authState: 1 // Authenticated
                    }
                  });
                }
              };

              /* Adobe Consulting Plugin: handlePPVevents helper function (for getPercentPageViewed v4.0 Plugin) */
              /* eslint-disable */
              s.handlePPVevents = function () {
                if ("undefined" !== typeof s_c_il) {
                  for (var c = 0, g = s_c_il.length; c < g; c += 1) {
                    if (s_c_il[c] && (s_c_il[c].getPercentPageViewed || s_c_il[c].getPreviousPageActivity)) {
                      var s = s_c_il[c];
                      break;
                    }
                  }
                  if (s && s.ppvID) {
                    var f = document && document.body ? Math.max(Math.max(document.body.scrollHeight, document.documentElement.scrollHeight), Math.max(document.body.offsetHeight, document.documentElement.offsetHeight), Math.max(document.body.clientHeight, document.documentElement.clientHeight)) : 0,
                      h = window.innerHeight || document.documentElement.clientHeight || document.body === null || !document.body.clientHeight ? 1 : document.body.clientHeight;
                    c = (window.pageYOffset || window.document.documentElement.scrollTop || document.body === null || !document.body.scrollTop ? 0 : document.body.scrollTop) + h;
                    g = Math.min(Math.round(c / f * 100), 100);
                    var k = Math.floor(c / h);
                    h = Math.floor(f / h);
                    var d = "";
                    if (!s.c_r("s_tp") || s.unescape(s.c_r("s_ppv").split(",")[0]) !== s.ppvID || s.p_fo(s.ppvID) || 1 == s.ppvChange && s.c_r("s_tp") && f != s.c_r("s_tp")) {
                      (s.unescape(s.c_r("s_ppv").split(",")[0]) !== s.ppvID || s.p_fo(s.ppvID + "1")) && s.c_w("s_ips", c);
                      if (s.c_r("s_tp") && s.unescape(s.c_r("s_ppv").split(",")[0]) === s.ppvID) {
                        s.c_r("s_tp");
                        d = s.c_r("s_ppv");
                        var e = -1 < d.indexOf(",") ? d.split(",") : [];
                        d = e[0] ? e[0] : "";
                        e = e[3] ? e[3] : "";
                        var l = s.c_r("s_ips");
                        d = d + "," + Math.round(e / f * 100) + "," + Math.round(l / f * 100) + "," + e + "," + k;
                      }
                      s.c_w("s_tp", f);
                    } else {
                      d = s.c_r("s_ppv");
                    }
                    var b = d && -1 < d.indexOf(",") ? d.split(",", 6) : [];
                    f = 0 < b.length ? b[0] : escape(s.ppvID);
                    e = 1 < b.length ? parseInt(b[1]) : g;
                    l = 2 < b.length ? parseInt(b[2]) : g;
                    var m = 3 < b.length ? parseInt(b[3]) : c,
                      n = 4 < b.length ? parseInt(b[4]) : k;
                    b = 5 < b.length ? parseInt(b[5]) : h;
                    0 < g && (d = f + "," + (g > e ? g : e) + "," + l + "," + (c > m ? c : m) + "," + (k > n ? k : n) + "," + (h > b ? h : b));
                    s.c_w("s_ppv", d);
                  }
                }
              };

              /* Adobe Consulting Plugin: p_fo (pageFirstOnly) v2.0 */
              /* eslint-disable */
              s.p_fo = function (on) {
                var s = this;
                s.__fo || (s.__fo = {});
                if (s.__fo[on]) return !1;
                s.__fo[on] = {};
                return !0;
              };

              /* Adobe Consulting Plugin: getPercentPageViewed v4.0 w/handlePPVevents helper function (Requires p_fo plug-in) */
              /* eslint-disable */
              s.getPercentPageViewed = function (pid, ch) {
                var s = this,
                  a = s.c_r("s_ppv");
                a = -1 < a.indexOf(",") ? a.split(",") : [];
                a[0] = s.unescape(a[0]);
                pid = pid ? pid : s.pageName ? s.pageName : document.location.href;
                s.ppvChange = "undefined" === typeof ch || !0 == ch ? !0 : !1;
                if ("undefined" === typeof s.linkType || "o" !== s.linkType) s.ppvID && s.ppvID === pid || (s.ppvID = pid, s.c_w("s_ppv", ""), s.handlePPVevents()), s.p_fo("s_gppvLoad") && window.addEventListener && (window.addEventListener("load", s.handlePPVevents, !1), window.addEventListener("click", s.handlePPVevents, !1), window.addEventListener("scroll", s.handlePPVevents, !1)), s._ppvPreviousPage = a[0] ? a[0] : "", s._ppvHighestPercentViewed = a[1] ? a[1] : "", s._ppvInitialPercentViewed = a[2] ? a[2] : "", s._ppvHighestPixelsSeen = a[3] ? a[3] : "", s._ppvFoldsSeen = a[4] ? a[4] : "", s._ppvFoldsAvailable = a[5] ? a[5] : "";
              };

              /*
               * Plugin: getPreviousValue_v1.0 - return previous value of designated
               *   variable (requires split utility)
               */
              s.getPreviousValue = new Function('v', 'c', 'el', '' // eslint-disable-line no-new-func
              + 'var s=this,t=new Date,i,j,r=\'\';t.setTime(t.getTime()+1800000);if(el' + '){if(s.events){i=s.split(el,\',\');j=s.split(s.events,\',\');for(x in i' + '){for(y in j){if(i[x]==j[y]){if(s.c_r(c)) r=s.c_r(c);v?s.c_w(c,v,t)' + ':s.c_w(c,\'no value\',t);return r}}}}}else{if(s.c_r(c)) r=s.c_r(c);v?' + 's.c_w(c,v,t):s.c_w(c,\'no value\',t);return r}');
              resolve(s);
            } catch (err) {
              reject(err);
            }
          });
        };
        if (typeof window.s_gi === 'undefined') {
          try {
            appMeasurementPatched.importScript();
            onAppMeasurementApiReady();
          } catch (err) {
            reject(err);
          }
        } else {
          onAppMeasurementApiReady();
        }
      });
    }
    return appMeasurement;
  }

  /***/
}), (/* 6 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  };
  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }
    return obj;
  }
  function searchPageIdentity(payload) {
    var pageIdentitySchema = '';
    payload.forEach(function (microMessage) {
      if (microMessage.schemaName === 'pageIdentity') {
        pageIdentitySchema = microMessage;
      }
    });
    return pageIdentitySchema;
  }
  function mergeAdobePayloads(intoThisObject, fromThisObject) {
    mergeAdobeEvents(fromThisObject, intoThisObject);
    mergeObjects(intoThisObject, fromThisObject);
  }
  function mergeAdobeEvents(intoThisObject, fromThisObject) {
    if (fromThisObject && fromThisObject.events) {
      if (!intoThisObject.events) {
        intoThisObject.events = fromThisObject.events;
        return;
      }
      var fromEventArray = fromThisObject.events.split(',');
      fromEventArray.forEach(function (event) {
        if (intoThisObject.events.indexOf(event) < 0) {
          intoThisObject.events += ',' + event;
        }
      });
    }
  }
  function mergeObjects(intoThisObject, fromThisObject) {
    if (fromThisObject) {
      Object.keys(fromThisObject).forEach(function (key) {
        intoThisObject[key] = fromThisObject[key];
      });
    }
    return intoThisObject;
  }
  function isObject(item) {
    return item && (typeof item === 'undefined' ? 'undefined' : _typeof(item)) === 'object' && !Array.isArray(item);
  }
  function mergeObjectsDeep(target) {
    for (var _len = arguments.length, sources = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      sources[_key - 1] = arguments[_key];
    }
    if (!sources.length) return target;
    var source = sources.shift();
    if (isObject(target) && isObject(source)) {
      Object.keys(source).forEach(function (key) {
        if (isObject(source[key])) {
          if (!target[key]) {
            Object.assign(target, _defineProperty({}, key, {}));
          }
          mergeObjectsDeep(target[key], source[key]);
        } else {
          Object.assign(target, _defineProperty({}, key, source[key]));
        }
      });
    }
    return mergeObjectsDeep.apply(undefined, [target].concat(sources));
  }
  module.exports = {
    searchPageIdentity: searchPageIdentity,
    mergeObjects: mergeObjects,
    mergeObjectsDeep: mergeObjectsDeep,
    mergeAdobeEvents: mergeAdobeEvents,
    mergeAdobePayloads: mergeAdobePayloads
  };

  /***/
}), (/* 7 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  module.exports = {
    ADOBE_MARKETING_CLOUD_ORGANIZATION_ID: 'C00802BE5330A8350A490D4C@AdobeOrg',
    OMNITURE_TRACKING_SERVER: 'om.expedia.com',
    OMNITURE_TRACKING_SERVER_SECURE: 'oms.expedia.com',
    TRACK_API_URL: '/api/uisprime/track',
    TRACK_API_URL_CROSS_SITE: 'https://wwwexpediacom.trunk.sb.karmalab.net/api/uisprime/track'
  };

  /***/
}), (/* 8 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }
    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();
  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  var PerformanceMetrics = __webpack_require__(9);
  var ClientLogging = __webpack_require__(10);
  var loadVisitorApi = __webpack_require__(4);
  var logger = __webpack_require__(1);
  var _require = __webpack_require__(16),
    UisPrime = _require.UisPrime;
  var appMeasurementLoader = __webpack_require__(5);
  var util = __webpack_require__(6);
  var ContextualInfo = __webpack_require__(28);
  var ctxUtil = __webpack_require__(29);
  var marketingInjecter = __webpack_require__(30);
  var instance = void 0;

  /**
   * Start loading Visitor Api as soon as the library is loaded
   */
  try {
    loadVisitorApi.load();
  } catch (err) {
    console.log(err);
  }
  var PlatformAnalytics = function () {
    function PlatformAnalytics() {
      var _this = this;
      var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        overridenMicroMessages: [],
        deviceUserAgentId: undefined,
        isPwa: false,
        isPublishWebVitals: false,
        // if this is set to true, Adobe PageView is not sent when calling publishClientSidePayload
        isAutomaticAdobePageViewDisabled: false,
        additionalHeaders: {}
      };
      _classCallCheck(this, PlatformAnalytics);
      this._ctx = ctxUtil.createContextualInfo(config);
      this.analyticsPayload = [];
      try {
        if (instance) {
          PerformanceMetrics.reset();
          this._ctx.isClientSidePageLoad = true;
        }
      } catch (err) {
        console.error('PlatformAnalyticsPrime: Got this Error while resetting Performance metrics  ' + err);
      }
      this.pm = PerformanceMetrics;
      this.cl = new ClientLogging({
        debugLogger: logger.toLogStore,
        pageName: this._ctx.pageName,
        guid: this._ctx.deviceId
      });
      this.isDebugEnabled = false;
      instance = this;
      PerformanceMetrics.setPlatformAnalyticsClass(PlatformAnalytics, config);
      this._hasCollectedEveryAnalyticsPayloads = new Promise(function (resolve) {
        _this._resolveHasCollectedEveryAnalyticsPayloads = resolve;
      });

      // cross-site click events don't need to wait for a collect() before firing
      if (this._ctx.isCrossSite) {
        this._resolveHasCollectedEveryAnalyticsPayloads();
      }

      /*
       * Following three variables: pageName, overridenMicroMessages, overridePageSchema are deprecated.
       * These are only kept for backward compatibility.
       */
      this.pageName = this.context.pageName;
      this.overridenMicroMessages = this._ctx.overridenMicroMessages;
      this.overridePageSchema = util.searchPageIdentity(this.overridenMicroMessages);
    }

    /**
     *
     * Usage of collect() to collect client side payload has been deprecated now.
     * @deprecated since version [1.2.4].
     * @param {publishClientSidePayload} replacementFunction
     * @param {collect} oldFnName
     */

    _createClass(PlatformAnalytics, [{
      key: 'collect',
      value: function collect(payload) {
        try {
          if (!this._ctx.pageName || this._ctx.pageName === ctxUtil.UNSPECIFIED) {
            var pageName = ctxUtil.updatePageName(this, payload);
            this.getClientLog().setConfiguration({
              pageName: pageName
            });
          }
          if (this.analyticsPayload.length === 0) {
            ctxUtil.updateContextualInfoWithFirstPayload(this._ctx, payload);
          }
          marketingInjecter.injectMarketingData(payload, this._ctx.isClientSidePageLoad);
          this.analyticsPayload.push(payload);
          this._resolveHasCollectedEveryAnalyticsPayloads();
          if (typeof payload.debug !== 'undefined') {
            setDebugEnabled(this, true);
            marketingInjecter.updateDebugData(payload);
            logger.toLogStore(payload.debug, 'papj', 'load', this._ctx.pageName, this.isDebugEnabled);
          }
          this.fireAmcvBeaconWithTraceId(payload);
        } catch (err) {
          console.log('PlatformAnalyticsPrime: Error while collecting payload ' + err);
          logger.logError(err, 'Error while collecting payload');
        }
      }
    }, {
      key: 'fireAmcvBeaconWithTraceId',
      value: function fireAmcvBeaconWithTraceId(payload) {
        var _this2 = this;
        this.payload = payload;
        return loadVisitorApi.load().then(function () {
          if (_this2.payload) {
            loadVisitorApi.initVisitorAPI(_this2.payload.traceId);
          }
        });
      }

      /**
       * Wrapper function for calling markPageUsable.This will send the page usable metrics to /trackPrime
       */
    }, {
      key: 'markPageUsable',
      value: function markPageUsable() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
          microMessages: [],
          callback: function callback() {}
        };
        var microMessages = (options || {}).microMessages || [];
        var noop = function noop() {};
        var callback = (options || {}).callback || noop;
        if (typeof callback !== 'function') {
          console.error('[PlatformAnalyticsPrime] callback argument is not a function');
        }
        this.pm.markPageUsable({
          microMessages: microMessages,
          callback: callback
        });
      }

      /**
       * Wrapper function for calling performanceMetrics.publishWebVitals.
       * This will measure web-vitals perf metrics with {@link https://web.dev/vitals/ |web-vitals library}
       * and sends the metrics to UIS Prime
       */
    }, {
      key: 'publishWebVitals',
      value: function publishWebVitals() {
        this.pm.publishWebVitals();
      }

      /**
       * Usage of publish() to publish client side payload has been deprecated now.
       * Publish view event of collected schema
       * @deprecated since version [1.2.4].
       * @param {publishClientSidePayload} replacementFunction
       * @param {publish} oldFnName
       */
    }, {
      key: 'publish',
      value: function publish() {
        var _this3 = this;
        try {
          if (this.analyticsPayload.length === 0) {
            throw new Error('PlatformAnalyticsPrime: Collect analytics payload before publish');
          }
          if (this._ctx.hasPub) {
            var err = new Error('PlatformAnalyticsPrime: Data is already published on this platform analytics ' + 'instance. Publishing again with the same instance indicates an error in the implementation.');
            this.getClientLog().logError(err);
          }
          this._ctx.hasPub = true;
          return appMeasurementLoader.load().then(function () {
            new UisPrime({
              context: _this3._ctx,
              isDebugEnabled: _this3.isDebugEnabled
            }).publish(_this3.analyticsPayload);
            _this3.analyticsPayload = [];
            return true;
          });
        } catch (e) {
          console.error('PlatformAnalyticsPrime: Got this Error while publishing view event  ' + e);
          return false;
        }
      }

      /**
       *
       * @param payloads a rest parameter to pass clientSidePayload, it could be single payload or array of payloads
       * @returns {*} Promise
       */
    }, {
      key: 'publishClientSidePayload',
      value: function publishClientSidePayload() {
        var _this4 = this;
        try {
          for (var _len = arguments.length, payloads = Array(_len), _key = 0; _key < _len; _key++) {
            payloads[_key] = arguments[_key];
          }
          if (payloads.length === 0) {
            return Promise.reject(this.getClientLog().logError(new Error('PlatformAnalyticsPrime: No data to publish')));
          }
          var flatPayloads = payloads.reduce(function (accumulator, value) {
            return accumulator.concat(value);
          }, []);
          flatPayloads.forEach(function (payload) {
            _this4.collect(payload);
          });
          return this.publish();
        } catch (e) {
          return Promise.reject(this.getClientLog().logError(new Error('PlatformAnalyticsPrime: Got this Error while publishing view event  ' + e)));
        }
      }

      /**
       *
       * @param params an object with the following optional keys:
       *        microMessages: Array of schema in case user has more than one to publish
       */
    }, {
      key: 'trackEvent',
      value: function trackEvent() {
        var _this5 = this;
        var microMessages = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        var eventType = arguments[1];
        try {
          if (!(microMessages instanceof Array)) {
            microMessages = [microMessages];
          }
          return Promise.all([this._hasCollectedEveryAnalyticsPayloads, appMeasurementLoader.load()]).then(function () {
            new UisPrime({
              context: _this5._ctx,
              isDebugEnabled: _this5.isDebugEnabled
            }).trackEvent(microMessages, eventType);
          });
        } catch (e) {
          this.getClientLog().logError(new Error('PlatformAnalytics: Got this Error while publishing track event  ' + e));
          return false;
        }
      }

      /**
       * Track a payload of UIS Prime micro messages and send the adobe mapped payload of it to Adobe.
       * All information that is going to be tracked and mapped to Adobe props must be present in the input of this function.
       * Since no CGP entry is available for this kind of tracking, these messages won't be available server side, but are mapped back to the client side
       * to the Adobe format, and then get published.
       *
       * The platform data expected here to be in the list of micro messages produced instead of extraction from CGP entry, where it applies:
       *
       *    https://github.expedia.biz/Brand-Expedia/uis-prime-schemas/blob/master/schemas/micro/platform/executionContext.json
       *    https://github.expedia.biz/Brand-Expedia/uis-prime-schemas/blob/master/schemas/micro/platform/deviceCharacteristics.json
       *    https://github.expedia.biz/Brand-Expedia/uis-prime-schemas/blob/master/schemas/micro/platform/site.json
       *    https://github.expedia.biz/Brand-Expedia/uis-prime-schemas/blob/master/schemas/micro/platform/pageIdentity.json
       *    https://github.expedia.biz/Brand-Expedia/uis-prime-schemas/blob/master/schemas/micro/platform/privacyContext.json
       *    https://github.expedia.biz/Brand-Expedia/uis-prime-schemas/blob/master/schemas/micro/platform/geoLocation.json
       *
       * @params fullPageViewPayload.microMessages the micro messages to be published.
       *         A microMessage is expected to have a string 'schemaName', and an object 'messageContent' which is the message itself.
       *
       * */
    }, {
      key: 'trackAndPublishToAdobe',
      value: function trackAndPublishToAdobe(fullPageViewPayload) {
        try {
          var microMessages = fullPageViewPayload.microMessages;
          var traceIdOfTheView = this._ctx.traceIdOfTheView;
          var doWeHaveTraceId = this._ctx.traceIdOfTheView !== undefined;
          var applicationName = this._ctx.applicationName;
          var doWeHaveApplicationName = this._ctx.applicationName !== undefined;
          if (!doWeHaveApplicationName || !doWeHaveTraceId || microMessages === undefined) {
            var error = new Error('PlatformAnalyticsPrime: missing input for trackAndPublishToAdobe ' + {
              traceIdOfTheView: traceIdOfTheView,
              applicationName: applicationName
            });
            this.getClientLog().logError(error);
            return Promise.reject(error);
          }
          var uisPrime = new UisPrime({
            context: this._ctx,
            isDebugEnabled: this.isDebugEnabled
          });
          return uisPrime.trackPageViewAndPublishToAdobe(fullPageViewPayload);
        } catch (error) {
          this.getClientLog().logError(new Error('PlatformAnalytics: Error at trackAndPublishToAdobe: ' + error));
          return Promise.reject(error);
        }
      }

      // eslint-disable-next-line class-methods-use-this
    }, {
      key: 'appendCrossDomainTrackingTo',
      value: function appendCrossDomainTrackingTo(destinationURL) {
        return loadVisitorApi.load().then(function (visitor) {
          return visitor.appendVisitorIDsTo(destinationURL);
        }).catch(function (err) {
          return logger.logError(err);
        });
      }
    }, {
      key: 'getPerformanceMetrics',
      value: function getPerformanceMetrics() {
        return this.pm;
      }
    }, {
      key: 'getClientLog',
      value: function getClientLog() {
        return this.cl;
      }
    }, {
      key: 'context',
      get: function get() {
        return new ContextualInfo(this);
      }
    }]);
    return PlatformAnalytics;
  }();
  function setDebugEnabled(platformAnalytics, isDebugEnabled) {
    platformAnalytics.isDebugEnabled = isDebugEnabled;
    platformAnalytics.pm.isDebugEnabled = isDebugEnabled;
    platformAnalytics.cl.setConfiguration({
      isDebugEnabled: isDebugEnabled
    });
  }

  /**
   * This is a synonym for the constructor and you should use the constructor in preference to this method. It's being
   * left here because Platform Analytics Prime is a fork of DCTK 3.0 and DCTK 3.0 apps used to use `newInstance`.
   *
   * @param config the constructor arguments to pass on
   * @returns {PlatformAnalytics} the result of `new PlatformAnalytics(config)`
   * @deprecated just use the constructor `new PlatformAnalytics(config)` instead
   */
  function newInstance() {
    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      overridenMicroMessages: [],
      deviceUserAgentId: undefined
    };
    return new PlatformAnalytics(config);
  }

  /**
   * Returns the last created instance of PlatformAnalytics which is useful when you want to capture analytics but you're
   * not responsible for the page load cycle. For example Global Controls has click tracking but does not own the page it
   * is running on. It uses getInstance() in
   * https://ewegithub.sb.karmalab.net/EWE/globalcontrols-content/blob/master/src/main/resources/static/js/util/analyticsStore.js
   * so that clicks can be attributed back to the page which GC is running on.
   *
   * @returns {PlatformAnalytics} the last created instance of PlatformAnalytics
   */
  function getInstance() {
    return instance;
  }
  PlatformAnalytics.newInstance = newInstance;
  PlatformAnalytics.getInstance = getInstance;
  module.exports = PlatformAnalytics;

  /***/
}), (/* 9 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }
    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();
  var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  };
  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  module.exports = /******/function (modules) {
    // webpackBootstrap
    /******/ // The module cache
    /******/
    var installedModules = {};
    /******/
    /******/ // The require function
    /******/
    function __webpack_require__(moduleId) {
      /******/
      /******/ // Check if module is in cache
      /******/if (installedModules[moduleId]) {
        /******/return installedModules[moduleId].exports;
        /******/
      }
      /******/ // Create a new module (and put it into the cache)
      /******/
      var module = installedModules[moduleId] = {
        /******/i: moduleId,
        /******/l: false,
        /******/exports: {}
        /******/
      };
      /******/
      /******/ // Execute the module function
      /******/
      modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
      /******/
      /******/ // Flag the module as loaded
      /******/
      module.l = true;
      /******/
      /******/ // Return the exports of the module
      /******/
      return module.exports;
      /******/
    }
    /******/
    /******/
    /******/ // expose the modules object (__webpack_modules__)
    /******/
    __webpack_require__.m = modules;
    /******/
    /******/ // expose the module cache
    /******/
    __webpack_require__.c = installedModules;
    /******/
    /******/ // define getter function for harmony exports
    /******/
    __webpack_require__.d = function (exports, name, getter) {
      /******/if (!__webpack_require__.o(exports, name)) {
        /******/Object.defineProperty(exports, name, {
          /******/configurable: false,
          /******/enumerable: true,
          /******/get: getter
          /******/
        });
        /******/
      }
      /******/
    };
    /******/
    /******/ // getDefaultExport function for compatibility with non-harmony modules
    /******/
    __webpack_require__.n = function (module) {
      /******/var getter = module && module.__esModule ? /******/function getDefault() {
        return module['default'];
      } : /******/function getModuleExports() {
        return module;
      };
      /******/
      __webpack_require__.d(getter, 'a', getter);
      /******/
      return getter;
      /******/
    };
    /******/
    /******/ // Object.prototype.hasOwnProperty.call
    /******/
    __webpack_require__.o = function (object, property) {
      return Object.prototype.hasOwnProperty.call(object, property);
    };
    /******/
    /******/ // __webpack_public_path__
    /******/
    __webpack_require__.p = "";
    /******/
    /******/ // Load entry module and return exports
    /******/
    return __webpack_require__(__webpack_require__.s = 4);
    /******/
  }(/************************************************************************/
  /******/[/* 0 */
  /***/function (module, exports) {
    var g;

    // This works in non-strict mode
    g = function () {
      return this;
    }();
    try {
      // This works if eval is allowed (see CSP)
      g = g || Function("return this")() || (1, eval)("this");
    } catch (e) {
      // This works if the window reference is available
      if ((typeof window === 'undefined' ? 'undefined' : _typeof(window)) === "object") g = window;
    }

    // g can still be undefined, but nothing to do about it...
    // We return undefined, instead of nothing here, so it's
    // easier to handle this case. if(!global) { ...}

    module.exports = g;

    /***/
  }, /* 1 */
  /***/function (module, exports, __webpack_require__) {
    /* WEBPACK VAR INJECTION */(function (global) {
      var PERFORMANCE = function () {
        var performance = window.performance;
        var navigationStart = ((performance || {}).timing || {}).navigationStart || getCurrentTimestamp();
        function getGaMarks() {
          if (typeof global.gaMarks === 'undefined') {
            global.gaMarks = [];
          }
          return global.gaMarks;
        }
        function getGaMeasures() {
          if (typeof global.gaMeasures === 'undefined') {
            global.gaMeasures = [];
          }
          return global.gaMeasures;
        }
        function timeSinceNavigationStart() {
          return typeof (window && window.performance || {}).now === 'function' ? performance.now() : getCurrentTimestamp() - navigationStart;
        }
        function mark(name) {
          if (typeof (performance || {}).mark === 'function') {
            performance.mark(name);
          } else if (typeof (performance || {}).webkitMark === 'function') {
            performance.webkitMark(name);
          } else {
            getGaMarks().push({
              name: name,
              entryType: 'mark',
              startTime: timeSinceNavigationStart(),
              duration: 0
            });
          }
        }
        function findMark(markName) {
          return findSpecificRow(getMarkEntries(), markName);
        }
        function findSpecificRow(OrigArr, markName) {
          var filteredArray = OrigArr.filter(function (sRow) {
            return sRow.name === markName;
          });
          return filteredArray.length > 0 ? filteredArray[0] : undefined;
        }
        function findMeasure(measureName) {
          return findSpecificRow(getMeasureEntries(), measureName);
        }
        function measure(name, startMarkName, endMarkName) {
          if (typeof (performance || {}).measure === 'function') {
            performance.measure(name, startMarkName, endMarkName);
          } else if (typeof (performance || {}).webkitMeasure === 'function') {
            performance.webkitMeasure(name, startMarkName, endMarkName);
          } else {
            var startMarkTime = 0;
            var endMarkTime = timeSinceNavigationStart();
            if (startMarkName) {
              var startMark = findMark(startMarkName);
              if (startMark) {
                startMarkTime = startMark.startTime;
              } else if (((performance || {}).timing || {})[startMarkName]) {
                startMarkTime = performance.timing[startMarkName] - performance.timing.navigationStart;
              }
            }
            if (endMarkName) {
              var endMark = findMark(endMarkName);
              if (endMark) {
                endMarkTime = endMark.startTime;
              } else if (((performance || {}).timing || {})[endMarkName]) {
                endMarkTime = performance.timing[endMarkName] - performance.timing.navigationStart;
              }
            }
            getGaMeasures().push({
              name: name,
              entryType: 'measure',
              startTime: startMarkTime,
              duration: endMarkTime - startMarkTime
            });
          }
        }
        function getMeasureEntries() {
          if (typeof (performance || {}).getEntriesByType === 'function') {
            return performance.getEntriesByType('measure');
          } else if (typeof (performance || {}).webkitGetEntriesByType === 'function') {
            return performance.webkitGetEntriesByType('measure');
          }
          return getGaMeasures();
        }
        function getMarkEntries() {
          if (typeof (performance || {}).getEntriesByType === 'function') {
            return performance.getEntriesByType('mark');
          } else if (typeof (performance || {}).webkitGetEntriesByType === 'function') {
            return performance.webkitGetEntriesByType('mark');
          }
          return getGaMarks();
        }
        function getEntriesByName(name) {
          if (typeof (performance || {}).getEntriesByName === 'function') {
            return performance.getEntriesByName(name);
          } else if (typeof (performance || {}).webkitGetEntriesByName === 'function') {
            return performance.webkitGetEntriesByName(name);
          }
          return [];
        }
        function clearMarks(markName) {
          if (typeof (performance || {}).clearMarks === 'function') {
            performance.clearMarks(markName);
          } else {
            global.gaMarks = getMarkEntries().filter(function (markEntry) {
              return markEntry.name !== markName;
            });
          }
        }
        function toJSON() {
          if (typeof (performance || {}).toJSON === 'function') {
            return performance.toJSON();
          }
          var timing = (performance || {}).timing || {};
          return {
            timing: timing
          };
        }
        return {
          mark: mark,
          measure: measure,
          getGaMarks: getGaMarks,
          getGaMeasures: getGaMeasures,
          getEntriesByName: getEntriesByName,
          findMark: findMark,
          findMeasure: findMeasure,
          clearMarks: clearMarks,
          findSpecificRow: findSpecificRow,
          toJSON: toJSON
        };
      }();
      module.exports = PERFORMANCE;
      function getCurrentTimestamp() {
        return typeof Date.now === 'function' ? Date.now() : Number(new Date());
      }

      /* WEBPACK VAR INJECTION */
    }).call(exports, __webpack_require__(0));

    /***/
  }, /* 2 */
  /***/function (module, exports, __webpack_require__) {
    /* WEBPACK VAR INJECTION */(function (global) {
      /* eslint-disable no-useless-escape */
      var env = __webpack_require__(3);
      function log(message) {
        if (env.isTestEnvironment()) {
          console.log(message);
        }
      }
      function toLogStore(message) {
        try {
          if (env.isTestEnvironment() || isEnabledWithCookie('paLogStore=true')) {
            if (!isLogStoreDefined()) {
              global.paLogStore = [];
              global.paLogStoreSize = 100;
            }
            global.paLogStore.push(message);
            if (global.paLogStore.length > global.paLogStoreSize) {
              global.paLogStore.shift();
            }
          }
        } catch (err) {
          log(err);
        }
      }
      function isLogStoreDefined() {
        return global && global.paLogStore && Array.isArray(global.paLogStore);
      }
      function isEnabledWithCookie(cookie) {
        if (typeof document === 'undefined' || typeof document.cookie === 'undefined') {
          return false;
        }
        return document.cookie.indexOf(cookie) !== -1;
      }
      module.exports = {
        toLogStore: toLogStore,
        log: log
      };

      /* WEBPACK VAR INJECTION */
    }).call(exports, __webpack_require__(0));

    /***/
  }, /* 3 */
  /***/function (module, exports, __webpack_require__) {
    /* WEBPACK VAR INJECTION */(function (process) {
      var TEST_ENVIRONMENT_REGEX = /(?:(?:test|int|stress)\.expedia\.com|exp-(?:test|int)\.net|karmalab\.net|expedmz.com|staging.*\.(?:traveltainment\.de|myersmediagroup\.com)|localhost|docweb\.exp-tools\.net)$/i; // eslint-disable-line max-len

      function isTestEnvironment() {
        var isTestEnv = false;
        if (isBrowser() && typeof location !== 'undefined') {
          isTestEnv = Boolean(location.hostname.match(TEST_ENVIRONMENT_REGEX));
        } else {
          isTestEnv = ['prod', 'production'].indexOf(process.env.NODE_ENV) === -1;
        }
        return isTestEnv;
      }
      function isLocalEnvironment() {
        if (typeof location !== 'undefined') {
          return location.hostname === 'localhost';
        }
        return false;
      }
      var isPerformanceTimingSupported = function isPerformanceTimingSupported() {
        return isPerformanceSupported() && window.performance.timing && typeof window.performance.timing.navigationStart !== 'undefined';
      };
      var isPerformanceMarkSupported = function isPerformanceMarkSupported() {
        return isPerformanceSupported() && (typeof window.performance.mark === 'function' || typeof window.performance.webkitMark === 'function');
      };
      function isBrowser() {
        return typeof window !== 'undefined';
      }
      function isPerformanceSupported() {
        return isBrowser() && window.performance;
      }
      module.exports = {
        isTestEnvironment: isTestEnvironment,
        isLocalEnvironment: isLocalEnvironment,
        isBrowser: isBrowser,
        isPerformanceTimingSupported: isPerformanceTimingSupported,
        isPerformanceMarkSupported: isPerformanceMarkSupported,
        isTrackingDisabled: function isTrackingDisabled() {
          return isBrowser() && navigator && navigator.doNotTrack === '1';
        },
        isBeaconSupported: function isBeaconSupported() {
          return isBrowser() && navigator && typeof navigator.sendBeacon === 'function';
        }
      };

      /* WEBPACK VAR INJECTION */
    }).call(exports, __webpack_require__(18));

    /***/
  }, /* 4 */
  /***/function (module, exports, __webpack_require__) {
    /* eslint-disable no-plusplus,no-prototype-builtins */
    var PerformanceMetrics = __webpack_require__(5);
    module.exports = new PerformanceMetrics();

    /***/
  }, /* 5 */
  /***/function (module, exports, __webpack_require__) {
    /* WEBPACK VAR INJECTION */(function (global) {
      /* eslint-disable no-plusplus,no-prototype-builtins */
      var uisPrimePublisher = __webpack_require__(6);
      var performanceShim = __webpack_require__(1);
      var pmPublisher = __webpack_require__(17);
      var PAGE_USABLE_MARK_NAME = 'Page Usable';
      var PAGE_CHANGE_MARK_NAME = 'Page Change';
      var metricsFields = ['deviceId', 'siteId', 'requestId', 'pageName', 'additionalData'];
      function publishPageUsable(context, pageUsableTime) {
        var contextCopy = {};
        safeCopyContext(context, contextCopy);
        contextCopy.pageUsableTime = pageUsableTime;
        pmPublisher.publish(contextCopy);
      }
      function safeCopyContext(src, dest) {
        if (src) {
          metricsFields.forEach(function (field) {
            if (src.hasOwnProperty(field)) {
              if (field === 'siteId' && isNaN(src[field])) {
                console.log('WARNING: siteId must be Integer!');
              } else {
                dest[field] = src[field];
              }
            }
          });
        }
      }
      function getSiteId() {
        if (!isNaN(global.siteid)) {
          return global.siteid;
        }
        if (!isNaN(global.site_id)) {
          return global.site_id;
        }
        if (!isNaN(global.siteId)) {
          return global.siteId;
        }
        return NaN;
      }
      var PerformanceMetrics = function () {
        function PerformanceMetrics() {
          var _this = this;
          var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          _classCallCheck(this, PerformanceMetrics);
          this.ctx = {};
          this.waitingMessage = {};
          this.setContext(context);
          this.findMark = function (markName) {
            return performanceShim.findMark(markName);
          };
          this.findMeasure = function (measureName) {
            return performanceShim.findMeasure(measureName);
          };
          this.clearMarks = function (markName) {
            return performanceShim.clearMarks(markName);
          };
          this.mark = function (markName) {
            return performanceShim.mark(markName);
          };
          this.measure = function (name, startMark, endMark) {
            return performanceShim.measure(name, startMark, endMark);
          };
          this.pul = function (listener, scope) {
            if (typeof _this.puListener !== 'undefined') {
              console.log('PageUsableListener has already been initialized');
              return;
            }
            _this.puListener = listener;
            _this.puScope = scope;
          };
        }
        _createClass(PerformanceMetrics, [{
          key: 'setContext',
          value: function setContext(context) {
            safeCopyContext(context, this.ctx);
          }
        }, {
          key: 'getFilteredPageUsableTime',
          value: function getFilteredPageUsableTime() {
            var pageUsableTime = this.getPageUsableTime();
            if (pageUsableTime && pageUsableTime.length > 0) {
              // DCTK2.0 returns array of PerformanceMark
              pageUsableTime = parseFloat((pageUsableTime[0].startTime / 1000).toFixed(2));
            }
            return pageUsableTime;
          }
        }, {
          key: 'justMarkPageUsable',
          value: function justMarkPageUsable() {
            var _this2 = this;
            var callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {};
            var primeOptions = arguments[1];

            // TODO long term solution here for primeJs would be to remove callback
            // and keep only primeOptions. Keeping it until dctk3 is alive but new adopters
            // should already be able to pass primeOptions instead of callback
            if (primeOptions || callback && (callback.callback || callback.microMessages)) {
              // Uis Prime path
              this.microMessages = (callback || {}).microMessages || primeOptions.microMessages;
              callback = (callback || {}).callback || primeOptions.callback;
            }
            // use setTimeout for more accurate mark (it delays the mark until the more cpu consuming threads finished to operate which proved to be the moment the page ends rendering)
            setTimeout(function () {
              if (!_this2.findMark(PAGE_USABLE_MARK_NAME)) {
                _this2.clearMarks(PAGE_USABLE_MARK_NAME);
                _this2.mark(PAGE_USABLE_MARK_NAME);
              } else {
                console.log("WARNING: marking a page that was already usable - value won't be updated - use reset() first");
              }
              var pageUsableTime = _this2.getFilteredPageUsableTime();
              if (typeof _this2.puListener === 'function') {
                _this2.puListener.call(_this2.puScope, pageUsableTime);
              }
              if (typeof callback === 'function') {
                callback(pageUsableTime, _this2.ctx);
              }
            }, 50);
          }
        }, {
          key: 'publish',
          value: function publish(context) {
            var pageUsableTime = (context || {}).pageUsableTime || this.getFilteredPageUsableTime();
            var microMessages = (context || {}).microMessages || [];
            if (this.PlatformAnalytics && typeof this.PlatformAnalytics.getInstance === 'function' && this.PlatformAnalytics.getInstance()) {
              uisPrimePublisher.publishPageUsableToUisPrime(this.PlatformAnalytics.getInstance(), microMessages, pageUsableTime);
              this.waitingMessage = {};
            } else if (context && context.uisPrime) {
              this.waitingMessage = {
                uisPrime: true,
                microMessages: microMessages,
                pageUsableTime: pageUsableTime
              };
            } else {
              // DCTK3 Path
              this.setContext(context);
              if (this.findMark(PAGE_USABLE_MARK_NAME)) {
                try {
                  publishPageUsable(this.ctx, this.getFilteredPageUsableTime());
                } catch (err) {
                  console.log('Unable to publish performance metrics' + err.message);
                }
              } else {
                console.log('WARNING: trying to publish before page being usable');
              }
            }
          }
        }, {
          key: 'markPageUsable',
          value: function markPageUsable() {
            var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            var _this3 = this;
            var _callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};
            var primeOptions = arguments[2];

            // TODO long term solution here for primeJs would be to remove context and callback
            // and keep only primeOptions. Keeping them until dctk3 is alive but new adopters
            // should already be able to pass primeOptions instead of context
            if (primeOptions || context.microMessages || context.callback) {
              // UisPrime path
              var microMessages = context.microMessages || (primeOptions || {}).microMessages;
              _callback = context.callback || (primeOptions || {}).callback;
              this.justMarkPageUsable({
                microMessages: microMessages,
                callback: function callback(pageUsableTime) {
                  _this3.publish({
                    uisPrime: true,
                    microMessages: microMessages
                  });
                  _callback(pageUsableTime);
                }
              });
            } else {
              // DCTK3 path
              this.setContext(context);
              this.justMarkPageUsable(function (pageUsableTime, _context) {
                if (isNaN(_this3.ctx.siteId)) {
                  var siteId = getSiteId();
                  if (!isNaN(siteId)) {
                    _context.siteId = parseInt(siteId, 10);
                  }
                }
                _this3.publish(_context);
                if (typeof _callback === 'function') {
                  _callback(pageUsableTime, _context);
                }
              });
            }
          }
        }, {
          key: 'getPageUsableTime',
          value: function getPageUsableTime() {
            var pageUsableTime = (this.findMark(PAGE_USABLE_MARK_NAME) || {}).startTime - ((this.findMark(PAGE_CHANGE_MARK_NAME) || {}).startTime || 0);
            return Math.round(pageUsableTime * 10) / 10;
          }
        }, {
          key: 'reset',
          value: function reset(context) {
            this.setContext(context);
            this.clearMarks(PAGE_USABLE_MARK_NAME);
            this.clearMarks(PAGE_CHANGE_MARK_NAME);
            this.mark(PAGE_CHANGE_MARK_NAME);
          }
        }, {
          key: 'setPlatformAnalyticsClass',
          value: function setPlatformAnalyticsClass(PlatformAnalytics) {
            var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
              isPublishWebVitals: false
            };
            this.PlatformAnalytics = PlatformAnalytics;
            if (this.waitingMessage.pageUsableTime) {
              this.publish(this.waitingMessage);
            } else if (this.findMark(PAGE_USABLE_MARK_NAME)) {
              // page was marked as usable before knowing it was on UisPrime path
              this.publish({
                uisPrime: true
              });
            }
            uisPrimePublisher.publishInteractionMetrics(this.PlatformAnalytics.getInstance());
            if (config.isPublishWebVitals) {
              uisPrimePublisher.publishWebVitals(this.PlatformAnalytics.getInstance());
            }
          }

          /**
           * Measures web-vitals perf metrics with {@link https://web.dev/vitals/ |web-vitals library}
           * and sends the metrics to UIS Prime
           */
        }, {
          key: 'publishWebVitals',
          value: function publishWebVitals() {
            if (this.PlatformAnalytics && typeof this.PlatformAnalytics.getInstance === 'function' && this.PlatformAnalytics.getInstance()) {
              uisPrimePublisher.publishWebVitals(this.PlatformAnalytics.getInstance());
            }
          }
        }]);
        return PerformanceMetrics;
      }();
      module.exports = PerformanceMetrics;

      /* WEBPACK VAR INJECTION */
    }).call(exports, __webpack_require__(0));

    /***/
  }, /* 6 */
  /***/function (module, exports, __webpack_require__) {
    /* WEBPACK VAR INJECTION */(function (global) {
      var firstInputDelay = __webpack_require__(7);
      var timeToInteractive = __webpack_require__(9);
      var performanceShim = __webpack_require__(1);
      var ttiPolyfill = __webpack_require__(11);
      var networkTimings = __webpack_require__(12);
      var networkType = __webpack_require__(13);
      var firstContentfulPaint = __webpack_require__(14);
      var webVitalsService = __webpack_require__(15);
      var networkApi = {
        navigator: global.navigator || {}
      };
      var PAGE_USABLE_MARK_NAME = 'Page Usable';
      function publishInteractionMetrics(platformAnalytics) {
        if (platformAnalytics && typeof platformAnalytics.trackEvent === 'function') {
          var delayedPerfMetricsMicroMessage = {
            schemaName: 'interactivityMetrics',
            messageContent: {}
          };
          firstInputDelay.collect(delayedPerfMetricsMicroMessage, function (microMessageWithFirstInputDelay) {
            timeToInteractive.collect(microMessageWithFirstInputDelay, ttiPolyfill, function (microMessageWithTti) {
              if (Object.keys(microMessageWithTti.messageContent).length !== 0) {
                platformAnalytics.trackEvent(microMessageWithTti, 'page-usable');
              }
            });
          });
        } else {
          console.error('[PerformanceMetrics] cannot publish interactionMetrics to Uis Prime (platformAnalytics not defined)');
        }
      }
      function publishPageUsableToUisPrime(platformAnalytics) {
        var microMessages = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
        var pageUsableTime = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
        if (platformAnalytics && typeof platformAnalytics.trackEvent === 'function') {
          if (!Array.isArray(microMessages)) {
            microMessages = [microMessages];
          }
          var performanceMetricsMicroMessage = {
            schemaName: 'performanceMetrics',
            messageContent: {
              markName: PAGE_USABLE_MARK_NAME,
              markValue: pageUsableTime
            }
          };
          var corePerformanceMetricsMicroMessage = {
            schemaName: 'corePerformanceMetrics',
            messageContent: {
              pageUsableTime: pageUsableTime
            }
          };
          networkType.collect(performanceMetricsMicroMessage, networkApi);
          networkTimings.collect(performanceMetricsMicroMessage, performanceShim, function (microMessageWithNetTiming) {
            firstContentfulPaint.collect(microMessageWithNetTiming, performanceShim, function (microMessageWithFCP) {
              microMessages.push(microMessageWithFCP);
              platformAnalytics.trackEvent(microMessages, 'page-usable');
            });
          });
          platformAnalytics.trackEvent(corePerformanceMetricsMicroMessage, 'page-usable');
          if (performanceMetricsMicroMessage.messageContent.pageLoadTime) {
            var additionalPerformanceMetricsMicroMessage = {
              schemaName: 'additionalPerformanceMetrics',
              messageContent: {
                pageLoadTime: performanceMetricsMicroMessage.messageContent.pageLoadTime
              }
            };
            platformAnalytics.trackEvent(additionalPerformanceMetricsMicroMessage, 'timing');
          }
        } else {
          console.error('[PerformanceMetrics] cannot publish page usable to Uis Prime (platformAnalytics not defined)');
        }
      }
      function publishWebVitals(platformAnalytics) {
        if (platformAnalytics && typeof platformAnalytics.trackEvent === 'function') {
          var uisPrimePublish = webVitalsService.uisPrimeOnReport(platformAnalytics);
          webVitalsService.report(uisPrimePublish);
        } else {
          console.error('[PerformanceMetrics] cannot publish web vitals to Uis Prime (platformAnalytics not defined)');
        }
      }
      module.exports = {
        publishInteractionMetrics: publishInteractionMetrics,
        publishPageUsableToUisPrime: publishPageUsableToUisPrime,
        publishWebVitals: publishWebVitals
      };

      /* WEBPACK VAR INJECTION */
    }).call(exports, __webpack_require__(0));

    /***/
  }, /* 7 */
  /***/function (module, exports, __webpack_require__) {
    /* WEBPACK VAR INJECTION */(function (global) {
      __webpack_require__(8);
      function collect(microMessage, callback) {
        try {
          global.perfMetrics.onFirstInputDelay(function (delay) {
            if (delay) {
              microMessage.messageContent.firstInputDelay = delay;
            }
            callback(microMessage);
          });
        } catch (err) {
          // if we get here this metric is not supported by this browser
          callback(microMessage);
        }
      }
      module.exports = {
        collect: collect
      };

      /* WEBPACK VAR INJECTION */
    }).call(exports, __webpack_require__(0));

    /***/
  }, /* 8 */
  /***/function (module, exports) {
    /*
     Copyright 2018 Google Inc. All Rights Reserved.
     Licensed under the Apache License, Version 2.0 (the "License");
     you may not use this file except in compliance with the License.
     You may obtain a copy of the License at
    
         http://www.apache.org/licenses/LICENSE-2.0
    
     Unless required by applicable law or agreed to in writing, software
     distributed under the License is distributed on an "AS IS" BASIS,
     WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     See the License for the specific language governing permissions and
     limitations under the License.
    */

    (function (addEventListener, removeEventListener) {
      var firstInputEvent;
      var firstInputDelay;
      var firstInputTimeStamp;
      var callbacks = [];
      var listenerOpts = {
        passive: true,
        capture: true
      };
      var startTimeStamp = new Date();
      var pointerup = 'pointerup';
      var pointercancel = 'pointercancel';

      /**
       * Accepts a callback to be invoked once the first input delay and event
       * are known.
       * @param {!Function} callback
       */
      function onFirstInputDelay(callback) {
        callbacks.push(callback);
        reportFirstInputDelayIfRecordedAndValid();
      }

      /**
       * Records the first input delay and event, so subsequent events can be
       * ignored. All added event listeners are then removed.
       * @param {number} delay
       * @param {!Event} evt
       */
      function recordFirstInputDelay(delay, evt) {
        if (!firstInputEvent) {
          firstInputEvent = evt;
          firstInputDelay = delay;
          firstInputTimeStamp = new Date();
          eachEventType(removeEventListener);
          reportFirstInputDelayIfRecordedAndValid();
        }
      }

      /**
       * Reports the first input delay and event (if they're recorded and valid)
       * by running the array of callback functions.
       */
      function reportFirstInputDelayIfRecordedAndValid() {
        // In some cases the recorded delay is clearly wrong, e.g. it's negative
        // or it's larger than the time between now and when the page was loaded.
        // - https://github.com/GoogleChromeLabs/first-input-delay/issues/4
        // - https://github.com/GoogleChromeLabs/first-input-delay/issues/6
        // - https://github.com/GoogleChromeLabs/first-input-delay/issues/7
        if (firstInputDelay >= 0 && firstInputDelay < firstInputTimeStamp - startTimeStamp) {
          callbacks.forEach(function (callback) {
            callback(firstInputDelay, firstInputEvent);
          });
          callbacks = [];
        }
      }

      /**
       * Handles pointer down events, which are a special case.
       * Pointer events can trigger main or compositor thread behavior.
       * We differenciate these cases based on whether or not we see a
       * pointercancel event, which are fired when we scroll. If we're scrolling
       * we don't need to report input delay since FID excludes scrolling and
       * pinch/zooming.
       * @param {number} delay
       * @param {!Event} evt
       */
      function onPointerDown(delay, evt) {
        /**
         * Responds to pointerup events and records a delay. If a pointer up event
         * is the next event after a pointerdown event, then it's not a sroll or
         * a pinch/zoom.
         */
        function onPointerUp() {
          recordFirstInputDelay(delay, evt);
          removePointerEventListeners();
        }

        /**
         * Responds to pointercancel events and removes pointer listeners.
         * If a pointercancel is the next event to fire after a pointerdown event,
         * it means this is a scroll or pinch/zoom interaction.
         */
        function onPointerCancel() {
          removePointerEventListeners();
        }

        /**
         * Removes added pointer event listeners.
         */
        function removePointerEventListeners() {
          removeEventListener(pointerup, onPointerUp, listenerOpts);
          removeEventListener(pointercancel, onPointerCancel, listenerOpts);
        }
        addEventListener(pointerup, onPointerUp, listenerOpts);
        addEventListener(pointercancel, onPointerCancel, listenerOpts);
      }

      /**
       * Handles all input events and records the time between when the event
       * was received by the operating system and when it's JavaScript listeners
       * were able to run.
       * @param {!Event} evt
       */
      function onInput(evt) {
        // Only count cancelable events, which should trigger behavior
        // important to the user.
        if (evt.cancelable) {
          // In some browsers `event.timeStamp` returns a `DOMTimeStamp` value
          // (epoch time) istead of the newer `DOMHighResTimeStamp`
          // (document-origin time). To check for that we assume any timestamp
          // greater than 1 trillion is a `DOMTimeStamp`, and compare it using
          // the `Date` object rather than `performance.now()`.
          // - https://github.com/GoogleChromeLabs/first-input-delay/issues/4
          var isEpochTime = evt.timeStamp > 1e12;
          var now = isEpochTime ? new Date() : performance.now();

          // Input delay is the delta between when the system received the event
          // (e.g. evt.timeStamp) and when it could run the callback (e.g. `now`).
          var delay = now - evt.timeStamp;
          if (evt.type == 'pointerdown') {
            onPointerDown(delay, evt);
          } else {
            recordFirstInputDelay(delay, evt);
          }
        }
      }

      /**
       * Invokes the passed callback function for each event type with the
       * `onInput` function and `listenerOpts`.
       * @param {!Function} callback
       */
      function eachEventType(callback) {
        var eventTypes = ['click', 'mousedown', 'keydown', 'touchstart', 'pointerdown'];
        eventTypes.forEach(function (eventType) {
          callback(eventType, onInput, listenerOpts);
        });
      }

      // TODO(tdresser): only register touchstart/pointerdown if other
      // listeners are present.
      eachEventType(addEventListener);

      // Don't override the perfMetrics namespace if it already exists.
      self['perfMetrics'] = self['perfMetrics'] || {};
      self['perfMetrics']['onFirstInputDelay'] = onFirstInputDelay;
    })(addEventListener, removeEventListener);

    /***/
  }, /* 9 */
  /***/function (module, exports, __webpack_require__) {
    __webpack_require__(10);
    function collect(microMessage, ttiPolyfill, callback) {
      // we try to avoid the usage of promises for others metrics to be compatible with older browsers without
      // promise support but here old browsers wouldn't support this metric anyway
      try {
        ttiPolyfill.getFirstConsistentlyInteractive().then(function (tti) {
          if (tti) {
            microMessage.messageContent.timeToInteractive = tti;
          }
          callback(microMessage);
        });
      } catch (err) {
        // if we get here this metric is not supported by this browser
        callback(microMessage);
      }
    }
    module.exports = {
      collect: collect
    };

    /***/
  }, /* 10 */
  /***/function (module, exports, __webpack_require__) {
    /* WEBPACK VAR INJECTION */(function (global) {
      /* eslint-disable */
      !function () {
        if ('PerformanceLongTaskTiming' in global) {
          var g = global.__tti = {
            e: []
          };
          g.o = new PerformanceObserver(function (l) {
            g.e = g.e.concat(l.getEntries());
          });
          g.o.observe({
            entryTypes: ['longtask']
          });
        }
      }();
      /* eslint-enable */

      /* WEBPACK VAR INJECTION */
    }).call(exports, __webpack_require__(0));

    /***/
  }, /* 11 */
  /***/function (module, exports, __webpack_require__) {
    /* WEBPACK VAR INJECTION */(function (global) {
      var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
      (function () {
        var h = "undefined" != typeof window && window === this ? this : "undefined" != typeof global && null != global ? global : this,
          k = "function" == typeof Object.defineProperties ? Object.defineProperty : function (a, b, c) {
            a != Array.prototype && a != Object.prototype && (a[b] = c.value);
          };
        function l() {
          l = function l() {};
          h.Symbol || (h.Symbol = m);
        }
        var n = 0;
        function m(a) {
          return "jscomp_symbol_" + (a || "") + n++;
        }
        function p() {
          l();
          var a = h.Symbol.iterator;
          a || (a = h.Symbol.iterator = h.Symbol("iterator"));
          "function" != typeof Array.prototype[a] && k(Array.prototype, a, {
            configurable: !0,
            writable: !0,
            value: function value() {
              return q(this);
            }
          });
          p = function p() {};
        }
        function q(a) {
          var b = 0;
          return r(function () {
            return b < a.length ? {
              done: !1,
              value: a[b++]
            } : {
              done: !0
            };
          });
        }
        function r(a) {
          p();
          a = {
            next: a
          };
          a[h.Symbol.iterator] = function () {
            return this;
          };
          return a;
        }
        function t(a) {
          p();
          var b = a[Symbol.iterator];
          return b ? b.call(a) : q(a);
        }
        function u(a) {
          if (!(a instanceof Array)) {
            a = t(a);
            for (var b, c = []; !(b = a.next()).done;) {
              c.push(b.value);
            }
            a = c;
          }
          return a;
        }
        var v = 0;
        function w(a, b) {
          var c = XMLHttpRequest.prototype.send,
            d = v++;
          XMLHttpRequest.prototype.send = function (f) {
            for (var e = [], g = 0; g < arguments.length; ++g) {
              e[g - 0] = arguments[g];
            }
            var E = this;
            a(d);
            this.addEventListener("readystatechange", function () {
              4 === E.readyState && b(d);
            });
            return c.apply(this, e);
          };
        }
        function x(a, b) {
          var c = fetch;
          fetch = function fetch(d) {
            for (var f = [], e = 0; e < arguments.length; ++e) {
              f[e - 0] = arguments[e];
            }
            return new Promise(function (d, e) {
              var g = v++;
              a(g);
              c.apply(null, [].concat(u(f))).then(function (a) {
                b(g);
                d(a);
              }, function (a) {
                b(a);
                e(a);
              });
            });
          };
        }
        var y = "img script iframe link audio video source".split(" ");
        function z(a, b) {
          a = t(a);
          for (var c = a.next(); !c.done; c = a.next()) {
            if (c = c.value, b.includes(c.nodeName.toLowerCase()) || z(c.children, b)) return !0;
          }
          return !1;
        }
        function A(a) {
          var b = new MutationObserver(function (c) {
            c = t(c);
            for (var b = c.next(); !b.done; b = c.next()) {
              b = b.value, "childList" == b.type && z(b.addedNodes, y) ? a(b) : "attributes" == b.type && y.includes(b.target.tagName.toLowerCase()) && a(b);
            }
          });
          b.observe(document, {
            attributes: !0,
            childList: !0,
            subtree: !0,
            attributeFilter: ["href", "src"]
          });
          return b;
        }
        function B(a, b) {
          if (2 < a.length) return performance.now();
          var c = [];
          b = t(b);
          for (var d = b.next(); !d.done; d = b.next()) {
            d = d.value, c.push({
              timestamp: d.start,
              type: "requestStart"
            }), c.push({
              timestamp: d.end,
              type: "requestEnd"
            });
          }
          b = t(a);
          for (d = b.next(); !d.done; d = b.next()) {
            c.push({
              timestamp: d.value,
              type: "requestStart"
            });
          }
          c.sort(function (a, b) {
            return a.timestamp - b.timestamp;
          });
          a = a.length;
          for (b = c.length - 1; 0 <= b; b--) {
            switch (d = c[b], d.type) {
              case "requestStart":
                a--;
                break;
              case "requestEnd":
                a++;
                if (2 < a) return d.timestamp;
                break;
              default:
                throw Error("Internal Error: This should never happen");
            }
          }
          return 0;
        }
        function C(a) {
          a = a ? a : {};
          this.w = !!a.useMutationObserver;
          this.u = a.minValue || null;
          a = window.__tti && window.__tti.e;
          var b = window.__tti && window.__tti.o;
          this.a = a ? a.map(function (a) {
            return {
              start: a.startTime,
              end: a.startTime + a.duration
            };
          }) : [];
          b && b.disconnect();
          this.b = [];
          this.f = new Map();
          this.j = null;
          this.v = -Infinity;
          this.i = !1;
          this.h = this.c = this.s = null;
          w(this.m.bind(this), this.l.bind(this));
          x(this.m.bind(this), this.l.bind(this));
          D(this);
          this.w && (this.h = A(this.B.bind(this)));
        }
        C.prototype.getFirstConsistentlyInteractive = function () {
          var a = this;
          return new Promise(function (b) {
            a.s = b;
            "complete" == document.readyState ? F(a) : window.addEventListener("load", function () {
              F(a);
            });
          });
        };
        function F(a) {
          a.i = !0;
          var b = 0 < a.a.length ? a.a[a.a.length - 1].end : 0,
            c = B(a.g, a.b);
          G(a, Math.max(c + 5E3, b));
        }
        function G(a, b) {
          !a.i || a.v > b || (clearTimeout(a.j), a.j = setTimeout(function () {
            var b = performance.timing.navigationStart,
              d = B(a.g, a.b),
              b = (window.a && window.a.A ? 1E3 * window.a.A().C - b : 0) || performance.timing.domContentLoadedEventEnd - b;
            if (a.u) var f = a.u;else performance.timing.domContentLoadedEventEnd ? (f = performance.timing, f = f.domContentLoadedEventEnd - f.navigationStart) : f = null;
            var e = performance.now();
            null === f && G(a, Math.max(d + 5E3, e + 1E3));
            var g = a.a;
            5E3 > e - d ? d = null : (d = g.length ? g[g.length - 1].end : b, d = 5E3 > e - d ? null : Math.max(d, f));
            d && (a.s(d), clearTimeout(a.j), a.i = !1, a.c && a.c.disconnect(), a.h && a.h.disconnect());
            G(a, performance.now() + 1E3);
          }, b - performance.now()), a.v = b);
        }
        function D(a) {
          a.c = new PerformanceObserver(function (b) {
            b = t(b.getEntries());
            for (var c = b.next(); !c.done; c = b.next()) {
              if (c = c.value, "resource" === c.entryType && (a.b.push({
                start: c.fetchStart,
                end: c.responseEnd
              }), G(a, B(a.g, a.b) + 5E3)), "longtask" === c.entryType) {
                var d = c.startTime + c.duration;
                a.a.push({
                  start: c.startTime,
                  end: d
                });
                G(a, d + 5E3);
              }
            }
          });
          a.c.observe({
            entryTypes: ["longtask", "resource"]
          });
        }
        C.prototype.m = function (a) {
          this.f.set(a, performance.now());
        };
        C.prototype.l = function (a) {
          this.f.delete(a);
        };
        C.prototype.B = function () {
          G(this, performance.now() + 5E3);
        };
        h.Object.defineProperties(C.prototype, {
          g: {
            configurable: !0,
            enumerable: !0,
            get: function get() {
              return [].concat(u(this.f.values()));
            }
          }
        });
        var H = {
          getFirstConsistentlyInteractive: function getFirstConsistentlyInteractive(a) {
            a = a ? a : {};
            return "PerformanceLongTaskTiming" in window ? new C(a).getFirstConsistentlyInteractive() : Promise.resolve(null);
          }
        };
        "undefined" != typeof module && module.exports ? module.exports = H : true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
          return H;
        }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : undefined;
      })();

      /* WEBPACK VAR INJECTION */
    }).call(exports, __webpack_require__(0));

    /***/
  }, /* 12 */
  /***/function (module, exports, __webpack_require__) {
    /* WEBPACK VAR INJECTION */(function (global) {
      function collect(microMessage, performanceApi, callback) {
        var performanceApiData = performanceApi.toJSON();
        if (performanceApiData.timing === undefined) {
          callback(microMessage);
          return;
        }
        safeDiff(microMessage.messageContent, 'dnsLookupTime', performanceApiData.timing.domainLookupEnd, performanceApiData.timing.domainLookupStart);
        safeDiff(microMessage.messageContent, 'timeToFirstByte', performanceApiData.timing.responseStart, performanceApiData.timing.fetchStart);
        safeDiff(microMessage.messageContent, 'tcpConnectionTime', performanceApiData.timing.connectEnd, performanceApiData.timing.connectStart);
        safeDiff(microMessage.messageContent, 'pageLoadTime', performanceApiData.timing.domContentLoadedEventEnd, performanceApiData.timing.navigationStart);
        if (microMessage.messageContent.pageLoadTime && microMessage.messageContent.pageLoadTime < 0) {
          global.addEventListener('load', function () {
            safeDiff(microMessage.messageContent, 'pageLoadTime', performanceApiData.timing.domContentLoadedEventEnd, performanceApiData.timing.navigationStart);
            callback(microMessage);
          });
        } else {
          callback(microMessage);
        }
      }
      function safeDiff(output, key, end, start) {
        if (end !== undefined && start !== undefined) {
          output[key] = end - start;
        }
      }
      module.exports = {
        collect: collect
      };

      /* WEBPACK VAR INJECTION */
    }).call(exports, __webpack_require__(0));

    /***/
  }, /* 13 */
  /***/function (module, exports) {
    function collect(microMessage, networkApi) {
      if (networkApi && networkApi.navigator) {
        var _navigator = networkApi.navigator;
        var connection = _navigator.connection || _navigator.mozConnection || _navigator.webkitConnection;
        if (connection) {
          safeAssign(microMessage.messageContent, 'networkEffectiveType', connection.effectiveType);
          safeAssign(microMessage.messageContent, 'networkDownLink', connection.downlink);
        }
      }
    }
    function safeAssign(output, key, input) {
      if (input !== undefined) {
        output[key] = input;
      }
    }
    module.exports = {
      collect: collect
    };

    /***/
  }, /* 14 */
  /***/function (module, exports, __webpack_require__) {
    /* WEBPACK VAR INJECTION */(function (global) {
      function collect(performanceMetricsMicroMessage, performanceApi, callback) {
        // check if FCP is supported
        if (global.PerformancePaintTiming === undefined) {
          callback(performanceMetricsMicroMessage);
          return;
        }
        var fcp = performanceApi.getEntriesByName('first-contentful-paint');
        // check if FCP is already available
        if (fcp && fcp.length > 0) {
          var entry = fcp[0];
          performanceMetricsMicroMessage.messageContent.firstContentfulPaint = Math.round(entry.startTime + entry.duration);
          callback(performanceMetricsMicroMessage);
          return;
        }
        // check if PerformanceObserver is available so we can be notified when FCP is ready
        if (global.PerformanceObserver !== undefined) {
          var observer = new global.PerformanceObserver(function (list) {
            // eslint-disable-next-line no-restricted-syntax
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;
            try {
              for (var _iterator = list.getEntries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var _entry = _step.value;

                // `name` will be either 'first-paint' or 'first-contentful-paint'.
                if (_entry.name === 'first-contentful-paint') {
                  performanceMetricsMicroMessage.messageContent.firstContentfulPaint = Math.round(_entry.startTime + _entry.duration);
                  callback(performanceMetricsMicroMessage);
                }
              }
            } catch (err) {
              _didIteratorError = true;
              _iteratorError = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }
              } finally {
                if (_didIteratorError) {
                  throw _iteratorError;
                }
              }
            }
          });
          observer.observe({
            entryTypes: ['paint']
          });
        } else {
          // FCP was supported but we couldn't collect it (shouldn't happen)
          callback(performanceMetricsMicroMessage);
        }
      }
      module.exports = {
        collect: collect
      };

      /* WEBPACK VAR INJECTION */
    }).call(exports, __webpack_require__(0));

    /***/
  }, /* 15 */
  /***/function (module, exports, __webpack_require__) {
    var webVitals = __webpack_require__(16);
    var INTERACTIVITY_METRICS_SCHEMA_NAME = 'interactivityMetrics';
    var CORE_PERFORMANCE_METRICS_SCHEMA_NAME = 'corePerformanceMetrics';
    var ADDITIONAL_PERFORMANCE_METRICS_SCHEMA_NAME = 'additionalPerformanceMetrics';
    var coreMetrics = {};
    function addToCoreMetrics(metricName) {
      return function (metric) {
        coreMetrics[metricName] = metric.value;
      };
    }
    var additionalMetrics = {};
    function addToAdditionalMetrics(metricName) {
      return function (metric) {
        additionalMetrics[metricName] = metric.value;
      };
    }
    var noop = function noop() {};
    var report = function report(onPerfEntry) {
      // no-op if code is not running on the client
      // or onPerfEntry is not a function
      if (typeof window === 'undefined' || !onPerfEntry || typeof onPerfEntry !== 'function') {
        return;
      }
      webVitals.getCLS(addToCoreMetrics('cumulativeLayoutShift'));
      webVitals.getLCP(addToCoreMetrics('largestContentfulPaint'));
      webVitals.getFID(addToCoreMetrics('firstInputDelay'));
      webVitals.getTTFB(addToAdditionalMetrics('timeToFirstByte'));
      webVitals.getFCP(addToAdditionalMetrics('firstContentfulPaint'));
      addEventListener('visibilitychange', function () {
        if (document.visibilityState === 'hidden') {
          onPerfEntry();
        }
      });

      // for Safari <= 14 ( https://caniuse.com/?search=visibilitychange )
      addEventListener('pagehide', onPerfEntry);
    };
    var uisPrimeOnReport = function uisPrimeOnReport(platformAnalytics) {
      var callback = noop;
      if (platformAnalytics && typeof platformAnalytics.trackEvent === 'function') {
        callback = function callback() {
          if (Object.keys(coreMetrics).length) {
            platformAnalytics.trackEvent({
              schemaName: INTERACTIVITY_METRICS_SCHEMA_NAME,
              messageContent: coreMetrics
            }, 'timing');
            platformAnalytics.trackEvent({
              schemaName: CORE_PERFORMANCE_METRICS_SCHEMA_NAME,
              messageContent: coreMetrics
            }, 'timing');
            coreMetrics = {};
          }
          if (Object.keys(additionalMetrics).length) {
            platformAnalytics.trackEvent({
              schemaName: ADDITIONAL_PERFORMANCE_METRICS_SCHEMA_NAME,
              messageContent: additionalMetrics
            }, 'timing');
            additionalMetrics = {};
          }
        };
      } else {
        console.error('[CorePerformanceMetrics] cannot publish web vitals to Uis Prime (platformAnalytics not defined)');
      }
      return callback;
    };
    module.exports = {
      report: report,
      uisPrimeOnReport: uisPrimeOnReport
    };

    /***/
  }, /* 16 */
  /***/function (module, __webpack_exports__, __webpack_require__) {
    "use strict";

    Object.defineProperty(__webpack_exports__, "__esModule", {
      value: true
    });
    /* harmony export (binding) */
    __webpack_require__.d(__webpack_exports__, "CLSThresholds", function () {
      return w;
    });
    /* harmony export (binding) */
    __webpack_require__.d(__webpack_exports__, "FCPThresholds", function () {
      return L;
    });
    /* harmony export (binding) */
    __webpack_require__.d(__webpack_exports__, "FIDThresholds", function () {
      return D;
    });
    /* harmony export (binding) */
    __webpack_require__.d(__webpack_exports__, "INPThresholds", function () {
      return j;
    });
    /* harmony export (binding) */
    __webpack_require__.d(__webpack_exports__, "LCPThresholds", function () {
      return U;
    });
    /* harmony export (binding) */
    __webpack_require__.d(__webpack_exports__, "TTFBThresholds", function () {
      return X;
    });
    /* harmony export (binding) */
    __webpack_require__.d(__webpack_exports__, "getCLS", function () {
      return S;
    });
    /* harmony export (binding) */
    __webpack_require__.d(__webpack_exports__, "getFCP", function () {
      return b;
    });
    /* harmony export (binding) */
    __webpack_require__.d(__webpack_exports__, "getFID", function () {
      return x;
    });
    /* harmony export (binding) */
    __webpack_require__.d(__webpack_exports__, "getINP", function () {
      return Q;
    });
    /* harmony export (binding) */
    __webpack_require__.d(__webpack_exports__, "getLCP", function () {
      return W;
    });
    /* harmony export (binding) */
    __webpack_require__.d(__webpack_exports__, "getTTFB", function () {
      return Z;
    });
    /* harmony export (binding) */
    __webpack_require__.d(__webpack_exports__, "onCLS", function () {
      return S;
    });
    /* harmony export (binding) */
    __webpack_require__.d(__webpack_exports__, "onFCP", function () {
      return b;
    });
    /* harmony export (binding) */
    __webpack_require__.d(__webpack_exports__, "onFID", function () {
      return x;
    });
    /* harmony export (binding) */
    __webpack_require__.d(__webpack_exports__, "onINP", function () {
      return Q;
    });
    /* harmony export (binding) */
    __webpack_require__.d(__webpack_exports__, "onLCP", function () {
      return W;
    });
    /* harmony export (binding) */
    __webpack_require__.d(__webpack_exports__, "onTTFB", function () {
      return Z;
    });
    var e,
      n,
      t,
      r,
      i,
      a = -1,
      o = function o(e) {
        addEventListener("pageshow", function (n) {
          n.persisted && (a = n.timeStamp, e(n));
        }, !0);
      },
      c = function c() {
        return window.performance && performance.getEntriesByType && performance.getEntriesByType("navigation")[0];
      },
      u = function u() {
        var e = c();
        return e && e.activationStart || 0;
      },
      f = function f(e, n) {
        var t = c(),
          r = "navigate";
        return a >= 0 ? r = "back-forward-cache" : t && (r = document.prerendering || u() > 0 ? "prerender" : document.wasDiscarded ? "restore" : t.type.replace(/_/g, "-")), {
          name: e,
          value: void 0 === n ? -1 : n,
          rating: "good",
          delta: 0,
          entries: [],
          id: "v3-".concat(Date.now(), "-").concat(Math.floor(8999999999999 * Math.random()) + 1e12),
          navigationType: r
        };
      },
      s = function s(e, n, t) {
        try {
          if (PerformanceObserver.supportedEntryTypes.includes(e)) {
            var r = new PerformanceObserver(function (e) {
              Promise.resolve().then(function () {
                n(e.getEntries());
              });
            });
            return r.observe(Object.assign({
              type: e,
              buffered: !0
            }, t || {})), r;
          }
        } catch (e) {}
      },
      d = function d(e, n, t, r) {
        var i, a;
        return function (o) {
          n.value >= 0 && (o || r) && ((a = n.value - (i || 0)) || void 0 === i) && (i = n.value, n.delta = a, n.rating = function (e, n) {
            return e > n[1] ? "poor" : e > n[0] ? "needs-improvement" : "good";
          }(n.value, t), e(n));
        };
      },
      l = function l(e) {
        requestAnimationFrame(function () {
          return requestAnimationFrame(function () {
            return e();
          });
        });
      },
      p = function p(e) {
        var n = function n(_n) {
          "pagehide" !== _n.type && "hidden" !== document.visibilityState || e(_n);
        };
        addEventListener("visibilitychange", n, !0), addEventListener("pagehide", n, !0);
      },
      v = function v(e) {
        var n = !1;
        return function (t) {
          n || (e(t), n = !0);
        };
      },
      m = -1,
      h = function h() {
        return "hidden" !== document.visibilityState || document.prerendering ? 1 / 0 : 0;
      },
      g = function g(e) {
        "hidden" === document.visibilityState && m > -1 && (m = "visibilitychange" === e.type ? e.timeStamp : 0, T());
      },
      y = function y() {
        addEventListener("visibilitychange", g, !0), addEventListener("prerenderingchange", g, !0);
      },
      T = function T() {
        removeEventListener("visibilitychange", g, !0), removeEventListener("prerenderingchange", g, !0);
      },
      E = function E() {
        return m < 0 && (m = h(), y(), o(function () {
          setTimeout(function () {
            m = h(), y();
          }, 0);
        })), {
          get firstHiddenTime() {
            return m;
          }
        };
      },
      C = function C(e) {
        document.prerendering ? addEventListener("prerenderingchange", function () {
          return e();
        }, !0) : e();
      },
      L = [1800, 3e3],
      b = function b(e, n) {
        n = n || {}, C(function () {
          var t,
            r = E(),
            i = f("FCP"),
            a = s("paint", function (e) {
              e.forEach(function (e) {
                "first-contentful-paint" === e.name && (a.disconnect(), e.startTime < r.firstHiddenTime && (i.value = Math.max(e.startTime - u(), 0), i.entries.push(e), t(!0)));
              });
            });
          a && (t = d(e, i, L, n.reportAllChanges), o(function (r) {
            i = f("FCP"), t = d(e, i, L, n.reportAllChanges), l(function () {
              i.value = performance.now() - r.timeStamp, t(!0);
            });
          }));
        });
      },
      w = [.1, .25],
      S = function S(e, n) {
        n = n || {}, b(v(function () {
          var t,
            r = f("CLS", 0),
            i = 0,
            a = [],
            c = function c(e) {
              e.forEach(function (e) {
                if (!e.hadRecentInput) {
                  var n = a[0],
                    t = a[a.length - 1];
                  i && e.startTime - t.startTime < 1e3 && e.startTime - n.startTime < 5e3 ? (i += e.value, a.push(e)) : (i = e.value, a = [e]);
                }
              }), i > r.value && (r.value = i, r.entries = a, t());
            },
            u = s("layout-shift", c);
          u && (t = d(e, r, w, n.reportAllChanges), p(function () {
            c(u.takeRecords()), t(!0);
          }), o(function () {
            i = 0, r = f("CLS", 0), t = d(e, r, w, n.reportAllChanges), l(function () {
              return t();
            });
          }), setTimeout(t, 0));
        }));
      },
      A = {
        passive: !0,
        capture: !0
      },
      I = new Date(),
      P = function P(r, i) {
        e || (e = i, n = r, t = new Date(), k(removeEventListener), F());
      },
      F = function F() {
        if (n >= 0 && n < t - I) {
          var i = {
            entryType: "first-input",
            name: e.type,
            target: e.target,
            cancelable: e.cancelable,
            startTime: e.timeStamp,
            processingStart: e.timeStamp + n
          };
          r.forEach(function (e) {
            e(i);
          }), r = [];
        }
      },
      M = function M(e) {
        if (e.cancelable) {
          var n = (e.timeStamp > 1e12 ? new Date() : performance.now()) - e.timeStamp;
          "pointerdown" == e.type ? function (e, n) {
            var t = function t() {
                P(e, n), i();
              },
              r = function r() {
                i();
              },
              i = function i() {
                removeEventListener("pointerup", t, A), removeEventListener("pointercancel", r, A);
              };
            addEventListener("pointerup", t, A), addEventListener("pointercancel", r, A);
          }(n, e) : P(n, e);
        }
      },
      k = function k(e) {
        ["mousedown", "keydown", "touchstart", "pointerdown"].forEach(function (n) {
          return e(n, M, A);
        });
      },
      D = [100, 300],
      x = function x(t, i) {
        i = i || {}, C(function () {
          var a,
            c = E(),
            u = f("FID"),
            l = function l(e) {
              e.startTime < c.firstHiddenTime && (u.value = e.processingStart - e.startTime, u.entries.push(e), a(!0));
            },
            m = function m(e) {
              e.forEach(l);
            },
            h = s("first-input", m);
          a = d(t, u, D, i.reportAllChanges), h && p(v(function () {
            m(h.takeRecords()), h.disconnect();
          })), h && o(function () {
            var o;
            u = f("FID"), a = d(t, u, D, i.reportAllChanges), r = [], n = -1, e = null, k(addEventListener), o = l, r.push(o), F();
          });
        });
      },
      B = 0,
      R = 1 / 0,
      H = 0,
      N = function N(e) {
        e.forEach(function (e) {
          e.interactionId && (R = Math.min(R, e.interactionId), H = Math.max(H, e.interactionId), B = H ? (H - R) / 7 + 1 : 0);
        });
      },
      O = function O() {
        return i ? B : performance.interactionCount || 0;
      },
      q = function q() {
        "interactionCount" in performance || i || (i = s("event", N, {
          type: "event",
          buffered: !0,
          durationThreshold: 0
        }));
      },
      j = [200, 500],
      _ = 0,
      z = function z() {
        return O() - _;
      },
      G = [],
      J = {},
      K = function K(e) {
        var n = G[G.length - 1],
          t = J[e.interactionId];
        if (t || G.length < 10 || e.duration > n.latency) {
          if (t) t.entries.push(e), t.latency = Math.max(t.latency, e.duration);else {
            var r = {
              id: e.interactionId,
              latency: e.duration,
              entries: [e]
            };
            J[r.id] = r, G.push(r);
          }
          G.sort(function (e, n) {
            return n.latency - e.latency;
          }), G.splice(10).forEach(function (e) {
            delete J[e.id];
          });
        }
      },
      Q = function Q(e, n) {
        n = n || {}, C(function () {
          q();
          var t,
            r = f("INP"),
            i = function i(e) {
              e.forEach(function (e) {
                (e.interactionId && K(e), "first-input" === e.entryType) && !G.some(function (n) {
                  return n.entries.some(function (n) {
                    return e.duration === n.duration && e.startTime === n.startTime;
                  });
                }) && K(e);
              });
              var n,
                i = (n = Math.min(G.length - 1, Math.floor(z() / 50)), G[n]);
              i && i.latency !== r.value && (r.value = i.latency, r.entries = i.entries, t());
            },
            a = s("event", i, {
              durationThreshold: n.durationThreshold || 40
            });
          t = d(e, r, j, n.reportAllChanges), a && (a.observe({
            type: "first-input",
            buffered: !0
          }), p(function () {
            i(a.takeRecords()), r.value < 0 && z() > 0 && (r.value = 0, r.entries = []), t(!0);
          }), o(function () {
            G = [], _ = O(), r = f("INP"), t = d(e, r, j, n.reportAllChanges);
          }));
        });
      },
      U = [2500, 4e3],
      V = {},
      W = function W(e, n) {
        n = n || {}, C(function () {
          var t,
            r = E(),
            i = f("LCP"),
            a = function a(e) {
              var n = e[e.length - 1];
              n && n.startTime < r.firstHiddenTime && (i.value = Math.max(n.startTime - u(), 0), i.entries = [n], t());
            },
            c = s("largest-contentful-paint", a);
          if (c) {
            t = d(e, i, U, n.reportAllChanges);
            var m = v(function () {
              V[i.id] || (a(c.takeRecords()), c.disconnect(), V[i.id] = !0, t(!0));
            });
            ["keydown", "click"].forEach(function (e) {
              addEventListener(e, m, !0);
            }), p(m), o(function (r) {
              i = f("LCP"), t = d(e, i, U, n.reportAllChanges), l(function () {
                i.value = performance.now() - r.timeStamp, V[i.id] = !0, t(!0);
              });
            });
          }
        });
      },
      X = [800, 1800],
      Y = function e(n) {
        document.prerendering ? C(function () {
          return e(n);
        }) : "complete" !== document.readyState ? addEventListener("load", function () {
          return e(n);
        }, !0) : setTimeout(n, 0);
      },
      Z = function Z(e, n) {
        n = n || {};
        var t = f("TTFB"),
          r = d(e, t, X, n.reportAllChanges);
        Y(function () {
          var i = c();
          if (i) {
            var a = i.responseStart;
            if (a <= 0 || a > performance.now()) return;
            t.value = Math.max(a - u(), 0), t.entries = [i], r(!0), o(function () {
              t = f("TTFB", 0), (r = d(e, t, X, n.reportAllChanges))(!0);
            });
          }
        });
      };

    /***/
  }, /* 17 */
  /***/function (module, exports, __webpack_require__) {
    var toLogStore = __webpack_require__(2).toLogStore;
    var log = __webpack_require__(2).log;
    var navigatorWrapper = __webpack_require__(19);
    var environment = __webpack_require__(3);
    var collectorUrl = environment.isLocalEnvironment() ? 'https://collector.test.expedia.com' : '/cl/data';

    /*
    AntiCors Endpoint : /cl/data/
    Test endpoint : https://collector.test.expedia.com
    Int endpoint : https://collector.int.expedia.com
    Prod endpoint : https://collector.prod.expedia.com
    PCI and Chandler endpoint: https://collector-pci.prod-p.expedia.com
    more info at: https://doppler/docs/documentation/collector/about/
    */

    // validating REQUIRED fields (deviceId, requestId, pageName, pageUsabletime)
    function isValid(data) {
      return !(!data || !data.deviceId || !data.pageName || !data.pageUsableTime || !data.requestId);
    }
    var publisherName = 'PM Publisher';
    function publish(data) {
      if (!isValid(data)) {
        log('Not valid PM formatted data: ');
        log(data);
        return false;
      }
      this.requestBody = data;
      this.requestBody.utcTimestamp = Date.now();
      this.requestBody.navigationTimingSupport = environment.isPerformanceTimingSupported();
      this.requestBody.performanceMarkSupport = environment.isPerformanceMarkSupported();
      this.requestBody.beaconApiSupport = environment.isBeaconSupported();
      var httpResponse = navigatorWrapper.sendBeacon(collectorUrl + '/perfmetrics.json?persist=true', this.requestBody);
      var logMsg = {
        publisher: publisherName,
        status: '',
        sentData: this.requestBody
      };
      if (typeof httpResponse === 'boolean') {
        logMsg.status = httpResponse ? 'queued' : 'failed';
        toLogStore(logMsg);
      } else {
        httpResponse.onload = function () {
          logMsg.status = httpResponse.status;
          toLogStore(logMsg);
        };
        httpResponse.onerror = function () {
          logMsg.status = 'error';
          toLogStore(logMsg);
        };
        httpResponse.ontimeout = function () {
          logMsg.status = 'timeout';
          toLogStore(logMsg);
        };
      }
      return httpResponse;
    }
    module.exports = {
      publish: publish,
      isValid: isValid
    };

    /***/
  }, /* 18 */
  /***/function (module, exports) {
    // shim for using process in browser
    var process = module.exports = {};

    // cached from whatever global is present so that test runners that stub it
    // don't break things.  But we need to wrap it in a try catch in case it is
    // wrapped in strict mode code which doesn't define any globals.  It's inside a
    // function because try/catches deoptimize in certain engines.

    var cachedSetTimeout;
    var cachedClearTimeout;
    function defaultSetTimout() {
      throw new Error('setTimeout has not been defined');
    }
    function defaultClearTimeout() {
      throw new Error('clearTimeout has not been defined');
    }
    (function () {
      try {
        if (typeof setTimeout === 'function') {
          cachedSetTimeout = setTimeout;
        } else {
          cachedSetTimeout = defaultSetTimout;
        }
      } catch (e) {
        cachedSetTimeout = defaultSetTimout;
      }
      try {
        if (typeof clearTimeout === 'function') {
          cachedClearTimeout = clearTimeout;
        } else {
          cachedClearTimeout = defaultClearTimeout;
        }
      } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
      }
    })();
    function runTimeout(fun) {
      if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
      }
      // if setTimeout wasn't available but was latter defined
      if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
      }
      try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
      } catch (e) {
        try {
          // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
          return cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
          // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
          return cachedSetTimeout.call(this, fun, 0);
        }
      }
    }
    function runClearTimeout(marker) {
      if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
      }
      // if clearTimeout wasn't available but was latter defined
      if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
      }
      try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
      } catch (e) {
        try {
          // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
          return cachedClearTimeout.call(null, marker);
        } catch (e) {
          // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
          // Some versions of I.E. have different rules for clearTimeout vs setTimeout
          return cachedClearTimeout.call(this, marker);
        }
      }
    }
    var queue = [];
    var draining = false;
    var currentQueue;
    var queueIndex = -1;
    function cleanUpNextTick() {
      if (!draining || !currentQueue) {
        return;
      }
      draining = false;
      if (currentQueue.length) {
        queue = currentQueue.concat(queue);
      } else {
        queueIndex = -1;
      }
      if (queue.length) {
        drainQueue();
      }
    }
    function drainQueue() {
      if (draining) {
        return;
      }
      var timeout = runTimeout(cleanUpNextTick);
      draining = true;
      var len = queue.length;
      while (len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
          if (currentQueue) {
            currentQueue[queueIndex].run();
          }
        }
        queueIndex = -1;
        len = queue.length;
      }
      currentQueue = null;
      draining = false;
      runClearTimeout(timeout);
    }
    process.nextTick = function (fun) {
      var args = new Array(arguments.length - 1);
      if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
          args[i - 1] = arguments[i];
        }
      }
      queue.push(new Item(fun, args));
      if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
      }
    };

    // v8 likes predictible objects
    function Item(fun, array) {
      this.fun = fun;
      this.array = array;
    }
    Item.prototype.run = function () {
      this.fun.apply(null, this.array);
    };
    process.title = 'browser';
    process.browser = true;
    process.env = {};
    process.argv = [];
    process.version = ''; // empty string to avoid regexp issues
    process.versions = {};
    function noop() {}
    process.on = noop;
    process.addListener = noop;
    process.once = noop;
    process.off = noop;
    process.removeListener = noop;
    process.removeAllListeners = noop;
    process.emit = noop;
    process.prependListener = noop;
    process.prependOnceListener = noop;
    process.listeners = function (name) {
      return [];
    };
    process.binding = function (name) {
      throw new Error('process.binding is not supported');
    };
    process.cwd = function () {
      return '/';
    };
    process.chdir = function (dir) {
      throw new Error('process.chdir is not supported');
    };
    process.umask = function () {
      return 0;
    };

    /***/
  }, /* 19 */
  /***/function (module, exports) {
    var isBeaconAPISupported = function isBeaconAPISupported() {
      return typeof navigator !== 'undefined' && typeof navigator.sendBeacon === 'function';
    };
    var sendBeacon = function sendBeacon(url, data) {
      if (isBeaconAPISupported()) {
        return navigator.sendBeacon(url, JSON.stringify(data));
      }
      return post(url, data);
    };
    function post(url, data) {
      var httpRequest = new XMLHttpRequest();
      var init = {
        method: 'POST',
        headers: {
          'Content-type': 'application/json'
        },
        body: data
      };
      httpRequest.open(init.method, url, true);
      httpRequest.setRequestHeader('Content-type', 'application/json');
      httpRequest.send(JSON.stringify(init.body));
      return httpRequest;
    }
    module.exports.sendBeacon = sendBeacon;

    /***/
  }]
  /******/);

  /***/
}), (/* 10 */
/***/function (module, exports) {
  module.exports = /******/function (modules) {
    // webpackBootstrap
    /******/ // The module cache
    /******/
    var installedModules = {};
    /******/
    /******/ // The require function
    /******/
    function __webpack_require__(moduleId) {
      /******/
      /******/ // Check if module is in cache
      /******/if (installedModules[moduleId]) {
        /******/return installedModules[moduleId].exports;
        /******/
      }
      /******/ // Create a new module (and put it into the cache)
      /******/
      var module = installedModules[moduleId] = {
        /******/i: moduleId,
        /******/l: false,
        /******/exports: {}
        /******/
      };
      /******/
      /******/ // Execute the module function
      /******/
      modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
      /******/
      /******/ // Flag the module as loaded
      /******/
      module.l = true;
      /******/
      /******/ // Return the exports of the module
      /******/
      return module.exports;
      /******/
    }
    /******/
    /******/
    /******/ // expose the modules object (__webpack_modules__)
    /******/
    __webpack_require__.m = modules;
    /******/
    /******/ // expose the module cache
    /******/
    __webpack_require__.c = installedModules;
    /******/
    /******/ // identity function for calling harmony imports with the correct context
    /******/
    __webpack_require__.i = function (value) {
      return value;
    };
    /******/
    /******/ // define getter function for harmony exports
    /******/
    __webpack_require__.d = function (exports, name, getter) {
      /******/if (!__webpack_require__.o(exports, name)) {
        /******/Object.defineProperty(exports, name, {
          /******/configurable: false,
          /******/enumerable: true,
          /******/get: getter
          /******/
        });
        /******/
      }
      /******/
    };
    /******/
    /******/ // getDefaultExport function for compatibility with non-harmony modules
    /******/
    __webpack_require__.n = function (module) {
      /******/var getter = module && module.__esModule ? /******/function getDefault() {
        return module['default'];
      } : /******/function getModuleExports() {
        return module;
      };
      /******/
      __webpack_require__.d(getter, 'a', getter);
      /******/
      return getter;
      /******/
    };
    /******/
    /******/ // Object.prototype.hasOwnProperty.call
    /******/
    __webpack_require__.o = function (object, property) {
      return Object.prototype.hasOwnProperty.call(object, property);
    };
    /******/
    /******/ // __webpack_public_path__
    /******/
    __webpack_require__.p = "";
    /******/
    /******/ // Load entry module and return exports
    /******/
    return __webpack_require__(__webpack_require__.s = 4);
    /******/
  }
  /************************************************************************/
  /******/([(/* 0 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
      return typeof obj;
    } : function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    var env = __webpack_require__(7);
    var httpUtil = __webpack_require__(1);
    var messageUrl = '/cl/2x2.json';
    function sendBeacon(url) {
      var beaconImages = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

      // ideally navigator.sendbeacon should be used here, but it sends a POST request
      // and collector-web only have GET request configured
      // (https://ewegithub.sb.karmalab.net/EWE/collector-web/blob/4457ab12394d47d6460188fc72a658b0fbb58ad4/src/main/scala/com/expedia/www/collector/app/ClientlogServlet.scala#L64-L74).
      var image = new Image();
      image.src = url;
      beaconImages.push(image);
    }
    function normalizeMessageParams(params) {
      if (!params) return [];
      if (typeof params === 'string') return [params];
      if ((typeof params === 'undefined' ? 'undefined' : _typeof(params)) === 'object' && !Array.isArray(params)) {
        // Is it an object except Array?
        var array = [];
        Object.keys(params).forEach(function (objKey) {
          array.push(encodeURIComponent(objKey) + '=' + encodeURIComponent(encodeSplunkFieldComponent(params[objKey])));
        });
        params = array;
      }
      return params;
    }
    function encodeSplunkFieldComponent(value) {
      //  Is there a way to encode the double quote instead of replacing it with a "fullwidth quotation mark"?
      return String(value).replace(/"/g, '＂');
    }
    function normalizeError(e) {
      var NA = 'NA';
      var col = NA;
      var line = NA;
      var src = NA;
      var loc = void 0;
      try {
        if (e && e.stack) {
          loc = e.stack.match(/(([^)]+\d+))/) || e.stack.match(/@([^)]+\d+)\n/);
          if (loc) {
            loc = loc[1].split(':');
            col = loc.pop();
            line = loc.pop();
            src = loc.join(':');
          }
        }
      } catch (ex) {
        console.log(ex + ' dcs:util.js');
        // do nothing and return the error as is
      }
      if (e) {
        e = {
          sourceURL: e.sourceURL || e.fileName || src,
          line: e.line || e.lineNumber || line,
          col: e.columnNumber || col,
          message: e.message,
          stack: e.stack || NA
        };
      }
      return e;
    }
    function consoleError(message) {
      if (typeof console !== 'undefined' && typeof console.error === 'function') {
        console.error(message);
      }
    }
    function getFixedParams(configuration, level) {
      var params = [];
      var returnVal = [];
      params.push('live=' + env.isProductionEnv(window.location.hostname));
      var agentFlags = getAgentFlags(configuration);
      returnVal = agentFlags.concat(prepareParams(configuration, level));
      return returnVal.concat(params);
    }
    function prepareParams(configuration, level) {
      var param = [];
      if (configuration.data && typeof configuration.data === 'string') {
        configuration.data.split('|').forEach(function (data) {
          param.push(data);
        });
      }
      if (configuration.data && _typeof(configuration.data) === 'object') {
        param = param.concat(paramsFromObject(configuration.data));
      }
      if (level) {
        var objKey = 'level';
        var objVal = level;
        param.push(objKey + '=' + objVal);
      }
      return param;
    }
    // private
    function paramsFromObject(object) {
      var params = [];
      var pair = void 0;
      if (Object.keys(object).length > 0) {
        Object.keys(object).forEach(function (key) {
          pair = key + '=' + String(object[key]).replace(/\n|\r/gm, '');
          params.push(pair);
        });
      }
      return params;
    }
    function getAgentFlags(configuration) {
      var dataParams = [];
      if (configuration.gcoAgent) {
        dataParams.push('gcoAgent=true');
        dataParams.push('agentLogonName=' + (configuration.agentLogonName || 'unknown'));
        dataParams.push('agentCallCenter=' + (configuration.agentCallCenter || 'unknown'));
        dataParams.push('agentCountry=' + (configuration.agentCountry || 'unknown'));
      } else {
        dataParams.push('gcoAgent=false');
      }
      return dataParams;
    }
    function expGetISODateString(date) {
      if (date.toISOString()) {
        return date.toISOString();
      }
      return date.getFullYear().toString() + '-' + date.getMonth() + '-' + date.getDate() + 'T' + date.getHours() + ':' + date.getMinutes() + ':' + date.getSeconds();
    }
    function logErrorOnConsole(message) {
      // eslint-disable-next-line no-console
      console.error(message);
    }
    function isBrowser() {
      return (typeof window === 'undefined' ? 'undefined' : _typeof(window)) === 'object';
    }
    function getCurrentTime() {
      return getCurrentDate().getTime();
    }
    function getCurrentDate() {
      return new Date();
    }
    function mergeObjects(intoThisObject, fromThisObject) {
      if (fromThisObject) {
        Object.keys(fromThisObject).forEach(function (key) {
          intoThisObject[key] = fromThisObject[key];
        });
      }
    }
    function logClientLogError(error, debug, functionName) {
      var obj = {};
      consoleError('Something went wrong while calling ' + functionName + ' ' + error);
      try {
        var keyIndex = error.indexOf(':');
        var errorKey = error.substring(0, keyIndex);
        var errormsg = error.substring(keyIndex + 1).replace(':', '');
        Object.defineProperty(obj, errorKey, {
          value: errormsg,
          enumerable: true
        });
        httpUtil.sendClientLog(messageUrl, obj, debug);
      } catch (err) {
        consoleError('Something went wrong while calling logClientLogError ' + err);
      }
    }
    module.exports = {
      getFixedParams: getFixedParams,
      normalizeMessageParams: normalizeMessageParams,
      normalizeError: normalizeError,
      logErrorOnConsole: logErrorOnConsole,
      expGetISODateString: expGetISODateString,
      sendBeacon: sendBeacon,
      isBrowser: isBrowser,
      getCurrentDate: getCurrentDate,
      getCurrentTime: getCurrentTime,
      consoleError: consoleError,
      mergeObjects: mergeObjects,
      logClientLogError: logClientLogError
    };

    /***/
  }), (/* 1 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    function post(url, data, toLogStore) {
      var httpRequest = new XMLHttpRequest();
      var init = {
        method: 'POST',
        headers: {
          'Content-type': 'application/json'
        },
        body: data
      };
      httpRequest.open(init.method, url, true);
      httpRequest.setRequestHeader('Content-type', 'application/json');
      toLogStore({
        publisher: 'Splunk and S3 Publisher',
        clientUrl: url,
        status: 'successfull',
        sentData: data
      });
      httpRequest.send(JSON.stringify(init.body));
      return httpRequest;
    }
    function isBeaconAPISupported() {
      return typeof navigator !== 'undefined' && typeof navigator.sendBeacon === 'function';
    }
    function sendClientLog(url, data, toLogStore) {
      if (isBeaconAPISupported()) {
        toLogStore({
          publisher: 'Splunk and S3 Publisher',
          clientUrl: url,
          status: 'successful',
          sentData: data
        });
        return navigator.sendBeacon(url, JSON.stringify(data));
      }
      return post(url, data, toLogStore);
    }
    module.exports = {
      sendClientLog: sendClientLog
    };

    /***/
  }), (/* 2 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
      return typeof obj;
    } : function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    var _createClass = function () {
      function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }
      return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
      };
    }();
    function _classCallCheck(instance, Constructor) {
      if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
      }
    }
    var util = __webpack_require__(0);
    var httpUtil = __webpack_require__(1);
    var messageUrl = '/cl/2x2.json';
    var ERROR_THRESHOLD_COUNT = 100;
    var ErrorLogger = function () {
      function ErrorLogger(params) {
        _classCallCheck(this, ErrorLogger);
        if (!util.isBrowser()) {
          throw new Error('Error Logger is only supported on a browser');
        }
        this.configuration = params || {};
        this.configuration.logErrorOnConsole = this.configuration.logErrorOnConsole || true;
        this.configuration.pageStartTime = this.configuration.pageStartTime || util.getCurrentTime();
        this.debugLogger = this.configuration.debugLogger || function () {};
        this.onerrorSubscribers = [];
        var attachWindowOnErrorHandler = this.configuration.attachWindowOnErrorHandler;
        attachWindowOnErrorHandler = attachWindowOnErrorHandler === undefined ? true : attachWindowOnErrorHandler;
        if (attachWindowOnErrorHandler) {
          this.errorsCountByMessage = {};
          this.bindWindowOnError();
        }
      }
      _createClass(ErrorLogger, [{
        key: 'bindWindowOnError',
        value: function bindWindowOnError() {
          var _this = this;
          window.onerror = function () {
            _this.onWindowError.apply(_this, arguments);
          };
        }
      }, {
        key: 'subscribeToOnErrorCallback',
        value: function subscribeToOnErrorCallback(callback) {
          this.onerrorSubscribers.push(callback);
        }
      }, {
        key: 'publishErrors',
        value: function publishErrors() {
          this.onerrorSubscribers.forEach(function (errorSubscriber) {
            if (typeof errorSubscriber === 'function') {
              errorSubscriber();
            } else {
              console.log(errorSubscriber + ' must be a function!');
            }
          });
        }
      }, {
        key: 'onWindowError',
        value: function onWindowError(message, url, line, column, error) {
          try {
            var params = error ? getErrorParams(error, url, line, column) : {
              onErrorMsg: message
            };
            this.errorsCountByMessage[message] = (this.errorsCountByMessage[message] || 0) + 1;
            var errorThresholdExceeded = this.errorsCountByMessage[message] === ERROR_THRESHOLD_COUNT;
            if (errorThresholdExceeded) params.exceedsErrorThreshold = true;
            if (this.errorsCountByMessage[message] === 1 || errorThresholdExceeded) {
              this.logMessage('windowOnError', params);
            }
            this.publishErrors();
          } catch (err) {
            util.logClientLogError('' + err, this.debugLogger, 'onWindowError');
          }
        }

        /**
         * @param message the message to be logged
         * @param param1 the level of the log if param2 is present, a data object containing properties to log otherwise
         * @param param2 a data object containing properties to log. can be a string in 'field=value' format, an array of mentioned strings, or an object
         */
      }, {
        key: 'logMessage',
        value: function logMessage(message, param1, param2) {
          try {
            var additionalData = param2 || param1;
            var level = param2 ? param1 : 'INFO';
            var params = getNormalizedParams(message, this.configuration);
            if (typeof additionalData === 'string') {
              var split = additionalData.split('=');
              params[split[0]] = split[1];
            } else if (Array.isArray(additionalData)) {
              additionalData.forEach(function (key) {
                var split = key.split('=');
                params[split[0]] = split[1];
              });
            } else if ((typeof additionalData === 'undefined' ? 'undefined' : _typeof(additionalData)) === 'object') {
              Object.keys(additionalData).forEach(function (key) {
                params[key] = additionalData[key];
              });
            }
            util.getFixedParams(this.configuration, level).forEach(function (key) {
              var split = key.split('=');
              params[split[0]] = split[1];
            });
            var JsonString = encodedToJson(util.normalizeMessageParams(params));
            var isDebugEnabled = (this.configuration || {}).isDebugEnabled || false;
            httpUtil.sendClientLog(messageUrl, JsonString, this.debugLogger);
            this.debugLogger({
              messageUrl: messageUrl,
              JsonString: JsonString
            }, 'clientLogging', level, this.configuration.pageName, isDebugEnabled);
          } catch (error) {
            util.logClientLogError('' + error, this.debugLogger, 'logMessage');
          }
        }
      }, {
        key: 'logError',
        value: function logError(message, error, additionalData) {
          try {
            var debugInfo = util.normalizeMessageParams(error ? getErrorParams(error) : {
              onError: 'NA'
            });
            debugInfo = debugInfo.concat(util.normalizeMessageParams(additionalData));
            this.logMessage(message, 'ERROR', debugInfo);
            if (this.configuration.logErrorOnConsole) {
              util.logErrorOnConsole(message + '\n' + debugInfo.join('\n'));
            }
          } catch (err) {
            util.logClientLogError('' + err, this.debugLogger, 'logError');
          }
        }
      }, {
        key: 'setConfiguration',
        value: function setConfiguration(params) {
          try {
            util.mergeObjects(this.configuration, params);
          } catch (err) {
            util.logClientLogError('' + err, this.debugLogger, 'setConfiguration');
          }
        }
      }]);
      return ErrorLogger;
    }();
    module.exports = ErrorLogger;
    function getNormalizedParams(message, configuration) {
      var rawParams = {
        logTime: util.expGetISODateString(util.getCurrentDate()),
        action: 'logErrors',
        label: message,
        pageName: configuration.pageName,
        pageUrl: window.location.href,
        guid: configuration.guid,
        clientWidth: document.documentElement.clientWidth
      };
      rawParams[message + '_elapsedTime'] = util.getCurrentTime() - configuration.pageStartTime;
      return rawParams;
    }
    function getErrorParams(error, url, line, column) {
      error = util.normalizeError(error);
      return {
        onErrorMsg: error.message,
        onErrorUrl: error.sourceURL || url,
        onErrorLine: error.line || line,
        onErrorChar: error.col || column || 'NA',
        stack: error.stack ? error.stack.substr(0, 200) : 'NA'
      };
    }
    function encodedToJson(arrayParams) {
      var i = void 0;
      var obj = {};
      for (i = 0; i < arrayParams.length; i += 1) {
        if (arrayParams[i].indexOf('=') !== -1) {
          var arrTmp = arrayParams[i];
          var paramValue = decodeURIComponent(arrTmp.substr(arrTmp.indexOf('=') + 1));
          Object.defineProperty(obj, decodeURIComponent(arrTmp.substr(0, arrTmp.indexOf('='))), {
            value: paramValue,
            enumerable: true,
            writable: true
          });
        }
      }
      return obj;
    }

    /***/
  }), (/* 3 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    var _createClass = function () {
      function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }
      return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
      };
    }();
    function _classCallCheck(instance, Constructor) {
      if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
      }
    }
    var collector = __webpack_require__(5);
    var util = __webpack_require__(0);
    var WebPerformanceLogger = function () {
      function WebPerformanceLogger(params) {
        _classCallCheck(this, WebPerformanceLogger);
        this.webPerfLogPublisher = '/cl/1x1.gif';
        this.configuratonParams = params || {};
        this.performance = window.performance;
        this.beaconImages = [];
        this.isPageUsableSent = false;
        this.bindWindowOnLoad();
      }
      _createClass(WebPerformanceLogger, [{
        key: 'logTrxEvent',
        value: function logTrxEvent(label, loggingData) {
          try {
            this.logMetrics(label, loggingData);
          } catch (err) {
            util.consoleError('Something went wrong while calling logTrxEvent ' + err);
          }
        }
      }, {
        key: 'markPageUsable',
        value: function markPageUsable() {
          try {
            if (this.performance && typeof this.performance.mark === 'function') {
              this.performance.mark('Page Usable');
            }
          } catch (err) {
            util.consoleError('Something went wrong while calling clintLog\'s markPageUsable ' + err);
          }
        }
      }, {
        key: 'setPageUsableTime',
        value: function setPageUsableTime(pageUsableTime) {
          this.pageUsableTime = pageUsableTime;
        }
      }, {
        key: 'logDefaultMetrics',
        value: function logDefaultMetrics() {
          var navTiming = collector.collectNavigationTimings();
          this.logMetrics('navTiming', navTiming);
        }
      }, {
        key: 'bindWindowOnLoad',
        value: function bindWindowOnLoad() {
          var _this = this;
          try {
            if (typeof setInterval === 'function') {
              window.addEventListener('load', this.logDefaultMetrics(), false);
              window.addEventListener('load', function () {
                return setInterval(_this.logMetrics.bind(_this, '', ''), 1 * 60 * 1000);
              }, false);
            }
          } catch (err) {
            util.consoleError('Something went wrong while calling bindWindowOnLoad ' + err);
          }
        }
      }, {
        key: 'markIsPageUsableSent',
        value: function markIsPageUsableSent() {
          this.isPageUsableSent = true;
        }
      }, {
        key: 'logMetrics',
        value: function logMetrics(label, loggingData) {
          var defaultAttributes = collector.collectDefaultAttributes(this.configuratonParams);
          var providedAttributes = collector.collectProvidedAttributes(this.configuratonParams, label, loggingData);
          var loggingParams = collector.joinAttributes(defaultAttributes, providedAttributes);
          loggingParams = '?' + loggingParams.replace(/,/g, '&');
          if (!this.isPageUsableSent) {
            var pageUsable = collector.collectPageUsableParameter(this.pageUsableTime);
            if (pageUsable.indexOf('pageUsableTime=') !== -1) {
              loggingParams = collector.joinAttributes(loggingParams, pageUsable);
              this.markIsPageUsableSent();
            }
          }
          this.publishLog(loggingParams);
        }
      }, {
        key: 'publishLog',
        value: function publishLog(loggingParams) {
          util.sendBeacon('' + this.webPerfLogPublisher + loggingParams, this.beaconImages);
        }
      }, {
        key: 'setConfiguration',
        value: function setConfiguration(params) {
          try {
            util.mergeObjects(this.configuratonParams, params);
          } catch (err) {
            util.consoleError('Something went wrong while setting configuration ' + err);
          }
        }
      }]);
      return WebPerformanceLogger;
    }();
    module.exports = WebPerformanceLogger;

    /***/
  }), (/* 4 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
      return typeof obj;
    } : function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    var _createClass = function () {
      function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }
      return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
      };
    }();
    function _classCallCheck(instance, Constructor) {
      if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
      }
    }
    var util = __webpack_require__(0);
    var ClientLogging = function () {
      function ClientLogging(params) {
        _classCallCheck(this, ClientLogging);
        this.configuration = params || {};
        if (util.isBrowser()) {
          // eslint-disable-next-line global-require
          var ErrorLogger = __webpack_require__(2);
          // eslint-disable-next-line global-require
          var WebPerformanceLogger = __webpack_require__(3);
          this.configuration.attachWindowOnErrorHandler = this.configuration.attachWindowOnErrorHandler || true;
          this.configuration.logErrorOnConsole = this.configuration.logErrorOnConsole || true;
          this.configuration.pageStartTime = this.configuration.pageStartTime || new Date();
          this.configuration.pageName = this.configuration.pageName || 'unknown';
          this.configuration.guid = this.configuration.guid || 'unknown';
          this.configuration.pageStartTime = this.configuration.pageStartTime || util.getCurrentTime();
          this.errorLogger = new ErrorLogger(this.configuration);
          this.webPerformanceLogger = new WebPerformanceLogger(this.configuration);
        }
      }
      _createClass(ClientLogging, [{
        key: 'logMessage',
        value: function logMessage(message, level, additionalData) {
          if (util.isBrowser()) {
            this.errorLogger.logMessage(message, level, additionalData);
          }
        }
      }, {
        key: 'logError',
        value: function logError(message, error, additionalData) {
          if (util.isBrowser()) {
            this.errorLogger.logError(message, error, additionalData);
          }
        }
      }, {
        key: 'subscribeToOnErrorCallback',
        value: function subscribeToOnErrorCallback(callback) {
          if (util.isBrowser()) {
            this.errorLogger.subscribeToOnErrorCallback(callback);
          }
        }
      }, {
        key: 'logTrxEvent',
        value: function logTrxEvent(label, loggingData) {
          if (util.isBrowser()) {
            this.webPerformanceLogger.logTrxEvent(label, loggingData);
          }
        }
      }, {
        key: 'markPageUsable',
        value: function markPageUsable() {
          if (util.isBrowser()) {
            this.webPerformanceLogger.markPageUsable();
          }
        }
      }, {
        key: 'setPageUsableTime',
        value: function setPageUsableTime(pageUsableTime) {
          if (util.isBrowser()) {
            this.webPerformanceLogger.setPageUsableTime(pageUsableTime);
          }
        }
      }, {
        key: 'setConfiguration',
        value: function setConfiguration(params) {
          if (util.isBrowser()) {
            if (params && (typeof params === 'undefined' ? 'undefined' : _typeof(params)) === 'object') {
              util.mergeObjects(this.configuration, params);
              this.errorLogger.setConfiguration(params);
              this.webPerformanceLogger.setConfiguration(params);
            }
          }
        }
      }, {
        key: 'getConfiguration',
        value: function getConfiguration() {
          return this.configuration;
        }
      }]);
      return ClientLogging;
    }();
    module.exports = ClientLogging;

    /***/
  }), (/* 5 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    var util = __webpack_require__(0);
    var populator = __webpack_require__(6);
    function collectDefaultAttributes(configurationParams) {
      return util.getFixedParams(configurationParams) + '&pageName=' + populator.getPageName(configurationParams) + '&guid=' + populator.getGuid(configurationParams) + '&logTime=' + util.expGetISODateString(util.getCurrentDate()) + '&sessionDuration=' + populator.getTimeOnPage();
    }
    function collectNavigationTimings() {
      var navTimings = populator.getNavigationTimings();
      return util.normalizeMessageParams(navTimings);
    }
    function collectPageUsableParameter(pageUsableTime) {
      var pageUsableEntries = typeof pageUsableTime === 'undefined' ? populator.getPageUsable() : pageUsableTime;
      if (!pageUsableEntries || pageUsableEntries === '') {
        return '';
      }
      return 'pageUsableTime=' + pageUsableEntries;
    }
    function collectProvidedAttributes(configurationParams, label, loggingData) {
      var params = [];
      if (label) {
        params = [label + '_elapsedTime=' + (util.getCurrentTime() - populator.getPageStartTime(configurationParams))];
      }
      if (loggingData) {
        params = params.concat(util.normalizeMessageParams(loggingData));
      }
      return 'action=logTrxEvent&' + (params || []).join('&');
    }
    function joinAttributes(attribute1, attribute2) {
      var returnValue = '';
      if (attribute1 && attribute2) {
        returnValue = attribute1 + '&' + attribute2;
      }
      return returnValue;
    }
    module.exports = {
      collectDefaultAttributes: collectDefaultAttributes,
      collectNavigationTimings: collectNavigationTimings,
      collectPageUsableParameter: collectPageUsableParameter,
      collectProvidedAttributes: collectProvidedAttributes,
      joinAttributes: joinAttributes
    };

    /***/
  }), (/* 6 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    var util = __webpack_require__(0);

    /**
     * @return {number|undefined} The duration of the current session in
     *     milliseconds, or `undefined` if it can't be calculated.
     */
    function getTimeOnPage() {
      var firstInteractionTimestamp = void 0;
      var currentTimestamp = util.getCurrentTime();
      var FIRST_INTERACTION_STORAGE_KEY = void 0;
      var LAST_INTERACTION_STORAGE_KEY = void 0;
      var lastInteractionTimestamp = void 0;
      var isSessionExpired = void 0;
      var isSessionNew = void 0;
      try {
        if (!window.localStorage) return 0;
        FIRST_INTERACTION_STORAGE_KEY = 'dctk_clientLogging_firstInteractionTimestamp';
        LAST_INTERACTION_STORAGE_KEY = 'dctk_clientLogging_lastInteractionTimestamp';
        lastInteractionTimestamp = Number(localStorage.getItem(LAST_INTERACTION_STORAGE_KEY));
        firstInteractionTimestamp = Number(localStorage.getItem(FIRST_INTERACTION_STORAGE_KEY));
        isSessionExpired = currentTimestamp - lastInteractionTimestamp > 30 * 60 * 1000;
        isSessionNew = firstInteractionTimestamp === 0;
        if (isSessionExpired || isSessionNew) {
          firstInteractionTimestamp = currentTimestamp;
          localStorage.setItem(FIRST_INTERACTION_STORAGE_KEY, firstInteractionTimestamp);
        }
        lastInteractionTimestamp = currentTimestamp;
        localStorage.setItem(LAST_INTERACTION_STORAGE_KEY, lastInteractionTimestamp);
      } catch (error) {
        firstInteractionTimestamp = currentTimestamp;
        console.log(error + '  dcs:web-perf-logger');
      }
      return currentTimestamp - firstInteractionTimestamp;
    }
    function getPageUsable() {
      if (window.performance) {
        if (window.performance.getEntriesByName) {
          var pageUsableEntries = window.performance.getEntriesByName('Page Usable', 'mark');
          if (!pageUsableEntries || !pageUsableEntries.length) {
            return '';
          }
          return Math.round(pageUsableEntries[0].startTime);
        }
      }
      return '';
    }
    function getNavigationTimings() {
      return {
        unloadTime: getTiming('unloadEventEnd') - getTiming('unloadEventStart'),
        redirectTime: getTiming('redirectEnd') - getTiming('redirectStart'),
        dnsTime: getTiming('domainLookupEnd') - getTiming('domainLookupStart'),
        connectionTime: getTiming('connectEnd') - getTiming('connectStart'),
        requestTime: getTiming('responseStart') - getTiming('requestStart'),
        responseTime: getTiming('responseEnd') - getTiming('responseStart'),
        parsingTime: getTiming('domInteractive') - getTiming('domLoading'),
        domReadyCallbackTime: getTiming('domContentLoadedEventEnd') - getTiming('domContentLoadedEventStart'),
        onLdCallbackTime: getTiming('loadEventEnd') - getTiming('loadEventStart'),
        processingTime: getTiming('domComplete') - getTiming('domLoading'),
        navigationToResponse: getTiming('responseStart') - getTiming('navigationStart'),
        navigationToDomContentLoaded: getTiming('domContentLoadedEventStart') - getTiming('navigationStart'),
        navigationToOnLd: getTiming('loadEventStart') - getTiming('navigationStart'),
        fetchToResponse: getTiming('responseStart') - getTiming('fetchStart'),
        fetchToDomContentLoaded: getTiming('domContentLoadedEventStart') - getTiming('fetchStart'),
        fetchToOnLd: getTiming('loadEventStart') - getTiming('fetchStart'),
        responseToDomContentLoaded: getTiming('domContentLoadedEventStart') - getTiming('responseStart'),
        responseToOnLd: getTiming('loadEventStart') - getTiming('responseStart'),
        navigationToDomInteractive: getTiming('domInteractive') - getTiming('navigationStart')
      };
    }

    /**
     * @param {string} name The name of the property of `performance.timing`
     * @returns {number|NaN} Its value or `NaN` if it doesn't exist (e.g. because
     *     the browser doesn't support the Navigation Timing API) or it's `0`,
     *     (which is the default value when the property could not be calculated)
     */
    function getTiming(name) {
      return window.performance && window.performance.timing && window.performance.timing[name] || NaN;
    }
    function getLoggingData(configurationParams) {
      var dataParams = '';
      if (configurationParams.data) {
        for (var i = 0, dataList = configurationParams.data.split('|'); i < dataList.length && dataList[i].length > 0; i += 1) {
          dataParams += '&' + dataList[i];
        }
      }
      return dataParams;
    }
    function getPageName(configuration) {
      return configuration.pageName || 'unknown';
    }
    function getGuid(configuration) {
      return configuration.guid || 'unknown';
    }
    function getPageStartTime(configuration) {
      var pageStartTime = getTiming('responseStart');
      if (!isNaN(pageStartTime)) {
        configuration.pageStartTime = pageStartTime;
      } else {
        configuration.pageStartTime = configuration.pageStartTime || util.getCurrentTime();
      }
    }
    module.exports = {
      getTimeOnPage: getTimeOnPage,
      getLoggingData: getLoggingData,
      getPageUsable: getPageUsable,
      getNavigationTimings: getNavigationTimings,
      getPageName: getPageName,
      getGuid: getGuid,
      getPageStartTime: getPageStartTime
    };

    /***/
  }), (/* 7 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    var TEST_ENVIRONMENT_REGEX = /(?:(?:test|int|stress)\.expedia\.com|exp-(?:test|int)\.net|karmalab\.net|expedmz.com|staging.*\.(?:traveltainment\.de|myersmediagroup\.com)|localhost|docweb\.exp-tools\.net)$/i; // eslint-disable-line max-len

    function isProductionEnv(domain) {
      return !domain.match(TEST_ENVIRONMENT_REGEX);
    }
    module.exports = {
      isProductionEnv: isProductionEnv
    };

    /***/
  }
  /******/)]);

  /***/
}), (/* 11 */
/***/function (module, exports, __webpack_require__) {
  /* WEBPACK VAR INJECTION */(function (global) {
    /**
    * @license
    * Adobe Visitor API for JavaScript version: 4.4.0
    * Copyright 2019 Adobe, Inc. All Rights Reserved
    * More info available at https://marketing.adobe.com/resources/help/en_US/mcvid/
    */
    var e = function () {
      "use strict";

      function e(t) {
        return (e = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
          return typeof e;
        } : function (e) {
          return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
        })(t);
      }
      function t(e, t, n) {
        return t in e ? Object.defineProperty(e, t, {
          value: n,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }) : e[t] = n, e;
      }
      function n() {
        return {
          callbacks: {},
          add: function (e, t) {
            this.callbacks[e] = this.callbacks[e] || [];
            var n = this.callbacks[e].push(t) - 1,
              i = this;
            return function () {
              i.callbacks[e].splice(n, 1);
            };
          },
          execute: function (e, t) {
            if (this.callbacks[e]) {
              t = void 0 === t ? [] : t, t = t instanceof Array ? t : [t];
              try {
                for (; this.callbacks[e].length;) {
                  var n = this.callbacks[e].shift();
                  "function" == typeof n ? n.apply(null, t) : n instanceof Array && n[1].apply(n[0], t);
                }
                delete this.callbacks[e];
              } catch (e) {}
            }
          },
          executeAll: function (e, t) {
            (t || e && !j.isObjectEmpty(e)) && Object.keys(this.callbacks).forEach(function (t) {
              var n = void 0 !== e[t] ? e[t] : "";
              this.execute(t, n);
            }, this);
          },
          hasCallbacks: function () {
            return Boolean(Object.keys(this.callbacks).length);
          }
        };
      }
      function i(e, t, n) {
        var i = null == e ? void 0 : e[t];
        return void 0 === i ? n : i;
      }
      function r(e) {
        for (var t = /^\d+$/, n = 0, i = e.length; n < i; n++) if (!t.test(e[n])) return !1;
        return !0;
      }
      function a(e, t) {
        for (; e.length < t.length;) e.push("0");
        for (; t.length < e.length;) t.push("0");
      }
      function o(e, t) {
        for (var n = 0; n < e.length; n++) {
          var i = parseInt(e[n], 10),
            r = parseInt(t[n], 10);
          if (i > r) return 1;
          if (r > i) return -1;
        }
        return 0;
      }
      function s(e, t) {
        if (e === t) return 0;
        var n = e.toString().split("."),
          i = t.toString().split(".");
        return r(n.concat(i)) ? (a(n, i), o(n, i)) : NaN;
      }
      function l(e) {
        return e === Object(e) && 0 === Object.keys(e).length;
      }
      function c(e) {
        return "function" == typeof e || e instanceof Array && e.length;
      }
      function u() {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "",
          t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : function () {
            return !0;
          };
        this.log = _e("log", e, t), this.warn = _e("warn", e, t), this.error = _e("error", e, t);
      }
      function d() {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
          t = e.isEnabled,
          n = e.cookieName,
          i = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
          r = i.cookies;
        return t && n && r ? {
          remove: function () {
            r.remove(n);
          },
          get: function () {
            var e = r.get(n),
              t = {};
            try {
              t = JSON.parse(e);
            } catch (e) {
              t = {};
            }
            return t;
          },
          set: function (e, t) {
            t = t || {}, r.set(n, JSON.stringify(e), {
              domain: t.optInCookieDomain || "",
              cookieLifetime: t.optInStorageExpiry || 3419e4,
              expires: !0
            });
          }
        } : {
          get: Le,
          set: Le,
          remove: Le
        };
      }
      function f(e) {
        this.name = this.constructor.name, this.message = e, "function" == typeof Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error(e).stack;
      }
      function p() {
        function e(e, t) {
          var n = Se(e);
          return n.length ? n.every(function (e) {
            return !!t[e];
          }) : De(t);
        }
        function t() {
          M(b), O(ce.COMPLETE), _(h.status, h.permissions), m.set(h.permissions, {
            optInCookieDomain: l,
            optInStorageExpiry: c
          }), C.execute(xe);
        }
        function n(e) {
          return function (n, i) {
            if (!Ae(n)) throw new Error("[OptIn] Invalid category(-ies). Please use the `OptIn.Categories` enum.");
            return O(ce.CHANGED), Object.assign(b, ye(Se(n), e)), i || t(), h;
          };
        }
        var i = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
          r = i.doesOptInApply,
          a = i.previousPermissions,
          o = i.preOptInApprovals,
          s = i.isOptInStorageEnabled,
          l = i.optInCookieDomain,
          c = i.optInStorageExpiry,
          u = i.isIabContext,
          f = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
          p = f.cookies,
          g = Pe(a);
        Re(g, "Invalid `previousPermissions`!"), Re(o, "Invalid `preOptInApprovals`!");
        var m = d({
            isEnabled: !!s,
            cookieName: "adobeujs-optin"
          }, {
            cookies: p
          }),
          h = this,
          _ = le(h),
          C = ge(),
          I = Me(g),
          v = Me(o),
          S = m.get(),
          D = {},
          A = function (e, t) {
            return ke(e) || t && ke(t) ? ce.COMPLETE : ce.PENDING;
          }(I, S),
          y = function (e, t, n) {
            var i = ye(pe, !r);
            return r ? Object.assign({}, i, e, t, n) : i;
          }(v, I, S),
          b = be(y),
          O = function (e) {
            return A = e;
          },
          M = function (e) {
            return y = e;
          };
        h.deny = n(!1), h.approve = n(!0), h.denyAll = h.deny.bind(h, pe), h.approveAll = h.approve.bind(h, pe), h.isApproved = function (t) {
          return e(t, h.permissions);
        }, h.isPreApproved = function (t) {
          return e(t, v);
        }, h.fetchPermissions = function (e) {
          var t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1],
            n = t ? h.on(ce.COMPLETE, e) : Le;
          return !r || r && h.isComplete || !!o ? e(h.permissions) : t || C.add(xe, function () {
            return e(h.permissions);
          }), n;
        }, h.complete = function () {
          h.status === ce.CHANGED && t();
        }, h.registerPlugin = function (e) {
          if (!e || !e.name || "function" != typeof e.onRegister) throw new Error(je);
          D[e.name] || (D[e.name] = e, e.onRegister.call(e, h));
        }, h.execute = Ne(D), Object.defineProperties(h, {
          permissions: {
            get: function () {
              return y;
            }
          },
          status: {
            get: function () {
              return A;
            }
          },
          Categories: {
            get: function () {
              return ue;
            }
          },
          doesOptInApply: {
            get: function () {
              return !!r;
            }
          },
          isPending: {
            get: function () {
              return h.status === ce.PENDING;
            }
          },
          isComplete: {
            get: function () {
              return h.status === ce.COMPLETE;
            }
          },
          __plugins: {
            get: function () {
              return Object.keys(D);
            }
          },
          isIabContext: {
            get: function () {
              return u;
            }
          }
        });
      }
      function g(e, t) {
        function n() {
          r = null, e.call(e, new f("The call took longer than you wanted!"));
        }
        function i() {
          r && (clearTimeout(r), e.apply(e, arguments));
        }
        if (void 0 === t) return e;
        var r = setTimeout(n, t);
        return i;
      }
      function m() {
        if (window.__cmp) return window.__cmp;
        var e = window;
        if (e === window.top) return void Ie.error("__cmp not found");
        for (var t; !t;) {
          e = e.parent;
          try {
            e.frames.__cmpLocator && (t = e);
          } catch (e) {}
          if (e === window.top) break;
        }
        if (!t) return void Ie.error("__cmp not found");
        var n = {};
        return window.__cmp = function (e, i, r) {
          var a = Math.random() + "",
            o = {
              __cmpCall: {
                command: e,
                parameter: i,
                callId: a
              }
            };
          n[a] = r, t.postMessage(o, "*");
        }, window.addEventListener("message", function (e) {
          var t = e.data;
          if ("string" == typeof t) try {
            t = JSON.parse(e.data);
          } catch (e) {}
          if (t.__cmpReturn) {
            var i = t.__cmpReturn;
            n[i.callId] && (n[i.callId](i.returnValue, i.success), delete n[i.callId]);
          }
        }, !1), window.__cmp;
      }
      function h() {
        var e = this;
        e.name = "iabPlugin", e.version = "0.0.1";
        var t = ge(),
          n = {
            allConsentData: null
          },
          i = function (e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
            return n[e] = t;
          };
        e.fetchConsentData = function (e) {
          var t = e.callback,
            n = e.timeout,
            i = g(t, n);
          r({
            callback: i
          });
        }, e.isApproved = function (e) {
          var t = e.callback,
            i = e.category,
            a = e.timeout;
          if (n.allConsentData) return t(null, s(i, n.allConsentData.vendorConsents, n.allConsentData.purposeConsents));
          var o = g(function (e) {
            var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
              r = n.vendorConsents,
              a = n.purposeConsents;
            t(e, s(i, r, a));
          }, a);
          r({
            category: i,
            callback: o
          });
        }, e.onRegister = function (t) {
          var n = Object.keys(de),
            i = function (e) {
              var i = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
                r = i.purposeConsents,
                a = i.gdprApplies,
                o = i.vendorConsents;
              !e && a && o && r && (n.forEach(function (e) {
                var n = s(e, o, r);
                t[n ? "approve" : "deny"](e, !0);
              }), t.complete());
            };
          e.fetchConsentData({
            callback: i
          });
        };
        var r = function (e) {
            var r = e.callback;
            if (n.allConsentData) return r(null, n.allConsentData);
            t.add("FETCH_CONSENT_DATA", r);
            var s = {};
            o(function () {
              var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
                r = e.purposeConsents,
                o = e.gdprApplies,
                l = e.vendorConsents;
              (arguments.length > 1 ? arguments[1] : void 0) && (s = {
                purposeConsents: r,
                gdprApplies: o,
                vendorConsents: l
              }, i("allConsentData", s)), a(function () {
                var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                (arguments.length > 1 ? arguments[1] : void 0) && (s.consentString = e.consentData, i("allConsentData", s)), t.execute("FETCH_CONSENT_DATA", [null, n.allConsentData]);
              });
            });
          },
          a = function (e) {
            var t = m();
            t && t("getConsentData", null, e);
          },
          o = function (e) {
            var t = Fe(de),
              n = m();
            n && n("getVendorConsents", t, e);
          },
          s = function (e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
              n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
              i = !!t[de[e]];
            return i && function () {
              return fe[e].every(function (e) {
                return n[e];
              });
            }();
          };
      }
      var _ = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self ? self : {};
      Object.assign = Object.assign || function (e) {
        for (var t, n, i = 1; i < arguments.length; ++i) {
          n = arguments[i];
          for (t in n) Object.prototype.hasOwnProperty.call(n, t) && (e[t] = n[t]);
        }
        return e;
      };
      var C,
        I,
        v = {
          HANDSHAKE: "HANDSHAKE",
          GETSTATE: "GETSTATE",
          PARENTSTATE: "PARENTSTATE"
        },
        S = {
          MCMID: "MCMID",
          MCAID: "MCAID",
          MCAAMB: "MCAAMB",
          MCAAMLH: "MCAAMLH",
          MCOPTOUT: "MCOPTOUT",
          CUSTOMERIDS: "CUSTOMERIDS"
        },
        D = {
          MCMID: "getMarketingCloudVisitorID",
          MCAID: "getAnalyticsVisitorID",
          MCAAMB: "getAudienceManagerBlob",
          MCAAMLH: "getAudienceManagerLocationHint",
          MCOPTOUT: "isOptedOut",
          ALLFIELDS: "getVisitorValues"
        },
        A = {
          CUSTOMERIDS: "getCustomerIDs"
        },
        y = {
          MCMID: "getMarketingCloudVisitorID",
          MCAAMB: "getAudienceManagerBlob",
          MCAAMLH: "getAudienceManagerLocationHint",
          MCOPTOUT: "isOptedOut",
          MCAID: "getAnalyticsVisitorID",
          CUSTOMERIDS: "getCustomerIDs",
          ALLFIELDS: "getVisitorValues"
        },
        b = {
          MC: "MCMID",
          A: "MCAID",
          AAM: "MCAAMB"
        },
        O = {
          MCMID: "MCMID",
          MCOPTOUT: "MCOPTOUT",
          MCAID: "MCAID",
          MCAAMLH: "MCAAMLH",
          MCAAMB: "MCAAMB"
        },
        M = {
          UNKNOWN: 0,
          AUTHENTICATED: 1,
          LOGGED_OUT: 2
        },
        k = {
          GLOBAL: "global"
        },
        E = {
          MESSAGES: v,
          STATE_KEYS_MAP: S,
          ASYNC_API_MAP: D,
          SYNC_API_MAP: A,
          ALL_APIS: y,
          FIELDGROUP_TO_FIELD: b,
          FIELDS: O,
          AUTH_STATE: M,
          OPT_OUT: k
        },
        T = E.STATE_KEYS_MAP,
        L = function (e) {
          function t() {}
          function n(t, n) {
            var i = this;
            return function () {
              var r = e(0, t),
                a = {};
              return a[t] = r, i.setStateAndPublish(a), n(r), r;
            };
          }
          this.getMarketingCloudVisitorID = function (e) {
            e = e || t;
            var i = this.findField(T.MCMID, e),
              r = n.call(this, T.MCMID, e);
            return void 0 !== i ? i : r();
          }, this.getVisitorValues = function (e) {
            this.getMarketingCloudVisitorID(function (t) {
              e({
                MCMID: t
              });
            });
          };
        },
        P = E.MESSAGES,
        R = E.ASYNC_API_MAP,
        w = E.SYNC_API_MAP,
        F = function () {
          function e() {}
          function t(e, t) {
            var n = this;
            return function () {
              return n.callbackRegistry.add(e, t), n.messageParent(P.GETSTATE), "";
            };
          }
          function n(n) {
            this[R[n]] = function (i) {
              i = i || e;
              var r = this.findField(n, i),
                a = t.call(this, n, i);
              return void 0 !== r ? r : a();
            };
          }
          function i(t) {
            this[w[t]] = function () {
              return this.findField(t, e) || {};
            };
          }
          Object.keys(R).forEach(n, this), Object.keys(w).forEach(i, this);
        },
        N = E.ASYNC_API_MAP,
        x = function () {
          Object.keys(N).forEach(function (e) {
            this[N[e]] = function (t) {
              this.callbackRegistry.add(e, t);
            };
          }, this);
        },
        j = function (e, t) {
          return t = {
            exports: {}
          }, e(t, t.exports), t.exports;
        }(function (t, n) {
          n.isObjectEmpty = function (e) {
            return e === Object(e) && 0 === Object.keys(e).length;
          }, n.isValueEmpty = function (e) {
            return "" === e || n.isObjectEmpty(e);
          }, n.getIeVersion = function () {
            if (document.documentMode) return document.documentMode;
            for (var e = 7; e > 4; e--) {
              var t = document.createElement("div");
              if (t.innerHTML = "\x3c!--[if IE " + e + "]><span></span><![endif]--\x3e", t.getElementsByTagName("span").length) return t = null, e;
              t = null;
            }
            return null;
          }, n.encodeAndBuildRequest = function (e, t) {
            return e.map(encodeURIComponent).join(t);
          }, n.isObject = function (t) {
            return null !== t && "object" === e(t) && !1 === Array.isArray(t);
          }, n.defineGlobalNamespace = function () {
            return window.adobe = n.isObject(window.adobe) ? window.adobe : {}, window.adobe;
          }, n.pluck = function (e, t) {
            return t.reduce(function (t, n) {
              return e[n] && (t[n] = e[n]), t;
            }, Object.create(null));
          }, n.parseOptOut = function (e, t, n) {
            t || (t = n, e.d_optout && e.d_optout instanceof Array && (t = e.d_optout.join(",")));
            var i = parseInt(e.d_ottl, 10);
            return isNaN(i) && (i = 7200), {
              optOut: t,
              d_ottl: i
            };
          }, n.normalizeBoolean = function (e) {
            var t = e;
            return "true" === e ? t = !0 : "false" === e && (t = !1), t;
          };
        }),
        V = (j.isObjectEmpty, j.isValueEmpty, j.getIeVersion, j.encodeAndBuildRequest, j.isObject, j.defineGlobalNamespace, j.pluck, j.parseOptOut, j.normalizeBoolean, n),
        H = E.MESSAGES,
        U = {
          0: "prefix",
          1: "orgID",
          2: "state"
        },
        B = function (e, t) {
          this.parse = function (e) {
            try {
              var t = {};
              return e.data.split("|").forEach(function (e, n) {
                if (void 0 !== e) {
                  t[U[n]] = 2 !== n ? e : JSON.parse(e);
                }
              }), t;
            } catch (e) {}
          }, this.isInvalid = function (n) {
            var i = this.parse(n);
            if (!i || Object.keys(i).length < 2) return !0;
            var r = e !== i.orgID,
              a = !t || n.origin !== t,
              o = -1 === Object.keys(H).indexOf(i.prefix);
            return r || a || o;
          }, this.send = function (n, i, r) {
            var a = i + "|" + e;
            r && r === Object(r) && (a += "|" + JSON.stringify(r));
            try {
              n.postMessage(a, t);
            } catch (e) {}
          };
        },
        G = E.MESSAGES,
        Y = function (e, t, n, i) {
          function r(e) {
            Object.assign(p, e);
          }
          function a(e) {
            Object.assign(p.state, e), Object.assign(p.state.ALLFIELDS, e), p.callbackRegistry.executeAll(p.state);
          }
          function o(e) {
            if (!h.isInvalid(e)) {
              m = !1;
              var t = h.parse(e);
              p.setStateAndPublish(t.state);
            }
          }
          function s(e) {
            !m && g && (m = !0, h.send(i, e));
          }
          function l() {
            r(new L(n._generateID)), p.getMarketingCloudVisitorID(), p.callbackRegistry.executeAll(p.state, !0), _.removeEventListener("message", c);
          }
          function c(e) {
            if (!h.isInvalid(e)) {
              var t = h.parse(e);
              m = !1, _.clearTimeout(p._handshakeTimeout), _.removeEventListener("message", c), r(new F(p)), _.addEventListener("message", o), p.setStateAndPublish(t.state), p.callbackRegistry.hasCallbacks() && s(G.GETSTATE);
            }
          }
          function u() {
            g && postMessage ? (_.addEventListener("message", c), s(G.HANDSHAKE), p._handshakeTimeout = setTimeout(l, 250)) : l();
          }
          function d() {
            _.s_c_in || (_.s_c_il = [], _.s_c_in = 0), p._c = "Visitor", p._il = _.s_c_il, p._in = _.s_c_in, p._il[p._in] = p, _.s_c_in++;
          }
          function f() {
            function e(e) {
              0 !== e.indexOf("_") && "function" == typeof n[e] && (p[e] = function () {});
            }
            Object.keys(n).forEach(e), p.getSupplementalDataID = n.getSupplementalDataID, p.isAllowed = function () {
              return !0;
            };
          }
          var p = this,
            g = t.whitelistParentDomain;
          p.state = {
            ALLFIELDS: {}
          }, p.version = n.version, p.marketingCloudOrgID = e, p.cookieDomain = n.cookieDomain || "", p._instanceType = "child";
          var m = !1,
            h = new B(e, g);
          p.callbackRegistry = V(), p.init = function () {
            d(), f(), r(new x(p)), u();
          }, p.findField = function (e, t) {
            if (void 0 !== p.state[e]) return t(p.state[e]), p.state[e];
          }, p.messageParent = s, p.setStateAndPublish = a;
        },
        q = E.MESSAGES,
        X = E.ALL_APIS,
        W = E.ASYNC_API_MAP,
        J = E.FIELDGROUP_TO_FIELD,
        K = function (e, t) {
          function n() {
            var t = {};
            return Object.keys(X).forEach(function (n) {
              var i = X[n],
                r = e[i]();
              j.isValueEmpty(r) || (t[n] = r);
            }), t;
          }
          function i() {
            var t = [];
            return e._loading && Object.keys(e._loading).forEach(function (n) {
              if (e._loading[n]) {
                var i = J[n];
                t.push(i);
              }
            }), t.length ? t : null;
          }
          function r(t) {
            return function n(r) {
              var a = i();
              if (a) {
                var o = W[a[0]];
                e[o](n, !0);
              } else t();
            };
          }
          function a(e, i) {
            var r = n();
            t.send(e, i, r);
          }
          function o(e) {
            l(e), a(e, q.HANDSHAKE);
          }
          function s(e) {
            r(function () {
              a(e, q.PARENTSTATE);
            })();
          }
          function l(n) {
            function i(i) {
              r.call(e, i), t.send(n, q.PARENTSTATE, {
                CUSTOMERIDS: e.getCustomerIDs()
              });
            }
            var r = e.setCustomerIDs;
            e.setCustomerIDs = i;
          }
          return function (e) {
            if (!t.isInvalid(e)) {
              (t.parse(e).prefix === q.HANDSHAKE ? o : s)(e.source);
            }
          };
        },
        z = function (e, t) {
          function n(e) {
            return function (n) {
              i[e] = n, r++, r === a && t(i);
            };
          }
          var i = {},
            r = 0,
            a = Object.keys(e).length;
          Object.keys(e).forEach(function (t) {
            var i = e[t];
            if (i.fn) {
              var r = i.args || [];
              r.unshift(n(t)), i.fn.apply(i.context || null, r);
            }
          });
        },
        Q = {
          get: function (e) {
            e = encodeURIComponent(e);
            var t = (";" + document.cookie).split(" ").join(";"),
              n = t.indexOf(";" + e + "="),
              i = n < 0 ? n : t.indexOf(";", n + 1);
            return n < 0 ? "" : decodeURIComponent(t.substring(n + 2 + e.length, i < 0 ? t.length : i));
          },
          set: function (e, t, n) {
            var r = i(n, "cookieLifetime"),
              a = i(n, "expires"),
              o = i(n, "domain"),
              s = i(n, "secure"),
              l = s ? "Secure" : "";
            if (a && "SESSION" !== r && "NONE" !== r) {
              var c = "" !== t ? parseInt(r || 0, 10) : -60;
              if (c) a = new Date(), a.setTime(a.getTime() + 1e3 * c);else if (1 === a) {
                a = new Date();
                var u = a.getYear();
                a.setYear(u + 2 + (u < 1900 ? 1900 : 0));
              }
            } else a = 0;
            return e && "NONE" !== r ? (document.cookie = encodeURIComponent(e) + "=" + encodeURIComponent(t) + "; path=/;" + (a ? " expires=" + a.toGMTString() + ";" : "") + (o ? " domain=" + o + ";" : "") + l, this.get(e) === t) : 0;
          },
          remove: function (e, t) {
            var n = i(t, "domain");
            n = n ? " domain=" + n + ";" : "", document.cookie = encodeURIComponent(e) + "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;" + n;
          }
        },
        $ = function (e) {
          var t;
          !e && _.location && (e = _.location.hostname), t = e;
          var n,
            i = t.split(".");
          for (n = i.length - 2; n >= 0; n--) if (t = i.slice(n).join("."), Q.set("test", "cookie", {
            domain: t
          })) return Q.remove("test", {
            domain: t
          }), t;
          return "";
        },
        Z = {
          compare: s,
          isLessThan: function (e, t) {
            return s(e, t) < 0;
          },
          areVersionsDifferent: function (e, t) {
            return 0 !== s(e, t);
          },
          isGreaterThan: function (e, t) {
            return s(e, t) > 0;
          },
          isEqual: function (e, t) {
            return 0 === s(e, t);
          }
        },
        ee = !!_.postMessage,
        te = {
          postMessage: function (e, t, n) {
            var i = 1;
            t && (ee ? n.postMessage(e, t.replace(/([^:]+:\/\/[^\/]+).*/, "$1")) : t && (n.location = t.replace(/#.*$/, "") + "#" + +new Date() + i++ + "&" + e));
          },
          receiveMessage: function (e, t) {
            var n;
            try {
              ee && (e && (n = function (n) {
                if ("string" == typeof t && n.origin !== t || "[object Function]" === Object.prototype.toString.call(t) && !1 === t(n.origin)) return !1;
                e(n);
              }), _.addEventListener ? _[e ? "addEventListener" : "removeEventListener"]("message", n) : _[e ? "attachEvent" : "detachEvent"]("onmessage", n));
            } catch (e) {}
          }
        },
        ne = function (e) {
          var t,
            n,
            i = "0123456789",
            r = "",
            a = "",
            o = 8,
            s = 10,
            l = 10;
          if (1 == e) {
            for (i += "ABCDEF", t = 0; 16 > t; t++) n = Math.floor(Math.random() * o), r += i.substring(n, n + 1), n = Math.floor(Math.random() * o), a += i.substring(n, n + 1), o = 16;
            return r + "-" + a;
          }
          for (t = 0; 19 > t; t++) n = Math.floor(Math.random() * s), r += i.substring(n, n + 1), 0 === t && 9 == n ? s = 3 : (1 == t || 2 == t) && 10 != s && 2 > n ? s = 10 : 2 < t && (s = 10), n = Math.floor(Math.random() * l), a += i.substring(n, n + 1), 0 === t && 9 == n ? l = 3 : (1 == t || 2 == t) && 10 != l && 2 > n ? l = 10 : 2 < t && (l = 10);
          return r + a;
        },
        ie = function (e, t) {
          return {
            corsMetadata: function () {
              var e = "none",
                t = !0;
              return "undefined" != typeof XMLHttpRequest && XMLHttpRequest === Object(XMLHttpRequest) && ("withCredentials" in new XMLHttpRequest() ? e = "XMLHttpRequest" : "undefined" != typeof XDomainRequest && XDomainRequest === Object(XDomainRequest) && (t = !1), Object.prototype.toString.call(_.HTMLElement).indexOf("Constructor") > 0 && (t = !1)), {
                corsType: e,
                corsCookiesEnabled: t
              };
            }(),
            getCORSInstance: function () {
              return "none" === this.corsMetadata.corsType ? null : new _[this.corsMetadata.corsType]();
            },
            fireCORS: function (t, n, i) {
              function r(e) {
                var n;
                try {
                  if ((n = JSON.parse(e)) !== Object(n)) return void a.handleCORSError(t, null, "Response is not JSON");
                } catch (e) {
                  return void a.handleCORSError(t, e, "Error parsing response as JSON");
                }
                try {
                  for (var i = t.callback, r = _, o = 0; o < i.length; o++) r = r[i[o]];
                  r(n);
                } catch (e) {
                  a.handleCORSError(t, e, "Error forming callback function");
                }
              }
              var a = this;
              n && (t.loadErrorHandler = n);
              try {
                var o = this.getCORSInstance();
                o.open("get", t.corsUrl + "&ts=" + new Date().getTime(), !0), "XMLHttpRequest" === this.corsMetadata.corsType && (o.withCredentials = !0, o.timeout = e.loadTimeout, o.setRequestHeader("Content-Type", "application/x-www-form-urlencoded"), o.onreadystatechange = function () {
                  4 === this.readyState && 200 === this.status && r(this.responseText);
                }), o.onerror = function (e) {
                  a.handleCORSError(t, e, "onerror");
                }, o.ontimeout = function (e) {
                  a.handleCORSError(t, e, "ontimeout");
                }, o.send(), e._log.requests.push(t.corsUrl);
              } catch (e) {
                this.handleCORSError(t, e, "try-catch");
              }
            },
            handleCORSError: function (t, n, i) {
              e.CORSErrors.push({
                corsData: t,
                error: n,
                description: i
              }), t.loadErrorHandler && ("ontimeout" === i ? t.loadErrorHandler(!0) : t.loadErrorHandler(!1));
            }
          };
        },
        re = {
          POST_MESSAGE_ENABLED: !!_.postMessage,
          DAYS_BETWEEN_SYNC_ID_CALLS: 1,
          MILLIS_PER_DAY: 864e5,
          ADOBE_MC: "adobe_mc",
          ADOBE_MC_SDID: "adobe_mc_sdid",
          VALID_VISITOR_ID_REGEX: /^[0-9a-fA-F\-]+$/,
          ADOBE_MC_TTL_IN_MIN: 5,
          VERSION_REGEX: /vVersion\|((\d+\.)?(\d+\.)?(\*|\d+))(?=$|\|)/,
          FIRST_PARTY_SERVER_COOKIE: "s_ecid"
        },
        ae = function (e, t) {
          var n = _.document;
          return {
            THROTTLE_START: 3e4,
            MAX_SYNCS_LENGTH: 649,
            throttleTimerSet: !1,
            id: null,
            onPagePixels: [],
            iframeHost: null,
            getIframeHost: function (e) {
              if ("string" == typeof e) {
                var t = e.split("/");
                return t[0] + "//" + t[2];
              }
            },
            subdomain: null,
            url: null,
            getUrl: function () {
              var t,
                i = "http://fast.",
                r = "?d_nsid=" + e.idSyncContainerID + "#" + encodeURIComponent(n.location.origin);
              return this.subdomain || (this.subdomain = "nosubdomainreturned"), e.loadSSL && (i = e.idSyncSSLUseAkamai ? "https://fast." : "https://"), t = i + this.subdomain + ".demdex.net/dest5.html" + r, this.iframeHost = this.getIframeHost(t), this.id = "destination_publishing_iframe_" + this.subdomain + "_" + e.idSyncContainerID, t;
            },
            checkDPIframeSrc: function () {
              var t = "?d_nsid=" + e.idSyncContainerID + "#" + encodeURIComponent(n.location.href);
              "string" == typeof e.dpIframeSrc && e.dpIframeSrc.length && (this.id = "destination_publishing_iframe_" + (e._subdomain || this.subdomain || new Date().getTime()) + "_" + e.idSyncContainerID, this.iframeHost = this.getIframeHost(e.dpIframeSrc), this.url = e.dpIframeSrc + t);
            },
            idCallNotProcesssed: null,
            doAttachIframe: !1,
            startedAttachingIframe: !1,
            iframeHasLoaded: null,
            iframeIdChanged: null,
            newIframeCreated: null,
            originalIframeHasLoadedAlready: null,
            iframeLoadedCallbacks: [],
            regionChanged: !1,
            timesRegionChanged: 0,
            sendingMessages: !1,
            messages: [],
            messagesPosted: [],
            messagesReceived: [],
            messageSendingInterval: re.POST_MESSAGE_ENABLED ? null : 100,
            onPageDestinationsFired: [],
            jsonForComparison: [],
            jsonDuplicates: [],
            jsonWaiting: [],
            jsonProcessed: [],
            canSetThirdPartyCookies: !0,
            receivedThirdPartyCookiesNotification: !1,
            readyToAttachIframePreliminary: function () {
              return !(e.idSyncDisableSyncs || e.disableIdSyncs || e.idSyncDisable3rdPartySyncing || e.disableThirdPartyCookies || e.disableThirdPartyCalls);
            },
            readyToAttachIframe: function () {
              return this.readyToAttachIframePreliminary() && (this.doAttachIframe || e._doAttachIframe) && (this.subdomain && "nosubdomainreturned" !== this.subdomain || e._subdomain) && this.url && !this.startedAttachingIframe;
            },
            attachIframe: function () {
              function e() {
                r = n.createElement("iframe"), r.sandbox = "allow-scripts allow-same-origin", r.title = "Adobe ID Syncing iFrame", r.id = i.id, r.name = i.id + "_name", r.style.cssText = "display: none; width: 0; height: 0;", r.src = i.url, i.newIframeCreated = !0, t(), n.body.appendChild(r);
              }
              function t(e) {
                r.addEventListener("load", function () {
                  r.className = "aamIframeLoaded", i.iframeHasLoaded = !0, i.fireIframeLoadedCallbacks(e), i.requestToProcess();
                });
              }
              this.startedAttachingIframe = !0;
              var i = this,
                r = n.getElementById(this.id);
              r ? "IFRAME" !== r.nodeName ? (this.id += "_2", this.iframeIdChanged = !0, e()) : (this.newIframeCreated = !1, "aamIframeLoaded" !== r.className ? (this.originalIframeHasLoadedAlready = !1, t("The destination publishing iframe already exists from a different library, but hadn't loaded yet.")) : (this.originalIframeHasLoadedAlready = !0, this.iframeHasLoaded = !0, this.iframe = r, this.fireIframeLoadedCallbacks("The destination publishing iframe already exists from a different library, and had loaded alresady."), this.requestToProcess())) : e(), this.iframe = r;
            },
            fireIframeLoadedCallbacks: function (e) {
              this.iframeLoadedCallbacks.forEach(function (t) {
                "function" == typeof t && t({
                  message: e || "The destination publishing iframe was attached and loaded successfully."
                });
              }), this.iframeLoadedCallbacks = [];
            },
            requestToProcess: function (t) {
              function n() {
                r.jsonForComparison.push(t), r.jsonWaiting.push(t), r.processSyncOnPage(t);
              }
              var i,
                r = this;
              if (t === Object(t) && t.ibs) if (i = JSON.stringify(t.ibs || []), this.jsonForComparison.length) {
                var a,
                  o,
                  s,
                  l = !1;
                for (a = 0, o = this.jsonForComparison.length; a < o; a++) if (s = this.jsonForComparison[a], i === JSON.stringify(s.ibs || [])) {
                  l = !0;
                  break;
                }
                l ? this.jsonDuplicates.push(t) : n();
              } else n();
              if ((this.receivedThirdPartyCookiesNotification || !re.POST_MESSAGE_ENABLED || this.iframeHasLoaded) && this.jsonWaiting.length) {
                var c = this.jsonWaiting.shift();
                this.process(c), this.requestToProcess();
              }
              e.idSyncDisableSyncs || e.disableIdSyncs || !this.iframeHasLoaded || !this.messages.length || this.sendingMessages || (this.throttleTimerSet || (this.throttleTimerSet = !0, setTimeout(function () {
                r.messageSendingInterval = re.POST_MESSAGE_ENABLED ? null : 150;
              }, this.THROTTLE_START)), this.sendingMessages = !0, this.sendMessages());
            },
            getRegionAndCheckIfChanged: function (t, n) {
              var i = e._getField("MCAAMLH"),
                r = t.d_region || t.dcs_region;
              return i ? r && (e._setFieldExpire("MCAAMLH", n), e._setField("MCAAMLH", r), parseInt(i, 10) !== r && (this.regionChanged = !0, this.timesRegionChanged++, e._setField("MCSYNCSOP", ""), e._setField("MCSYNCS", ""), i = r)) : (i = r) && (e._setFieldExpire("MCAAMLH", n), e._setField("MCAAMLH", i)), i || (i = ""), i;
            },
            processSyncOnPage: function (e) {
              var t, n, i, r;
              if ((t = e.ibs) && t instanceof Array && (n = t.length)) for (i = 0; i < n; i++) r = t[i], r.syncOnPage && this.checkFirstPartyCookie(r, "", "syncOnPage");
            },
            process: function (e) {
              var t,
                n,
                i,
                r,
                a,
                o = encodeURIComponent,
                s = !1;
              if ((t = e.ibs) && t instanceof Array && (n = t.length)) for (s = !0, i = 0; i < n; i++) r = t[i], a = [o("ibs"), o(r.id || ""), o(r.tag || ""), j.encodeAndBuildRequest(r.url || [], ","), o(r.ttl || ""), "", "", r.fireURLSync ? "true" : "false"], r.syncOnPage || (this.canSetThirdPartyCookies ? this.addMessage(a.join("|")) : r.fireURLSync && this.checkFirstPartyCookie(r, a.join("|")));
              s && this.jsonProcessed.push(e);
            },
            checkFirstPartyCookie: function (t, n, i) {
              var r = "syncOnPage" === i,
                a = r ? "MCSYNCSOP" : "MCSYNCS";
              e._readVisitor();
              var o,
                s,
                l = e._getField(a),
                c = !1,
                u = !1,
                d = Math.ceil(new Date().getTime() / re.MILLIS_PER_DAY);
              l ? (o = l.split("*"), s = this.pruneSyncData(o, t.id, d), c = s.dataPresent, u = s.dataValid, c && u || this.fireSync(r, t, n, o, a, d)) : (o = [], this.fireSync(r, t, n, o, a, d));
            },
            pruneSyncData: function (e, t, n) {
              var i,
                r,
                a,
                o = !1,
                s = !1;
              for (r = 0; r < e.length; r++) i = e[r], a = parseInt(i.split("-")[1], 10), i.match("^" + t + "-") ? (o = !0, n < a ? s = !0 : (e.splice(r, 1), r--)) : n >= a && (e.splice(r, 1), r--);
              return {
                dataPresent: o,
                dataValid: s
              };
            },
            manageSyncsSize: function (e) {
              if (e.join("*").length > this.MAX_SYNCS_LENGTH) for (e.sort(function (e, t) {
                return parseInt(e.split("-")[1], 10) - parseInt(t.split("-")[1], 10);
              }); e.join("*").length > this.MAX_SYNCS_LENGTH;) e.shift();
            },
            fireSync: function (t, n, i, r, a, o) {
              var s = this;
              if (t) {
                if ("img" === n.tag) {
                  var l,
                    c,
                    u,
                    d,
                    f = n.url,
                    p = e.loadSSL ? "https:" : "http:";
                  for (l = 0, c = f.length; l < c; l++) {
                    u = f[l], d = /^\/\//.test(u);
                    var g = new Image();
                    g.addEventListener("load", function (t, n, i, r) {
                      return function () {
                        s.onPagePixels[t] = null, e._readVisitor();
                        var o,
                          l = e._getField(a),
                          c = [];
                        if (l) {
                          o = l.split("*");
                          var u, d, f;
                          for (u = 0, d = o.length; u < d; u++) f = o[u], f.match("^" + n.id + "-") || c.push(f);
                        }
                        s.setSyncTrackingData(c, n, i, r);
                      };
                    }(this.onPagePixels.length, n, a, o)), g.src = (d ? p : "") + u, this.onPagePixels.push(g);
                  }
                }
              } else this.addMessage(i), this.setSyncTrackingData(r, n, a, o);
            },
            addMessage: function (t) {
              var n = encodeURIComponent,
                i = n(e._enableErrorReporting ? "---destpub-debug---" : "---destpub---");
              this.messages.push((re.POST_MESSAGE_ENABLED ? "" : i) + t);
            },
            setSyncTrackingData: function (t, n, i, r) {
              t.push(n.id + "-" + (r + Math.ceil(n.ttl / 60 / 24))), this.manageSyncsSize(t), e._setField(i, t.join("*"));
            },
            sendMessages: function () {
              var e,
                t = this,
                n = "",
                i = encodeURIComponent;
              this.regionChanged && (n = i("---destpub-clear-dextp---"), this.regionChanged = !1), this.messages.length ? re.POST_MESSAGE_ENABLED ? (e = n + i("---destpub-combined---") + this.messages.join("%01"), this.postMessage(e), this.messages = [], this.sendingMessages = !1) : (e = this.messages.shift(), this.postMessage(n + e), setTimeout(function () {
                t.sendMessages();
              }, this.messageSendingInterval)) : this.sendingMessages = !1;
            },
            postMessage: function (e) {
              te.postMessage(e, this.url, this.iframe.contentWindow), this.messagesPosted.push(e);
            },
            receiveMessage: function (e) {
              var t,
                n = /^---destpub-to-parent---/;
              "string" == typeof e && n.test(e) && (t = e.replace(n, "").split("|"), "canSetThirdPartyCookies" === t[0] && (this.canSetThirdPartyCookies = "true" === t[1], this.receivedThirdPartyCookiesNotification = !0, this.requestToProcess()), this.messagesReceived.push(e));
            },
            processIDCallData: function (i) {
              (null == this.url || i.subdomain && "nosubdomainreturned" === this.subdomain) && ("string" == typeof e._subdomain && e._subdomain.length ? this.subdomain = e._subdomain : this.subdomain = i.subdomain || "", this.url = this.getUrl()), i.ibs instanceof Array && i.ibs.length && (this.doAttachIframe = !0), this.readyToAttachIframe() && (e.idSyncAttachIframeOnWindowLoad ? (t.windowLoaded || "complete" === n.readyState || "loaded" === n.readyState) && this.attachIframe() : this.attachIframeASAP()), "function" == typeof e.idSyncIDCallResult ? e.idSyncIDCallResult(i) : this.requestToProcess(i), "function" == typeof e.idSyncAfterIDCallResult && e.idSyncAfterIDCallResult(i);
            },
            canMakeSyncIDCall: function (t, n) {
              return e._forceSyncIDCall || !t || n - t > re.DAYS_BETWEEN_SYNC_ID_CALLS;
            },
            attachIframeASAP: function () {
              function e() {
                t.startedAttachingIframe || (n.body ? t.attachIframe() : setTimeout(e, 30));
              }
              var t = this;
              e();
            }
          };
        },
        oe = {
          audienceManagerServer: {},
          audienceManagerServerSecure: {},
          cookieDomain: {},
          cookieLifetime: {},
          cookieName: {},
          doesOptInApply: {},
          disableThirdPartyCalls: {},
          discardTrackingServerECID: {},
          idSyncAfterIDCallResult: {},
          idSyncAttachIframeOnWindowLoad: {},
          idSyncContainerID: {},
          idSyncDisable3rdPartySyncing: {},
          disableThirdPartyCookies: {},
          idSyncDisableSyncs: {},
          disableIdSyncs: {},
          idSyncIDCallResult: {},
          idSyncSSLUseAkamai: {},
          isCoopSafe: {},
          isIabContext: {},
          isOptInStorageEnabled: {},
          loadSSL: {},
          loadTimeout: {},
          marketingCloudServer: {},
          marketingCloudServerSecure: {},
          optInCookieDomain: {},
          optInStorageExpiry: {},
          overwriteCrossDomainMCIDAndAID: {},
          preOptInApprovals: {},
          previousPermissions: {},
          resetBeforeVersion: {},
          sdidParamExpiry: {},
          serverState: {},
          sessionCookieName: {},
          secureCookie: {},
          takeTimeoutMetrics: {},
          trackingServer: {},
          trackingServerSecure: {},
          whitelistIframeDomains: {},
          whitelistParentDomain: {}
        },
        se = {
          getConfigNames: function () {
            return Object.keys(oe);
          },
          getConfigs: function () {
            return oe;
          },
          normalizeConfig: function (e) {
            return "function" != typeof e ? e : e();
          }
        },
        le = function (e) {
          var t = {};
          return e.on = function (e, n, i) {
            if (!n || "function" != typeof n) throw new Error("[ON] Callback should be a function.");
            t.hasOwnProperty(e) || (t[e] = []);
            var r = t[e].push({
              callback: n,
              context: i
            }) - 1;
            return function () {
              t[e].splice(r, 1), t[e].length || delete t[e];
            };
          }, e.off = function (e, n) {
            t.hasOwnProperty(e) && (t[e] = t[e].filter(function (e) {
              if (e.callback !== n) return e;
            }));
          }, e.publish = function (e) {
            if (t.hasOwnProperty(e)) {
              var n = [].slice.call(arguments, 1);
              t[e].slice(0).forEach(function (e) {
                e.callback.apply(e.context, n);
              });
            }
          }, e.publish;
        },
        ce = {
          PENDING: "pending",
          CHANGED: "changed",
          COMPLETE: "complete"
        },
        ue = {
          AAM: "aam",
          ADCLOUD: "adcloud",
          ANALYTICS: "aa",
          CAMPAIGN: "campaign",
          ECID: "ecid",
          LIVEFYRE: "livefyre",
          TARGET: "target",
          VIDEO_ANALYTICS: "videoaa"
        },
        de = (C = {}, t(C, ue.AAM, 565), t(C, ue.ECID, 565), C),
        fe = (I = {}, t(I, ue.AAM, [1, 2, 5]), t(I, ue.ECID, [1, 2, 5]), I),
        pe = function (e) {
          return Object.keys(e).map(function (t) {
            return e[t];
          });
        }(ue),
        ge = function () {
          var e = {};
          return e.callbacks = Object.create(null), e.add = function (t, n) {
            if (!c(n)) throw new Error("[callbackRegistryFactory] Make sure callback is a function or an array of functions.");
            e.callbacks[t] = e.callbacks[t] || [];
            var i = e.callbacks[t].push(n) - 1;
            return function () {
              e.callbacks[t].splice(i, 1);
            };
          }, e.execute = function (t, n) {
            if (e.callbacks[t]) {
              n = void 0 === n ? [] : n, n = n instanceof Array ? n : [n];
              try {
                for (; e.callbacks[t].length;) {
                  var i = e.callbacks[t].shift();
                  "function" == typeof i ? i.apply(null, n) : i instanceof Array && i[1].apply(i[0], n);
                }
                delete e.callbacks[t];
              } catch (e) {}
            }
          }, e.executeAll = function (t, n) {
            (n || t && !l(t)) && Object.keys(e.callbacks).forEach(function (n) {
              var i = void 0 !== t[n] ? t[n] : "";
              e.execute(n, i);
            }, e);
          }, e.hasCallbacks = function () {
            return Boolean(Object.keys(e.callbacks).length);
          }, e;
        },
        me = function () {},
        he = function (e) {
          var t = window,
            n = t.console;
          return !!n && "function" == typeof n[e];
        },
        _e = function (e, t, n) {
          return n() ? function () {
            if (he(e)) {
              for (var n = arguments.length, i = new Array(n), r = 0; r < n; r++) i[r] = arguments[r];
              console[e].apply(console, [t].concat(i));
            }
          } : me;
        },
        Ce = u,
        Ie = new Ce("[ADOBE OPT-IN]"),
        ve = function (t, n) {
          return e(t) === n;
        },
        Se = function (e, t) {
          return e instanceof Array ? e : ve(e, "string") ? [e] : t || [];
        },
        De = function (e) {
          var t = Object.keys(e);
          return !!t.length && t.every(function (t) {
            return !0 === e[t];
          });
        },
        Ae = function (e) {
          return !(!e || Oe(e)) && Se(e).every(function (e) {
            return pe.indexOf(e) > -1;
          });
        },
        ye = function (e, t) {
          return e.reduce(function (e, n) {
            return e[n] = t, e;
          }, {});
        },
        be = function (e) {
          return JSON.parse(JSON.stringify(e));
        },
        Oe = function (e) {
          return "[object Array]" === Object.prototype.toString.call(e) && !e.length;
        },
        Me = function (e) {
          if (Te(e)) return e;
          try {
            return JSON.parse(e);
          } catch (e) {
            return {};
          }
        },
        ke = function (e) {
          return void 0 === e || (Te(e) ? Ae(Object.keys(e)) : Ee(e));
        },
        Ee = function (e) {
          try {
            var t = JSON.parse(e);
            return !!e && ve(e, "string") && Ae(Object.keys(t));
          } catch (e) {
            return !1;
          }
        },
        Te = function (e) {
          return null !== e && ve(e, "object") && !1 === Array.isArray(e);
        },
        Le = function () {},
        Pe = function (e) {
          return ve(e, "function") ? e() : e;
        },
        Re = function (e, t) {
          ke(e) || Ie.error("".concat(t));
        },
        we = function (e) {
          return Object.keys(e).map(function (t) {
            return e[t];
          });
        },
        Fe = function (e) {
          return we(e).filter(function (e, t, n) {
            return n.indexOf(e) === t;
          });
        },
        Ne = function (e) {
          return function () {
            var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
              n = t.command,
              i = t.params,
              r = void 0 === i ? {} : i,
              a = t.callback,
              o = void 0 === a ? Le : a;
            if (!n || -1 === n.indexOf(".")) throw new Error("[OptIn.execute] Please provide a valid command.");
            try {
              var s = n.split("."),
                l = e[s[0]],
                c = s[1];
              if (!l || "function" != typeof l[c]) throw new Error("Make sure the plugin and API name exist.");
              var u = Object.assign(r, {
                callback: o
              });
              l[c].call(l, u);
            } catch (e) {
              Ie.error("[execute] Something went wrong: " + e.message);
            }
          };
        };
      f.prototype = Object.create(Error.prototype), f.prototype.constructor = f;
      var xe = "fetchPermissions",
        je = "[OptIn#registerPlugin] Plugin is invalid.";
      p.Categories = ue, p.TimeoutError = f;
      var Ve = Object.freeze({
          OptIn: p,
          IabPlugin: h
        }),
        He = function (e, t) {
          e.publishDestinations = function (n) {
            var i = arguments[1],
              r = arguments[2];
            try {
              r = "function" == typeof r ? r : n.callback;
            } catch (e) {
              r = function () {};
            }
            var a = t;
            if (!a.readyToAttachIframePreliminary()) return void r({
              error: "The destination publishing iframe is disabled in the Visitor library."
            });
            if ("string" == typeof n) {
              if (!n.length) return void r({
                error: "subdomain is not a populated string."
              });
              if (!(i instanceof Array && i.length)) return void r({
                error: "messages is not a populated array."
              });
              var o = !1;
              if (i.forEach(function (e) {
                "string" == typeof e && e.length && (a.addMessage(e), o = !0);
              }), !o) return void r({
                error: "None of the messages are populated strings."
              });
            } else {
              if (!j.isObject(n)) return void r({
                error: "Invalid parameters passed."
              });
              var s = n;
              if ("string" != typeof (n = s.subdomain) || !n.length) return void r({
                error: "config.subdomain is not a populated string."
              });
              var l = s.urlDestinations;
              if (!(l instanceof Array && l.length)) return void r({
                error: "config.urlDestinations is not a populated array."
              });
              var c = [];
              l.forEach(function (e) {
                j.isObject(e) && (e.hideReferrer ? e.message && a.addMessage(e.message) : c.push(e));
              });
              !function e() {
                c.length && setTimeout(function () {
                  var t = new Image(),
                    n = c.shift();
                  t.src = n.url, a.onPageDestinationsFired.push(n), e();
                }, 100);
              }();
            }
            a.iframe ? (r({
              message: "The destination publishing iframe is already attached and loaded."
            }), a.requestToProcess()) : !e.subdomain && e._getField("MCMID") ? (a.subdomain = n, a.doAttachIframe = !0, a.url = a.getUrl(), a.readyToAttachIframe() ? (a.iframeLoadedCallbacks.push(function (e) {
              r({
                message: "Attempted to attach and load the destination publishing iframe through this API call. Result: " + (e.message || "no result")
              });
            }), a.attachIframe()) : r({
              error: "Encountered a problem in attempting to attach and load the destination publishing iframe through this API call."
            })) : a.iframeLoadedCallbacks.push(function (e) {
              r({
                message: "Attempted to attach and load the destination publishing iframe through normal Visitor API processing. Result: " + (e.message || "no result")
              });
            });
          };
        },
        Ue = function e(t) {
          function n(e, t) {
            return e >>> t | e << 32 - t;
          }
          for (var i, r, a = Math.pow, o = a(2, 32), s = "", l = [], c = 8 * t.length, u = e.h = e.h || [], d = e.k = e.k || [], f = d.length, p = {}, g = 2; f < 64; g++) if (!p[g]) {
            for (i = 0; i < 313; i += g) p[i] = g;
            u[f] = a(g, .5) * o | 0, d[f++] = a(g, 1 / 3) * o | 0;
          }
          for (t += ""; t.length % 64 - 56;) t += "\0";
          for (i = 0; i < t.length; i++) {
            if ((r = t.charCodeAt(i)) >> 8) return;
            l[i >> 2] |= r << (3 - i) % 4 * 8;
          }
          for (l[l.length] = c / o | 0, l[l.length] = c, r = 0; r < l.length;) {
            var m = l.slice(r, r += 16),
              h = u;
            for (u = u.slice(0, 8), i = 0; i < 64; i++) {
              var _ = m[i - 15],
                C = m[i - 2],
                I = u[0],
                v = u[4],
                S = u[7] + (n(v, 6) ^ n(v, 11) ^ n(v, 25)) + (v & u[5] ^ ~v & u[6]) + d[i] + (m[i] = i < 16 ? m[i] : m[i - 16] + (n(_, 7) ^ n(_, 18) ^ _ >>> 3) + m[i - 7] + (n(C, 17) ^ n(C, 19) ^ C >>> 10) | 0);
              u = [S + ((n(I, 2) ^ n(I, 13) ^ n(I, 22)) + (I & u[1] ^ I & u[2] ^ u[1] & u[2])) | 0].concat(u), u[4] = u[4] + S | 0;
            }
            for (i = 0; i < 8; i++) u[i] = u[i] + h[i] | 0;
          }
          for (i = 0; i < 8; i++) for (r = 3; r + 1; r--) {
            var D = u[i] >> 8 * r & 255;
            s += (D < 16 ? 0 : "") + D.toString(16);
          }
          return s;
        },
        Be = function (e, t) {
          return "SHA-256" !== t && "SHA256" !== t && "sha256" !== t && "sha-256" !== t || (e = Ue(e)), e;
        },
        Ge = function (e) {
          return String(e).trim().toLowerCase();
        },
        Ye = Ve.OptIn;
      j.defineGlobalNamespace(), window.adobe.OptInCategories = Ye.Categories;
      var qe = function (t, n, i) {
        function r(e) {
          var t = e;
          return function (e) {
            var n = e || v.location.href;
            try {
              var i = g._extractParamFromUri(n, t);
              if (i) return w.parsePipeDelimetedKeyValues(i);
            } catch (e) {}
          };
        }
        function a(e) {
          function t(e, t, n) {
            e && e.match(re.VALID_VISITOR_ID_REGEX) && (n === A && (I = !0), t(e));
          }
          t(e[A], g.setMarketingCloudVisitorID, A), g._setFieldExpire(k, -1), t(e[O], g.setAnalyticsVisitorID);
        }
        function o(e) {
          e = e || {}, g._supplementalDataIDCurrent = e.supplementalDataIDCurrent || "", g._supplementalDataIDCurrentConsumed = e.supplementalDataIDCurrentConsumed || {}, g._supplementalDataIDLast = e.supplementalDataIDLast || "", g._supplementalDataIDLastConsumed = e.supplementalDataIDLastConsumed || {};
        }
        function s(e) {
          function t(e, t, n) {
            return n = n ? n += "|" : n, n += e + "=" + encodeURIComponent(t);
          }
          function n(e, n) {
            var i = n[0],
              r = n[1];
            return null != r && r !== T && (e = t(i, r, e)), e;
          }
          var i = e.reduce(n, "");
          return function (e) {
            var t = w.getTimestampInSeconds();
            return e = e ? e += "|" : e, e += "TS=" + t;
          }(i);
        }
        function l(e) {
          var t = e.minutesToLive,
            n = "";
          return (g.idSyncDisableSyncs || g.disableIdSyncs) && (n = n || "Error: id syncs have been disabled"), "string" == typeof e.dpid && e.dpid.length || (n = n || "Error: config.dpid is empty"), "string" == typeof e.url && e.url.length || (n = n || "Error: config.url is empty"), void 0 === t ? t = 20160 : (t = parseInt(t, 10), (isNaN(t) || t <= 0) && (n = n || "Error: config.minutesToLive needs to be a positive number")), {
            error: n,
            ttl: t
          };
        }
        function c() {
          return !!g.configs.doesOptInApply && !(m.optIn.isComplete && u());
        }
        function u() {
          return g.configs.isIabContext ? m.optIn.isApproved(m.optIn.Categories.ECID) && C : m.optIn.isApproved(m.optIn.Categories.ECID);
        }
        function d(e, t) {
          if (C = !0, e) throw new Error("[IAB plugin] : " + e);
          t.gdprApplies && (h = t.consentString), g.init(), p();
        }
        function f() {
          m.optIn.isApproved(m.optIn.Categories.ECID) && (g.configs.isIabContext ? m.optIn.execute({
            command: "iabPlugin.fetchConsentData",
            callback: d
          }) : (g.init(), p()));
        }
        function p() {
          m.optIn.off("complete", f);
        }
        if (!i || i.split("").reverse().join("") !== t) throw new Error("Please use `Visitor.getInstance` to instantiate Visitor.");
        var g = this,
          m = window.adobe,
          h = "",
          C = !1,
          I = !1;
        g.version = "4.4.0";
        var v = _,
          S = v.Visitor;
        S.version = g.version, S.AuthState = E.AUTH_STATE, S.OptOut = E.OPT_OUT, v.s_c_in || (v.s_c_il = [], v.s_c_in = 0), g._c = "Visitor", g._il = v.s_c_il, g._in = v.s_c_in, g._il[g._in] = g, v.s_c_in++, g._instanceType = "regular", g._log = {
          requests: []
        }, g.marketingCloudOrgID = t, g.cookieName = "AMCV_" + t, g.sessionCookieName = "AMCVS_" + t, g.cookieDomain = $(), g.loadSSL = v.location.protocol.toLowerCase().indexOf("https") >= 0, g.loadTimeout = 3e4, g.CORSErrors = [], g.marketingCloudServer = g.audienceManagerServer = "dpm.demdex.net", g.sdidParamExpiry = 30;
        var D = null,
          A = "MCMID",
          y = "MCIDTS",
          b = "A",
          O = "MCAID",
          M = "AAM",
          k = "MCAAMB",
          T = "NONE",
          L = function (e) {
            return !Object.prototype[e];
          },
          P = ie(g);
        g.FIELDS = E.FIELDS, g.cookieRead = function (e) {
          return Q.get(e);
        }, g.cookieWrite = function (e, t, n) {
          var i = g.cookieLifetime ? ("" + g.cookieLifetime).toUpperCase() : "",
            r = !1;
          return g.configs && g.configs.secureCookie && "https:" === location.protocol && (r = !0), Q.set(e, "" + t, {
            expires: n,
            domain: g.cookieDomain,
            cookieLifetime: i,
            secure: r
          });
        }, g.resetState = function (e) {
          e ? g._mergeServerState(e) : o();
        }, g._isAllowedDone = !1, g._isAllowedFlag = !1, g.isAllowed = function () {
          return g._isAllowedDone || (g._isAllowedDone = !0, (g.cookieRead(g.cookieName) || g.cookieWrite(g.cookieName, "T", 1)) && (g._isAllowedFlag = !0)), "T" === g.cookieRead(g.cookieName) && g._helpers.removeCookie(g.cookieName), g._isAllowedFlag;
        }, g.setMarketingCloudVisitorID = function (e) {
          g._setMarketingCloudFields(e);
        }, g._use1stPartyMarketingCloudServer = !1, g.getMarketingCloudVisitorID = function (e, t) {
          g.marketingCloudServer && g.marketingCloudServer.indexOf(".demdex.net") < 0 && (g._use1stPartyMarketingCloudServer = !0);
          var n = g._getAudienceManagerURLData("_setMarketingCloudFields"),
            i = n.url;
          return g._getRemoteField(A, i, e, t, n);
        }, g.getVisitorValues = function (e, t) {
          var n = {
              MCMID: {
                fn: g.getMarketingCloudVisitorID,
                args: [!0],
                context: g
              },
              MCOPTOUT: {
                fn: g.isOptedOut,
                args: [void 0, !0],
                context: g
              },
              MCAID: {
                fn: g.getAnalyticsVisitorID,
                args: [!0],
                context: g
              },
              MCAAMLH: {
                fn: g.getAudienceManagerLocationHint,
                args: [!0],
                context: g
              },
              MCAAMB: {
                fn: g.getAudienceManagerBlob,
                args: [!0],
                context: g
              }
            },
            i = t && t.length ? j.pluck(n, t) : n;
          z(i, e);
        }, g._currentCustomerIDs = {}, g._customerIDsHashChanged = !1, g._newCustomerIDsHash = "", g.setCustomerIDs = function (t, n) {
          function i() {
            g._customerIDsHashChanged = !1;
          }
          if (!g.isOptedOut() && t) {
            if (!j.isObject(t) || j.isObjectEmpty(t)) return !1;
            g._readVisitor();
            var r, a, o;
            for (r in t) if (L(r) && (a = t[r], n = a.hasOwnProperty("hashType") ? a.hashType : n, a)) if ("object" === e(a)) {
              var s = {};
              if (a.id) {
                if (n) {
                  if (!(o = Be(Ge(a.id), n))) return;
                  a.id = o, s.hashType = n;
                }
                s.id = a.id;
              }
              void 0 != a.authState && (s.authState = a.authState), g._currentCustomerIDs[r] = s;
            } else if (n) {
              if (!(o = Be(Ge(a), n))) return;
              g._currentCustomerIDs[r] = {
                id: o,
                hashType: n
              };
            } else g._currentCustomerIDs[r] = {
              id: a
            };
            var l = g.getCustomerIDs(),
              c = g._getField("MCCIDH"),
              u = "";
            c || (c = 0);
            for (r in l) L(r) && (a = l[r], u += (u ? "|" : "") + r + "|" + (a.id ? a.id : "") + (a.authState ? a.authState : ""));
            g._newCustomerIDsHash = String(g._hash(u)), g._newCustomerIDsHash !== c && (g._customerIDsHashChanged = !0, g._mapCustomerIDs(i));
          }
        }, g.getCustomerIDs = function () {
          g._readVisitor();
          var e,
            t,
            n = {};
          for (e in g._currentCustomerIDs) L(e) && (t = g._currentCustomerIDs[e], n[e] || (n[e] = {}), t.id && (n[e].id = t.id), void 0 != t.authState ? n[e].authState = t.authState : n[e].authState = S.AuthState.UNKNOWN, t.hashType && (n[e].hashType = t.hashType));
          return n;
        }, g.setAnalyticsVisitorID = function (e) {
          g._setAnalyticsFields(e);
        }, g.getAnalyticsVisitorID = function (e, t, n) {
          if (!w.isTrackingServerPopulated() && !n) return g._callCallback(e, [""]), "";
          var i = "";
          if (n || (i = g.getMarketingCloudVisitorID(function (t) {
            g.getAnalyticsVisitorID(e, !0);
          })), i || n) {
            var r = n ? g.marketingCloudServer : g.trackingServer,
              a = "";
            g.loadSSL && (n ? g.marketingCloudServerSecure && (r = g.marketingCloudServerSecure) : g.trackingServerSecure && (r = g.trackingServerSecure));
            var o = {};
            if (r) {
              var s = "http" + (g.loadSSL ? "s" : "") + "://" + r + "/id",
                l = "d_visid_ver=" + g.version + "&mcorgid=" + encodeURIComponent(g.marketingCloudOrgID) + (i ? "&mid=" + encodeURIComponent(i) : "") + (g.idSyncDisable3rdPartySyncing || g.disableThirdPartyCookies ? "&d_coppa=true" : ""),
                c = ["s_c_il", g._in, "_set" + (n ? "MarketingCloud" : "Analytics") + "Fields"];
              a = s + "?" + l + "&callback=s_c_il%5B" + g._in + "%5D._set" + (n ? "MarketingCloud" : "Analytics") + "Fields", o.corsUrl = s + "?" + l, o.callback = c;
            }
            return o.url = a, g._getRemoteField(n ? A : O, a, e, t, o);
          }
          return "";
        }, g.getAudienceManagerLocationHint = function (e, t) {
          if (g.getMarketingCloudVisitorID(function (t) {
            g.getAudienceManagerLocationHint(e, !0);
          })) {
            var n = g._getField(O);
            if (!n && w.isTrackingServerPopulated() && (n = g.getAnalyticsVisitorID(function (t) {
              g.getAudienceManagerLocationHint(e, !0);
            })), n || !w.isTrackingServerPopulated()) {
              var i = g._getAudienceManagerURLData(),
                r = i.url;
              return g._getRemoteField("MCAAMLH", r, e, t, i);
            }
          }
          return "";
        }, g.getLocationHint = g.getAudienceManagerLocationHint, g.getAudienceManagerBlob = function (e, t) {
          if (g.getMarketingCloudVisitorID(function (t) {
            g.getAudienceManagerBlob(e, !0);
          })) {
            var n = g._getField(O);
            if (!n && w.isTrackingServerPopulated() && (n = g.getAnalyticsVisitorID(function (t) {
              g.getAudienceManagerBlob(e, !0);
            })), n || !w.isTrackingServerPopulated()) {
              var i = g._getAudienceManagerURLData(),
                r = i.url;
              return g._customerIDsHashChanged && g._setFieldExpire(k, -1), g._getRemoteField(k, r, e, t, i);
            }
          }
          return "";
        }, g._supplementalDataIDCurrent = "", g._supplementalDataIDCurrentConsumed = {}, g._supplementalDataIDLast = "", g._supplementalDataIDLastConsumed = {}, g.getSupplementalDataID = function (e, t) {
          g._supplementalDataIDCurrent || t || (g._supplementalDataIDCurrent = g._generateID(1));
          var n = g._supplementalDataIDCurrent;
          return g._supplementalDataIDLast && !g._supplementalDataIDLastConsumed[e] ? (n = g._supplementalDataIDLast, g._supplementalDataIDLastConsumed[e] = !0) : n && (g._supplementalDataIDCurrentConsumed[e] && (g._supplementalDataIDLast = g._supplementalDataIDCurrent, g._supplementalDataIDLastConsumed = g._supplementalDataIDCurrentConsumed, g._supplementalDataIDCurrent = n = t ? "" : g._generateID(1), g._supplementalDataIDCurrentConsumed = {}), n && (g._supplementalDataIDCurrentConsumed[e] = !0)), n;
        };
        var R = !1;
        g._liberatedOptOut = null, g.getOptOut = function (e, t) {
          var n = g._getAudienceManagerURLData("_setMarketingCloudFields"),
            i = n.url;
          if (u()) return g._getRemoteField("MCOPTOUT", i, e, t, n);
          if (g._registerCallback("liberatedOptOut", e), null !== g._liberatedOptOut) return g._callAllCallbacks("liberatedOptOut", [g._liberatedOptOut]), R = !1, g._liberatedOptOut;
          if (R) return null;
          R = !0;
          var r = "liberatedGetOptOut";
          return n.corsUrl = n.corsUrl.replace(/dpm\.demdex\.net\/id\?/, "dpm.demdex.net/optOutStatus?"), n.callback = [r], _[r] = function (e) {
            if (e === Object(e)) {
              var t,
                n,
                i = j.parseOptOut(e, t, T);
              t = i.optOut, n = 1e3 * i.d_ottl, g._liberatedOptOut = t, setTimeout(function () {
                g._liberatedOptOut = null;
              }, n);
            }
            g._callAllCallbacks("liberatedOptOut", [t]), R = !1;
          }, P.fireCORS(n), null;
        }, g.isOptedOut = function (e, t, n) {
          t || (t = S.OptOut.GLOBAL);
          var i = g.getOptOut(function (n) {
            var i = n === S.OptOut.GLOBAL || n.indexOf(t) >= 0;
            g._callCallback(e, [i]);
          }, n);
          return i ? i === S.OptOut.GLOBAL || i.indexOf(t) >= 0 : null;
        }, g._fields = null, g._fieldsExpired = null, g._hash = function (e) {
          var t,
            n,
            i = 0;
          if (e) for (t = 0; t < e.length; t++) n = e.charCodeAt(t), i = (i << 5) - i + n, i &= i;
          return i;
        }, g._generateID = ne, g._generateLocalMID = function () {
          var e = g._generateID(0);
          return N.isClientSideMarketingCloudVisitorID = !0, e;
        }, g._callbackList = null, g._callCallback = function (e, t) {
          try {
            "function" == typeof e ? e.apply(v, t) : e[1].apply(e[0], t);
          } catch (e) {}
        }, g._registerCallback = function (e, t) {
          t && (null == g._callbackList && (g._callbackList = {}), void 0 == g._callbackList[e] && (g._callbackList[e] = []), g._callbackList[e].push(t));
        }, g._callAllCallbacks = function (e, t) {
          if (null != g._callbackList) {
            var n = g._callbackList[e];
            if (n) for (; n.length > 0;) g._callCallback(n.shift(), t);
          }
        }, g._addQuerystringParam = function (e, t, n, i) {
          var r = encodeURIComponent(t) + "=" + encodeURIComponent(n),
            a = w.parseHash(e),
            o = w.hashlessUrl(e);
          if (-1 === o.indexOf("?")) return o + "?" + r + a;
          var s = o.split("?"),
            l = s[0] + "?",
            c = s[1];
          return l + w.addQueryParamAtLocation(c, r, i) + a;
        }, g._extractParamFromUri = function (e, t) {
          var n = new RegExp("[\\?&#]" + t + "=([^&#]*)"),
            i = n.exec(e);
          if (i && i.length) return decodeURIComponent(i[1]);
        }, g._parseAdobeMcFromUrl = r(re.ADOBE_MC), g._parseAdobeMcSdidFromUrl = r(re.ADOBE_MC_SDID), g._attemptToPopulateSdidFromUrl = function (e) {
          var n = g._parseAdobeMcSdidFromUrl(e),
            i = 1e9;
          n && n.TS && (i = w.getTimestampInSeconds() - n.TS), n && n.SDID && n.MCORGID === t && i < g.sdidParamExpiry && (g._supplementalDataIDCurrent = n.SDID, g._supplementalDataIDCurrentConsumed.SDID_URL_PARAM = !0);
        }, g._attemptToPopulateIdsFromUrl = function () {
          var e = g._parseAdobeMcFromUrl();
          if (e && e.TS) {
            var n = w.getTimestampInSeconds(),
              i = n - e.TS;
            if (Math.floor(i / 60) > re.ADOBE_MC_TTL_IN_MIN || e.MCORGID !== t) return;
            a(e);
          }
        }, g._mergeServerState = function (e) {
          if (e) try {
            if (e = function (e) {
              return w.isObject(e) ? e : JSON.parse(e);
            }(e), e[g.marketingCloudOrgID]) {
              var t = e[g.marketingCloudOrgID];
              !function (e) {
                w.isObject(e) && g.setCustomerIDs(e);
              }(t.customerIDs), o(t.sdid);
            }
          } catch (e) {
            throw new Error("`serverState` has an invalid format.");
          }
        }, g._timeout = null, g._loadData = function (e, t, n, i) {
          t = g._addQuerystringParam(t, "d_fieldgroup", e, 1), i.url = g._addQuerystringParam(i.url, "d_fieldgroup", e, 1), i.corsUrl = g._addQuerystringParam(i.corsUrl, "d_fieldgroup", e, 1), N.fieldGroupObj[e] = !0, i === Object(i) && i.corsUrl && "XMLHttpRequest" === P.corsMetadata.corsType && P.fireCORS(i, n, e);
        }, g._clearTimeout = function (e) {
          null != g._timeout && g._timeout[e] && (clearTimeout(g._timeout[e]), g._timeout[e] = 0);
        }, g._settingsDigest = 0, g._getSettingsDigest = function () {
          if (!g._settingsDigest) {
            var e = g.version;
            g.audienceManagerServer && (e += "|" + g.audienceManagerServer), g.audienceManagerServerSecure && (e += "|" + g.audienceManagerServerSecure), g._settingsDigest = g._hash(e);
          }
          return g._settingsDigest;
        }, g._readVisitorDone = !1, g._readVisitor = function () {
          if (!g._readVisitorDone) {
            g._readVisitorDone = !0;
            var e,
              t,
              n,
              i,
              r,
              a,
              o = g._getSettingsDigest(),
              s = !1,
              l = g.cookieRead(g.cookieName),
              c = new Date();
            if (l || I || g.discardTrackingServerECID || (l = g.cookieRead(re.FIRST_PARTY_SERVER_COOKIE)), null == g._fields && (g._fields = {}), l && "T" !== l) for (l = l.split("|"), l[0].match(/^[\-0-9]+$/) && (parseInt(l[0], 10) !== o && (s = !0), l.shift()), l.length % 2 == 1 && l.pop(), e = 0; e < l.length; e += 2) t = l[e].split("-"), n = t[0], i = l[e + 1], t.length > 1 ? (r = parseInt(t[1], 10), a = t[1].indexOf("s") > 0) : (r = 0, a = !1), s && ("MCCIDH" === n && (i = ""), r > 0 && (r = c.getTime() / 1e3 - 60)), n && i && (g._setField(n, i, 1), r > 0 && (g._fields["expire" + n] = r + (a ? "s" : ""), (c.getTime() >= 1e3 * r || a && !g.cookieRead(g.sessionCookieName)) && (g._fieldsExpired || (g._fieldsExpired = {}), g._fieldsExpired[n] = !0)));
            !g._getField(O) && w.isTrackingServerPopulated() && (l = g.cookieRead("s_vi")) && (l = l.split("|"), l.length > 1 && l[0].indexOf("v1") >= 0 && (i = l[1], e = i.indexOf("["), e >= 0 && (i = i.substring(0, e)), i && i.match(re.VALID_VISITOR_ID_REGEX) && g._setField(O, i)));
          }
        }, g._appendVersionTo = function (e) {
          var t = "vVersion|" + g.version,
            n = e ? g._getCookieVersion(e) : null;
          return n ? Z.areVersionsDifferent(n, g.version) && (e = e.replace(re.VERSION_REGEX, t)) : e += (e ? "|" : "") + t, e;
        }, g._writeVisitor = function () {
          var e,
            t,
            n = g._getSettingsDigest();
          for (e in g._fields) L(e) && g._fields[e] && "expire" !== e.substring(0, 6) && (t = g._fields[e], n += (n ? "|" : "") + e + (g._fields["expire" + e] ? "-" + g._fields["expire" + e] : "") + "|" + t);
          n = g._appendVersionTo(n), g.cookieWrite(g.cookieName, n, 1);
        }, g._getField = function (e, t) {
          return null == g._fields || !t && g._fieldsExpired && g._fieldsExpired[e] ? null : g._fields[e];
        }, g._setField = function (e, t, n) {
          null == g._fields && (g._fields = {}), g._fields[e] = t, n || g._writeVisitor();
        }, g._getFieldList = function (e, t) {
          var n = g._getField(e, t);
          return n ? n.split("*") : null;
        }, g._setFieldList = function (e, t, n) {
          g._setField(e, t ? t.join("*") : "", n);
        }, g._getFieldMap = function (e, t) {
          var n = g._getFieldList(e, t);
          if (n) {
            var i,
              r = {};
            for (i = 0; i < n.length; i += 2) r[n[i]] = n[i + 1];
            return r;
          }
          return null;
        }, g._setFieldMap = function (e, t, n) {
          var i,
            r = null;
          if (t) {
            r = [];
            for (i in t) L(i) && (r.push(i), r.push(t[i]));
          }
          g._setFieldList(e, r, n);
        }, g._setFieldExpire = function (e, t, n) {
          var i = new Date();
          i.setTime(i.getTime() + 1e3 * t), null == g._fields && (g._fields = {}), g._fields["expire" + e] = Math.floor(i.getTime() / 1e3) + (n ? "s" : ""), t < 0 ? (g._fieldsExpired || (g._fieldsExpired = {}), g._fieldsExpired[e] = !0) : g._fieldsExpired && (g._fieldsExpired[e] = !1), n && (g.cookieRead(g.sessionCookieName) || g.cookieWrite(g.sessionCookieName, "1"));
        }, g._findVisitorID = function (t) {
          return t && ("object" === e(t) && (t = t.d_mid ? t.d_mid : t.visitorID ? t.visitorID : t.id ? t.id : t.uuid ? t.uuid : "" + t), t && "NOTARGET" === (t = t.toUpperCase()) && (t = T), t && (t === T || t.match(re.VALID_VISITOR_ID_REGEX)) || (t = "")), t;
        }, g._setFields = function (t, n) {
          if (g._clearTimeout(t), null != g._loading && (g._loading[t] = !1), N.fieldGroupObj[t] && N.setState(t, !1), "MC" === t) {
            !0 !== N.isClientSideMarketingCloudVisitorID && (N.isClientSideMarketingCloudVisitorID = !1);
            var i = g._getField(A);
            if (!i || g.overwriteCrossDomainMCIDAndAID) {
              if (!(i = "object" === e(n) && n.mid ? n.mid : g._findVisitorID(n))) {
                if (g._use1stPartyMarketingCloudServer && !g.tried1stPartyMarketingCloudServer) return g.tried1stPartyMarketingCloudServer = !0, void g.getAnalyticsVisitorID(null, !1, !0);
                i = g._generateLocalMID();
              }
              g._setField(A, i);
            }
            i && i !== T || (i = ""), "object" === e(n) && ((n.d_region || n.dcs_region || n.d_blob || n.blob) && g._setFields(M, n), g._use1stPartyMarketingCloudServer && n.mid && g._setFields(b, {
              id: n.id
            })), g._callAllCallbacks(A, [i]);
          }
          if (t === M && "object" === e(n)) {
            var r = 604800;
            void 0 != n.id_sync_ttl && n.id_sync_ttl && (r = parseInt(n.id_sync_ttl, 10));
            var a = F.getRegionAndCheckIfChanged(n, r);
            g._callAllCallbacks("MCAAMLH", [a]);
            var o = g._getField(k);
            (n.d_blob || n.blob) && (o = n.d_blob, o || (o = n.blob), g._setFieldExpire(k, r), g._setField(k, o)), o || (o = ""), g._callAllCallbacks(k, [o]), !n.error_msg && g._newCustomerIDsHash && g._setField("MCCIDH", g._newCustomerIDsHash);
          }
          if (t === b) {
            var s = g._getField(O);
            s && !g.overwriteCrossDomainMCIDAndAID || (s = g._findVisitorID(n), s ? s !== T && g._setFieldExpire(k, -1) : s = T, g._setField(O, s)), s && s !== T || (s = ""), g._callAllCallbacks(O, [s]);
          }
          if (g.idSyncDisableSyncs || g.disableIdSyncs) F.idCallNotProcesssed = !0;else {
            F.idCallNotProcesssed = !1;
            var l = {};
            l.ibs = n.ibs, l.subdomain = n.subdomain, F.processIDCallData(l);
          }
          if (n === Object(n)) {
            var c, d;
            u() && g.isAllowed() && (c = g._getField("MCOPTOUT"));
            var f = j.parseOptOut(n, c, T);
            c = f.optOut, d = f.d_ottl, g._setFieldExpire("MCOPTOUT", d, !0), g._setField("MCOPTOUT", c), g._callAllCallbacks("MCOPTOUT", [c]);
          }
        }, g._loading = null, g._getRemoteField = function (e, t, n, i, r) {
          var a,
            o = "",
            s = w.isFirstPartyAnalyticsVisitorIDCall(e),
            l = {
              MCAAMLH: !0,
              MCAAMB: !0
            };
          if (u() && g.isAllowed()) {
            g._readVisitor(), o = g._getField(e, !0 === l[e]);
            if (function () {
              return (!o || g._fieldsExpired && g._fieldsExpired[e]) && (!g.disableThirdPartyCalls || s);
            }()) {
              if (e === A || "MCOPTOUT" === e ? a = "MC" : "MCAAMLH" === e || e === k ? a = M : e === O && (a = b), a) return !t || null != g._loading && g._loading[a] || (null == g._loading && (g._loading = {}), g._loading[a] = !0, g._loadData(a, t, function (t) {
                if (!g._getField(e)) {
                  t && N.setState(a, !0);
                  var n = "";
                  e === A ? n = g._generateLocalMID() : a === M && (n = {
                    error_msg: "timeout"
                  }), g._setFields(a, n);
                }
              }, r)), g._registerCallback(e, n), o || (t || g._setFields(a, {
                id: T
              }), "");
            } else o || (e === A ? (g._registerCallback(e, n), o = g._generateLocalMID(), g.setMarketingCloudVisitorID(o)) : e === O ? (g._registerCallback(e, n), o = "", g.setAnalyticsVisitorID(o)) : (o = "", i = !0));
          }
          return e !== A && e !== O || o !== T || (o = "", i = !0), n && i && g._callCallback(n, [o]), o;
        }, g._setMarketingCloudFields = function (e) {
          g._readVisitor(), g._setFields("MC", e);
        }, g._mapCustomerIDs = function (e) {
          g.getAudienceManagerBlob(e, !0);
        }, g._setAnalyticsFields = function (e) {
          g._readVisitor(), g._setFields(b, e);
        }, g._setAudienceManagerFields = function (e) {
          g._readVisitor(), g._setFields(M, e);
        }, g._getAudienceManagerURLData = function (e) {
          var t = g.audienceManagerServer,
            n = "",
            i = g._getField(A),
            r = g._getField(k, !0),
            a = g._getField(O),
            o = a && a !== T ? "&d_cid_ic=AVID%01" + encodeURIComponent(a) : "";
          if (g.loadSSL && g.audienceManagerServerSecure && (t = g.audienceManagerServerSecure), t) {
            var s,
              l,
              c = g.getCustomerIDs();
            if (c) for (s in c) L(s) && (l = c[s], o += "&d_cid_ic=" + encodeURIComponent(s) + "%01" + encodeURIComponent(l.id ? l.id : "") + (l.authState ? "%01" + l.authState : ""));
            e || (e = "_setAudienceManagerFields");
            var u = "http" + (g.loadSSL ? "s" : "") + "://" + t + "/id",
              d = "d_visid_ver=" + g.version + (h && -1 !== u.indexOf("demdex.net") ? "&gdpr=1&gdpr_force=1&gdpr_consent=" + h : "") + "&d_rtbd=json&d_ver=2" + (!i && g._use1stPartyMarketingCloudServer ? "&d_verify=1" : "") + "&d_orgid=" + encodeURIComponent(g.marketingCloudOrgID) + "&d_nsid=" + (g.idSyncContainerID || 0) + (i ? "&d_mid=" + encodeURIComponent(i) : "") + (g.idSyncDisable3rdPartySyncing || g.disableThirdPartyCookies ? "&d_coppa=true" : "") + (!0 === D ? "&d_coop_safe=1" : !1 === D ? "&d_coop_unsafe=1" : "") + (r ? "&d_blob=" + encodeURIComponent(r) : "") + o,
              f = ["s_c_il", g._in, e];
            return n = u + "?" + d + "&d_cb=s_c_il%5B" + g._in + "%5D." + e, {
              url: n,
              corsUrl: u + "?" + d,
              callback: f
            };
          }
          return {
            url: n
          };
        }, g.appendVisitorIDsTo = function (e) {
          try {
            var t = [[A, g._getField(A)], [O, g._getField(O)], ["MCORGID", g.marketingCloudOrgID]];
            return g._addQuerystringParam(e, re.ADOBE_MC, s(t));
          } catch (t) {
            return e;
          }
        }, g.appendSupplementalDataIDTo = function (e, t) {
          if (!(t = t || g.getSupplementalDataID(w.generateRandomString(), !0))) return e;
          try {
            var n = s([["SDID", t], ["MCORGID", g.marketingCloudOrgID]]);
            return g._addQuerystringParam(e, re.ADOBE_MC_SDID, n);
          } catch (t) {
            return e;
          }
        };
        var w = {
          parseHash: function (e) {
            var t = e.indexOf("#");
            return t > 0 ? e.substr(t) : "";
          },
          hashlessUrl: function (e) {
            var t = e.indexOf("#");
            return t > 0 ? e.substr(0, t) : e;
          },
          addQueryParamAtLocation: function (e, t, n) {
            var i = e.split("&");
            return n = null != n ? n : i.length, i.splice(n, 0, t), i.join("&");
          },
          isFirstPartyAnalyticsVisitorIDCall: function (e, t, n) {
            if (e !== O) return !1;
            var i;
            return t || (t = g.trackingServer), n || (n = g.trackingServerSecure), !("string" != typeof (i = g.loadSSL ? n : t) || !i.length) && i.indexOf("2o7.net") < 0 && i.indexOf("omtrdc.net") < 0;
          },
          isObject: function (e) {
            return Boolean(e && e === Object(e));
          },
          removeCookie: function (e) {
            Q.remove(e, {
              domain: g.cookieDomain
            });
          },
          isTrackingServerPopulated: function () {
            return !!g.trackingServer || !!g.trackingServerSecure;
          },
          getTimestampInSeconds: function () {
            return Math.round(new Date().getTime() / 1e3);
          },
          parsePipeDelimetedKeyValues: function (e) {
            return e.split("|").reduce(function (e, t) {
              var n = t.split("=");
              return e[n[0]] = decodeURIComponent(n[1]), e;
            }, {});
          },
          generateRandomString: function (e) {
            e = e || 5;
            for (var t = "", n = "abcdefghijklmnopqrstuvwxyz0123456789"; e--;) t += n[Math.floor(Math.random() * n.length)];
            return t;
          },
          normalizeBoolean: function (e) {
            return "true" === e || "false" !== e && e;
          },
          parseBoolean: function (e) {
            return "true" === e || "false" !== e && null;
          },
          replaceMethodsWithFunction: function (e, t) {
            for (var n in e) e.hasOwnProperty(n) && "function" == typeof e[n] && (e[n] = t);
            return e;
          }
        };
        g._helpers = w;
        var F = ae(g, S);
        g._destinationPublishing = F, g.timeoutMetricsLog = [];
        var N = {
          isClientSideMarketingCloudVisitorID: null,
          MCIDCallTimedOut: null,
          AnalyticsIDCallTimedOut: null,
          AAMIDCallTimedOut: null,
          fieldGroupObj: {},
          setState: function (e, t) {
            switch (e) {
              case "MC":
                !1 === t ? !0 !== this.MCIDCallTimedOut && (this.MCIDCallTimedOut = !1) : this.MCIDCallTimedOut = t;
                break;
              case b:
                !1 === t ? !0 !== this.AnalyticsIDCallTimedOut && (this.AnalyticsIDCallTimedOut = !1) : this.AnalyticsIDCallTimedOut = t;
                break;
              case M:
                !1 === t ? !0 !== this.AAMIDCallTimedOut && (this.AAMIDCallTimedOut = !1) : this.AAMIDCallTimedOut = t;
            }
          }
        };
        g.isClientSideMarketingCloudVisitorID = function () {
          return N.isClientSideMarketingCloudVisitorID;
        }, g.MCIDCallTimedOut = function () {
          return N.MCIDCallTimedOut;
        }, g.AnalyticsIDCallTimedOut = function () {
          return N.AnalyticsIDCallTimedOut;
        }, g.AAMIDCallTimedOut = function () {
          return N.AAMIDCallTimedOut;
        }, g.idSyncGetOnPageSyncInfo = function () {
          return g._readVisitor(), g._getField("MCSYNCSOP");
        }, g.idSyncByURL = function (e) {
          if (!g.isOptedOut()) {
            var t = l(e || {});
            if (t.error) return t.error;
            var n,
              i,
              r = e.url,
              a = encodeURIComponent,
              o = F;
            return r = r.replace(/^https:/, "").replace(/^http:/, ""), n = j.encodeAndBuildRequest(["", e.dpid, e.dpuuid || ""], ","), i = ["ibs", a(e.dpid), "img", a(r), t.ttl, "", n], o.addMessage(i.join("|")), o.requestToProcess(), "Successfully queued";
          }
        }, g.idSyncByDataSource = function (e) {
          if (!g.isOptedOut()) return e === Object(e) && "string" == typeof e.dpuuid && e.dpuuid.length ? (e.url = "//dpm.demdex.net/ibs:dpid=" + e.dpid + "&dpuuid=" + e.dpuuid, g.idSyncByURL(e)) : "Error: config or config.dpuuid is empty";
        }, He(g, F), g._getCookieVersion = function (e) {
          e = e || g.cookieRead(g.cookieName);
          var t = re.VERSION_REGEX.exec(e);
          return t && t.length > 1 ? t[1] : null;
        }, g._resetAmcvCookie = function (e) {
          var t = g._getCookieVersion();
          t && !Z.isLessThan(t, e) || w.removeCookie(g.cookieName);
        }, g.setAsCoopSafe = function () {
          D = !0;
        }, g.setAsCoopUnsafe = function () {
          D = !1;
        }, function () {
          if (g.configs = Object.create(null), w.isObject(n)) for (var e in n) L(e) && (g[e] = n[e], g.configs[e] = n[e]);
        }(), function () {
          [["getMarketingCloudVisitorID"], ["setCustomerIDs", void 0], ["getAnalyticsVisitorID"], ["getAudienceManagerLocationHint"], ["getLocationHint"], ["getAudienceManagerBlob"]].forEach(function (e) {
            var t = e[0],
              n = 2 === e.length ? e[1] : "",
              i = g[t];
            g[t] = function (e) {
              return u() && g.isAllowed() ? i.apply(g, arguments) : ("function" == typeof e && g._callCallback(e, [n]), n);
            };
          });
        }(), g.init = function () {
          if (c()) return m.optIn.fetchPermissions(f, !0);
          !function () {
            if (w.isObject(n)) {
              g.idSyncContainerID = g.idSyncContainerID || 0, D = "boolean" == typeof g.isCoopSafe ? g.isCoopSafe : w.parseBoolean(g.isCoopSafe), g.resetBeforeVersion && g._resetAmcvCookie(g.resetBeforeVersion), g._attemptToPopulateIdsFromUrl(), g._attemptToPopulateSdidFromUrl(), g._readVisitor();
              var e = g._getField(y),
                t = Math.ceil(new Date().getTime() / re.MILLIS_PER_DAY);
              g.idSyncDisableSyncs || g.disableIdSyncs || !F.canMakeSyncIDCall(e, t) || (g._setFieldExpire(k, -1), g._setField(y, t)), g.getMarketingCloudVisitorID(), g.getAudienceManagerLocationHint(), g.getAudienceManagerBlob(), g._mergeServerState(g.serverState);
            } else g._attemptToPopulateIdsFromUrl(), g._attemptToPopulateSdidFromUrl();
          }(), function () {
            if (!g.idSyncDisableSyncs && !g.disableIdSyncs) {
              F.checkDPIframeSrc();
              var e = function () {
                var e = F;
                e.readyToAttachIframe() && e.attachIframe();
              };
              v.addEventListener("load", function () {
                S.windowLoaded = !0, e();
              });
              try {
                te.receiveMessage(function (e) {
                  F.receiveMessage(e.data);
                }, F.iframeHost);
              } catch (e) {}
            }
          }(), function () {
            g.whitelistIframeDomains && re.POST_MESSAGE_ENABLED && (g.whitelistIframeDomains = g.whitelistIframeDomains instanceof Array ? g.whitelistIframeDomains : [g.whitelistIframeDomains], g.whitelistIframeDomains.forEach(function (e) {
              var n = new B(t, e),
                i = K(g, n);
              te.receiveMessage(i, e);
            }));
          }();
        };
      };
      qe.config = se, _.Visitor = qe;
      var Xe = qe,
        We = function (e) {
          if (j.isObject(e)) return Object.keys(e).filter(function (t) {
            return "" !== e[t];
          }).reduce(function (t, n) {
            var i = "doesOptInApply" !== n ? e[n] : se.normalizeConfig(e[n]),
              r = j.normalizeBoolean(i);
            return t[n] = r, t;
          }, Object.create(null));
        },
        Je = Ve.OptIn,
        Ke = Ve.IabPlugin;
      return Xe.getInstance = function (e, t) {
        if (!e) throw new Error("Visitor requires Adobe Marketing Cloud Org ID.");
        e.indexOf("@") < 0 && (e += "@AdobeOrg");
        var n = function () {
          var t = _.s_c_il;
          if (t) for (var n = 0; n < t.length; n++) {
            var i = t[n];
            if (i && "Visitor" === i._c && i.marketingCloudOrgID === e) return i;
          }
        }();
        if (n) return n;
        var i = We(t);
        !function (e) {
          _.adobe.optIn = _.adobe.optIn || function () {
            var t = j.pluck(e, ["doesOptInApply", "previousPermissions", "preOptInApprovals", "isOptInStorageEnabled", "optInStorageExpiry", "isIabContext"]),
              n = e.optInCookieDomain || e.cookieDomain;
            n = n || $(), n = n === window.location.hostname ? "" : n, t.optInCookieDomain = n;
            var i = new Je(t, {
              cookies: Q
            });
            if (t.isIabContext) {
              var r = new Ke(window.__cmp);
              i.registerPlugin(r);
            }
            return i;
          }();
        }(i || {});
        var r = e,
          a = r.split("").reverse().join(""),
          o = new Xe(e, null, a);
        j.isObject(i) && i.cookieDomain && (o.cookieDomain = i.cookieDomain), function () {
          _.s_c_il.splice(--_.s_c_in, 1);
        }();
        var s = j.getIeVersion();
        if ("number" == typeof s && s < 10) return o._helpers.replaceMethodsWithFunction(o, function () {});
        var l = function () {
          try {
            return _.self !== _.parent;
          } catch (e) {
            return !0;
          }
        }() && !function (e) {
          return e.cookieWrite("TEST_AMCV_COOKIE", "T", 1), "T" === e.cookieRead("TEST_AMCV_COOKIE") && (e._helpers.removeCookie("TEST_AMCV_COOKIE"), !0);
        }(o) && _.parent ? new Y(e, i, o, _.parent) : new Xe(e, i, a);
        return o = null, l.init(), l;
      }, function () {
        function e() {
          Xe.windowLoaded = !0;
        }
        _.addEventListener ? _.addEventListener("load", e) : _.attachEvent && _.attachEvent("onload", e), Xe.codeLoadEnd = new Date().getTime();
      }(), Xe;
    }();

    /* WEBPACK VAR INJECTION */
  }).call(this, __webpack_require__(0));

  /***/
}), (/* 12 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  /* WEBPACK VAR INJECTION */
  (function (global) {
    module.exports = {
      adobeAnalyticsAccount: 'expediaglobaldev',
      travelPixel: {
        url: 'https://b.travel-assets.com/travel-pixel-js/1.0.0/app.js',
        domain: (global.location || {}).hostname,
        environment: 'dev'
      },
      TRACK_API_URL: '/api/uisprime/track',
      TRACK_API_URL_CROSS_SITE: 'https://wwwexpediacom.trunk.sb.karmalab.net/api/uisprime/track'
    };
    /* WEBPACK VAR INJECTION */
  }).call(this, __webpack_require__(0));

  /***/
}), (/* 13 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  /* WEBPACK VAR INJECTION */
  (function (global) {
    module.exports = {
      adobeAnalyticsAccount: 'expediaglobaldev',
      travelPixel: {
        url: 'https://b.travel-assets.com/travel-pixel-js/1.0.0/app.js',
        domain: (global.location || {}).hostname,
        environment: 'trunk'
      },
      TRACK_API_URL: '/api/uisprime/track',
      TRACK_API_URL_CROSS_SITE: 'https://wwwexpediacom.trunk.sb.karmalab.net/api/uisprime/track'
    };
    /* WEBPACK VAR INJECTION */
  }).call(this, __webpack_require__(0));

  /***/
}), (/* 14 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  /* WEBPACK VAR INJECTION */
  (function (global) {
    module.exports = {
      adobeAnalyticsAccount: 'expediaglobal',
      travelPixel: {
        url: 'https://b.travel-assets.com/travel-pixel-js/1.0.0/app.js',
        domain: (global.location || {}).hostname,
        environment: 'prod'
      },
      TRACK_API_URL: '/api/uisprime/track',
      TRACK_API_URL_CROSS_SITE: 'https://www.expedia.com/api/uisprime/track'
    };
    /* WEBPACK VAR INJECTION */
  }).call(this, __webpack_require__(0));

  /***/
}), (/* 15 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  /* WEBPACK VAR INJECTION */
  (function (global) {
    module.exports = {
      adobeAnalyticsAccount: 'expediaglobaldev',
      travelPixel: {
        url: 'https://b.travel-assets.com/travel-pixel-js/1.0.0/app.js',
        domain: (global.location || {}).hostname,
        environment: 'int'
      },
      TRACK_API_URL: '/api/uisprime/track',
      TRACK_API_URL_CROSS_SITE: 'https://wwwexpediacom.trunk.sb.karmalab.net/api/uisprime/track'
    };
    /* WEBPACK VAR INJECTION */
  }).call(this, __webpack_require__(0));

  /***/
}), (/* 16 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  };
  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }
    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();
  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  var Publishers = __webpack_require__(17);
  var clientSideSchemaToUisPublishing = __webpack_require__(25);
  var util = __webpack_require__(6);
  var uisPrimeUtil = __webpack_require__(27);
  var env = __webpack_require__(2);
  var _require = __webpack_require__(1),
    toLogStore = _require.toLogStore;
  var VIEW_EVENT = 'view';
  var CLICK_EVENT = 'click';
  var UisPrime = function () {
    function UisPrime() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        context: [],
        tealiumContext: [],
        isDebugEnabled: false
      };
      _classCallCheck(this, UisPrime);
      this.context = params.context;
      this.tealiumContext = params.tealiumContext;
      this.isDebugEnabled = params.isDebugEnabled;
    }
    _createClass(UisPrime, [{
      key: 'mergePayloads',
      value: function mergePayloads(payloads) {
        var _this = this;
        this.adobeMappedData = {};
        this.tealiumUtagData = typeof window !== 'undefined' ? window.utag_data || {} : {};
        this.tagCommanderData = typeof window !== 'undefined' ? window.tc_vars || {} : {};
        var firstTraceId = void 0;
        payloads.forEach(function (payload) {
          if (payload.adobeMappedData) {
            if (!firstTraceId && payload.adobeMappedData.prop10) {
              firstTraceId = payload.adobeMappedData.prop10;
            }
            util.mergeAdobePayloads(_this.adobeMappedData, payload.adobeMappedData);
          }
          if (payload.tealiumUtagData) {
            util.mergeObjectsDeep(_this.tealiumUtagData, payload.tealiumUtagData);
          }
          if (payload.tagCommanderData) {
            util.mergeObjectsDeep(_this.tagCommanderData, payload.tagCommanderData);
          }
        });
        if (firstTraceId) {
          this.adobeMappedData.prop10 = firstTraceId;
        }
      }
    }, {
      key: 'publish',
      value: function publish(payloads) {
        var _this2 = this;
        try {
          this.mergePayloads(payloads);
          clientSideSchemaToUisPublishing.getAllSchemas(this.context.overridenMicroMessages, payloads).then(function (clientSideSchemas) {
            if (clientSideSchemas.schema.length !== 0) {
              _this2.trackPrime(clientSideSchemas.schema, VIEW_EVENT);
            }
            if (clientSideSchemas.adobeData) {
              util.mergeAdobePayloads(_this2.adobeMappedData, clientSideSchemas.adobeData);
              if (!_this2.context.isAutomaticAdobePageViewDisabled) {
                var publishAdobeDataPayload = {
                  adobeMappedData: _this2.adobeMappedData,
                  eventType: VIEW_EVENT,
                  isDebugEnabled: _this2.isDebugEnabled,
                  tealiumUtagData: _this2.tealiumUtagData,
                  context: _this2.context
                };
                publishAdobeData(publishAdobeDataPayload);
                publishTravelPixel(_this2.tealiumUtagData, _this2.isDebugEnabled);
              }
            }
          });
          var tealiumAccountDetails = void 0;
          if (this.context.isPwa) {
            tealiumAccountDetails = this.context.tealiumContext ? this.context.tealiumContext.tealiumAccountDetailsPWA : this.context.tealiumAccountDetailsPWA;
          } else {
            tealiumAccountDetails = this.context.tealiumContext ? this.context.tealiumContext.tealiumAccountDetails : this.context.tealiumAccountDetails;
          }
          var tcContext = this.context.tc_context || this.tealiumUtagData.tc_context;
          var tcVars = this.context.tc_vars || this.tealiumUtagData.tc_vars;
          addTagCommander(tcContext, tcVars, this.isDebugEnabled);
          publishTealiumData(this.tealiumUtagData, tealiumAccountDetails, this.isDebugEnabled);
        } catch (err) {
          console.error('[PlatformAnalyticsPrime] Error while publishing view event : ' + err);
        }
        return true;
      }
    }, {
      key: 'trackEvent',
      value: function trackEvent(microMessages) {
        var eventType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : CLICK_EVENT;
        try {
          this.trackPrime(microMessages, eventType);
        } catch (err) {
          console.error('[PlatformAnalyticsPrime] Error while publishing ' + eventType + ' event: ' + err);
        }
        return true;
      }
    }, {
      key: 'trackPrime',
      value: function trackPrime(microMessages, eventType) {
        var _this3 = this;
        var UisPublisher = Publishers.UisPublisher;
        var applicationName = this.context && this.context.applicationName;
        var traceIdOfTheView = this.context && this.context.traceIdOfTheView;
        var additionalHeaders = this.context && this.context.additionalHeaders;
        uisPrimeUtil.addPageIdentity(microMessages, this.context);
        uisPrimeUtil.addParentView(microMessages, this.context);
        uisPrimeUtil.addVisitEvents(microMessages, this.context);
        var publishPayload = {
          applicationName: applicationName,
          traceIdOfTheView: traceIdOfTheView,
          microMessages: microMessages
        };
        var label = ((microMessages[0] || {}).messageContent || {}).referrerId || this.context.pageName;
        var publisher = new UisPublisher({
          isDebugEnabled: this.isDebugEnabled,
          eventType: eventType,
          label: label,
          trackApiUrl: getTrackApiUrl(this.context.isCrossSite),
          additionalHeaders: additionalHeaders
        });
        publisher.publish(publishPayload).then(function (data) {
          var response = JSON.parse(data.response);
          if (typeof response === 'string') {
            // hotfix - this scenario happens because trackPrime endpoint is serializing the json object twice
            response = JSON.parse(response);
          }
          if (_typeof(response.adobeMappedData) !== 'object') {
            console.error('[trackPrime] error: the response from trackPrime endpoint does not contain the expected data');
          }
          // need to check for isAutomaticAdobePageViewDisabled to keep the existing functionality
          // where view_event was not published in case of clientSideSchemas.schema.length !== 0
          if (eventType === VIEW_EVENT && response.adobeMappedData && _this3.context.isAutomaticAdobePageViewDisabled) {
            // need to set the pageURL, otherwise it will be <domain>/api/track as it's returned by track api
            if (typeof window !== 'undefined') {
              response.adobeMappedData.pageURL = window.location.href;
            }
            var adobePageViewDataPayload = {
              adobeMappedData: response.adobeMappedData,
              eventType: VIEW_EVENT,
              isDebugEnabled: _this3.isDebugEnabled,
              tealiumUtagData: response.tealiumUtagData,
              context: _this3.context
            };
            publishAdobeData(adobePageViewDataPayload);
            publishTravelPixel(response.tealiumUtagData, _this3.isDebugEnabled);
          }
          if (eventType === CLICK_EVENT && response.adobeMappedData) {
            var publishAdobeDataPayload = {
              adobeMappedData: response.adobeMappedData,
              eventType: CLICK_EVENT,
              isDebugEnabled: _this3.isDebugEnabled,
              context: _this3.context
            };
            publishAdobeData(publishAdobeDataPayload);
          }
        });
      }
    }, {
      key: 'trackPageViewAndPublishToAdobe',
      value: function trackPageViewAndPublishToAdobe(fullPageViewPayload) {
        var _this4 = this;
        var label = this.context.pageName;
        var publisher = new Publishers.UisPublisher({
          isDebugEnabled: this.isDebugEnabled,
          eventType: VIEW_EVENT,
          label: label,
          trackApiUrl: getTrackApiUrl(this.context.isCrossSite)
        });
        var actualPayload = {
          applicationName: this.context && this.context.applicationName,
          traceIdOfTheView: this.context && this.context.traceIdOfTheView,
          microMessages: fullPageViewPayload.microMessages
        };
        return publisher.publish(actualPayload).then(function (data) {
          var response = JSON.parse(data.response);
          if (typeof response === 'string') {
            // hotfix - this scenario happens because trackPrime endpoint is serializing the json object twice
            response = JSON.parse(response);
          }
          if (_typeof(response.adobeMappedData) !== 'object') {
            console.error('[trackPrime] error: the response from trackPrime endpoint does not contain the expected data');
          }
          if (response.adobeMappedData) {
            var publishAdobeDataPayload = {
              adobeMappedData: response.adobeMappedData,
              eventType: VIEW_EVENT,
              isDebugEnabled: _this4.isDebugEnabled,
              context: _this4.context
            };
            publishAdobeData(publishAdobeDataPayload);
            publishTravelPixel(response.tealiumUtagData, _this4.isDebugEnabled);
          }
          return Promise.resolve(data);
        });
      }
    }]);
    return UisPrime;
  }();
  function getTrackApiUrl(isCrossSite) {
    var config = env.getConfiguration();
    var trackApiUrl = isCrossSite ? config.TRACK_API_URL_CROSS_SITE : config.TRACK_API_URL;
    return trackApiUrl;
  }
  function publishTealiumData(tealiumUtagData, tealiumAccountDetails, isDebugEnabled) {
    try {
      if ((typeof tealiumUtagData === 'undefined' ? 'undefined' : _typeof(tealiumUtagData)) !== 'object') {
        console.error('[TealiumPublisher] error: trying to publish something that is not an object (type was: ' + (typeof tealiumUtagData === 'undefined' ? 'undefined' : _typeof(tealiumUtagData)) + ')');
        return;
      }
      if (Object.keys(tealiumUtagData).length > 0) {
        var TealiumPublisher = Publishers.TealiumPublisher;
        new TealiumPublisher({
          tealiumAccountDetails: tealiumAccountDetails,
          isDebugEnabled: isDebugEnabled
        }).publish(tealiumUtagData);
      }
    } catch (err) {
      console.error('[PlatformAnalyticsPrime] Tealium publishing failed because of: ' + err);
    }
  }
  function publishAdobeData(params) {
    try {
      if (_typeof(params.adobeMappedData) !== 'object') {
        console.error('[AdobePublisher] error: trying to publish something that is not an object (type was: ' + _typeof(params.adobeMappedData) + ')');
        return;
      }
      if (params.context && params.context.beaconOffConfig && params.context.beaconOffConfig.settings && params.context.beaconOffConfig.settings.sendToAdobeClientSide === false) {
        return;
      }
      if (Object.keys(params.adobeMappedData).length > 0) {
        var AdobePublisher = Publishers.AdobePublisher;
        new AdobePublisher({
          eventType: params.eventType,
          isDebugEnabled: params.isDebugEnabled,
          context: params.context
        }).publish(params.adobeMappedData, params.tealiumUtagData);
      }
    } catch (e) {
      console.error('Adobe publishing failed because of : ' + e.stack);
    }
  }
  function publishTravelPixel(tealiumUtagData, isDebugEnabled) {
    try {
      var TravelPixelPublisher = Publishers.TravelPixelPublisher;
      new TravelPixelPublisher(isDebugEnabled).publish(tealiumUtagData);
    } catch (e) {
      var debugLabel = ((tealiumUtagData || {}).pageInfo || {}).pageName;
      toLogStore('Something went wrong with Travel-pixel library', 'travel-pixel', VIEW_EVENT, debugLabel, true);
    }
  }
  function addTagCommander(tcContext, tcVars, isDebugEnabled) {
    try {
      var TagCommanderPublisher = Publishers.TagCommanderPublisher;
      new TagCommanderPublisher({
        config: tcContext,
        isDebugEnabled: isDebugEnabled
      }).publish(tcVars);
    } catch (err) {
      console.error('[PlatformAnalyticsPrime] TagCommander publishing failed because of: ' + err);
    }
  }
  module.exports = {
    UisPrime: UisPrime,
    publishTealiumData: publishTealiumData,
    getTrackApiUrl: getTrackApiUrl
  };

  /***/
}), (/* 17 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  var UisPublisher = __webpack_require__(18);
  var AdobePublisher = __webpack_require__(19);
  var TealiumPublisher = __webpack_require__(21);
  var _require = __webpack_require__(22),
    TagCommanderPublisher = _require.TagCommanderPublisher;
  var TravelPixelPublisher = __webpack_require__(23);
  module.exports = {
    UisPublisher: UisPublisher,
    AdobePublisher: AdobePublisher,
    TealiumPublisher: TealiumPublisher,
    TagCommanderPublisher: TagCommanderPublisher,
    TravelPixelPublisher: TravelPixelPublisher
  };

  /***/
}), (/* 18 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  /* WEBPACK VAR INJECTION */
  (function (global) {
    var _createClass = function () {
      function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }
      return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
      };
    }();
    function _classCallCheck(instance, Constructor) {
      if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
      }
    }
    var _require = __webpack_require__(1),
      toLogStore = _require.toLogStore;
    var defaultTrackApiUrl = '/api/uisprime/track';
    function post(uisUrl, data, httpRequest, isDebugEnabled, eventType, label, additionalHeaders) {
      var hcomOriginId = 'x-hcom-origin-id';
      var hcomPageId = 'x-page-id';
      var hcomHost = /https:\/\/\w+.(staging1-)?(hotels|hoteis|hoteles).(com|cn)\/*/;
      return new Promise(function (resolve, reject) {
        var init = {
          method: 'POST',
          body: data
        };
        httpRequest.onload = function () {
          if (httpRequest.status >= 200 && httpRequest.status < 300) {
            toLogStore({
              status: 'successful',
              url: uisUrl,
              sentData: data
            }, 'uis', eventType, label, isDebugEnabled);
            resolve(httpRequest);
          } else if (httpRequest.status === 405 && httpRequest.responseURL && httpRequest.responseURL.match(hcomHost)) {
            // the only way to pass cookies in a fetch is using the withCredential(true);
            // and it needs a XMLHttpRequest in a OPEN state (or it will throw an exception)
            var xmlHttpRequest = new XMLHttpRequest();
            xmlHttpRequest.withCredentials = true;
            resolve(post(httpRequest.responseURL, data, xmlHttpRequest, isDebugEnabled, eventType, label, additionalHeaders));
          } else {
            toLogStore({
              status: 'FAILED - Http ' + httpRequest.status,
              url: uisUrl,
              sentData: data
            }, 'uis', eventType, label, isDebugEnabled);
            reject(new Error('UIS (' + uisUrl + ')replied with HTTP status code: ' + httpRequest.status));
          }
        };
        httpRequest.onerror = function () {
          return reject(new Error('Could not connect to ', uisUrl));
        };
        httpRequest.ontimeout = function () {
          return reject(new Error('Request timed out.'));
        };
        httpRequest.open(init.method, uisUrl, true);
        httpRequest.setRequestHeader('Content-type', 'text/plain');
        if (additionalHeaders[hcomOriginId]) {
          httpRequest.setRequestHeader(hcomOriginId, additionalHeaders[hcomOriginId]);
        }
        if (additionalHeaders[hcomPageId]) {
          httpRequest.setRequestHeader(hcomPageId, additionalHeaders[hcomPageId]);
        }
        var requestBody = JSON.stringify(init.body);
        httpRequest.send(requestBody);
      });
    }
    var UisPublisher = function () {
      function UisPublisher() {
        var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
          isDebugEnabled: false,
          eventType: '',
          label: '',
          additionalHeaders: {}
        };
        _classCallCheck(this, UisPublisher);
        this.trackApiUrl = params.trackApiUrl || defaultTrackApiUrl;
        this.requestBody = {};
        this.isDebugEnabled = typeof params.isDebugEnabled === 'boolean' ? params.isDebugEnabled : false;
        this.eventType = params.eventType;
        this.label = params.label;
        if (typeof global.uisDebugXmlHttpRequest !== 'undefined') {
          this.xmlHttpRequest = global.uisDebugXmlHttpRequest;
        } else {
          this.xmlHttpRequest = new XMLHttpRequest();
        }
        this.additionalHeaders = params.additionalHeaders || {};
      }
      _createClass(UisPublisher, [{
        key: 'publish',
        value: function publish(data) {
          this.requestBody = data;
          return post(this.trackApiUrl, this.requestBody, this.xmlHttpRequest, this.isDebugEnabled, this.eventType, this.label, this.additionalHeaders);
        }
      }]);
      return UisPublisher;
    }();
    module.exports = UisPublisher;
    /* WEBPACK VAR INJECTION */
  }).call(this, __webpack_require__(0));

  /***/
}), (/* 19 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }
    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();
  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  var adobeLibrariesLoader = __webpack_require__(4);
  var appMeasurementLoader = __webpack_require__(5);
  var _require = __webpack_require__(1),
    toLogStore = _require.toLogStore;
  var VIEW_EVENT = 'view';
  var AdobePublisher = function () {
    function AdobePublisher() {
      var _this = this;
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        eventType: VIEW_EVENT,
        isDebugEnabled: false,
        context: context
      };
      _classCallCheck(this, AdobePublisher);
      this.isDebugEnabled = params.isDebugEnabled;
      this.eventType = params.eventType;
      this.readyToPublish = Promise.all([adobeLibrariesLoader.load(), appMeasurementLoader.load()]).then(function (results) {
        _this.s = results[1];
        _this.s.visitor = results[0];
      });
    }
    _createClass(AdobePublisher, [{
      key: 'publish',
      value: function publish(data, tealiumUtagData) {
        var _this2 = this;
        return this.readyToPublish.then(function () {
          var debugLabel = '';
          if (_this2.eventType === VIEW_EVENT) {
            debugLabel = ((tealiumUtagData || {}).pageInfo || {}).pageName;
            if (_this2.s && _this2.s.t) {
              try {
                _this2.s.t(data);
              } catch (e) {
                toLogStore('Something went wrong with minified appMeasurement lib at this.s.t(data)', 'adobe-publisher', _this2.eventType, debugLabel, true);
              }
            }
          } else {
            data.linkTrackVars = Object.keys(data).toString();
            setTrackEvents(data);
            var linkName = data.linkName || 'Custom Event';
            debugLabel = linkName.replace(/\s/g, '-');
            _this2.s.tl(true, 'o', linkName, data);
          }
          toLogStore({
            eventType: _this2.eventType,
            sentData: data
          }, 'adobe', _this2.eventType, debugLabel, _this2.isDebugEnabled);
          if (_this2.s && _this2.s.clearVars) {
            try {
              _this2.s.clearVars();
            } catch (e) {
              toLogStore('Something went wrong with minified appMeasurement lib at this.s.clearVars', 'adobe-publisher', _this2.eventType, debugLabel, true);
            }
          }
        });
      }
    }]);
    return AdobePublisher;
  }();
  function setTrackEvents(data) {
    if (data.events) {
      data.linkTrackEvents = data.events.replace(/=[^,]*/g, '');
    } else {
      data.linkTrackEvents = 'None';
    }
  }
  module.exports = AdobePublisher;

  /***/
}), (/* 20 */
/***/function (module, exports) {
  function AppMeasurement_Module_AudienceManagement(d) {
    var a = this;
    a.s = d;
    var b = window;
    b.s_c_in || (b.s_c_il = [], b.s_c_in = 0);
    a._il = b.s_c_il;
    a._in = b.s_c_in;
    a._il[a._in] = a;
    b.s_c_in++;
    a._c = "s_m";
    a.setup = function (c) {
      b.DIL && c && (c.disableDefaultRequest = !0, c.disableScriptAttachment = !0, c.disableCORS = !0, c.secureDataCollection = !1, a.instance = b.DIL.create(c), a.tools = b.DIL.tools);
    };
    a.isReady = function () {
      return a.instance ? !0 : !1;
    };
    a.getEventCallConfigParams = function () {
      return a.instance && a.instance.api && a.instance.api.getEventCallConfigParams ? a.instance.api.getEventCallConfigParams() : {};
    };
    a.passData = function (b) {
      a.instance && a.instance.api && a.instance.api.passData && a.instance.api.passData(b);
    };
  }
  !function (e) {
    var t = {};
    function n(r) {
      if (t[r]) return t[r].exports;
      var s = t[r] = {
        i: r,
        l: !1,
        exports: {}
      };
      return e[r].call(s.exports, s, s.exports, n), s.l = !0, s.exports;
    }
    n.m = e, n.c = t, n.d = function (e, t, r) {
      n.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: r
      });
    }, n.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, n.t = function (e, t) {
      if (1 & t && (e = n(e)), 8 & t) return e;
      if (4 & t && "object" == typeof e && e && e.__esModule) return e;
      var r = Object.create(null);
      if (n.r(r), Object.defineProperty(r, "default", {
        enumerable: !0,
        value: e
      }), 2 & t && "string" != typeof e) for (var s in e) n.d(r, s, function (t) {
        return e[t];
      }.bind(null, s));
      return r;
    }, n.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return n.d(t, "a", t), t;
    }, n.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, n.p = "", n(n.s = 0);
  }([function (e, t) {
    "function" != typeof window.DIL && (window.DIL = function (e) {
      var t,
        n,
        r,
        s,
        i,
        o,
        a,
        d,
        u,
        c,
        l,
        f,
        p,
        h,
        g,
        m,
        I,
        y = [];
      e !== Object(e) && (e = {}), r = e.partner, s = e.containerNSID, i = e.mappings, o = e.uuidCookie, a = !0 === e.enableErrorReporting, d = e.visitorService, u = e.declaredId, c = !0 === e.delayAllUntilWindowLoad, l = void 0 === e.secureDataCollection || !0 === e.secureDataCollection, f = "boolean" == typeof e.isCoopSafe ? e.isCoopSafe : null, p = !0 === e.disableDefaultRequest, h = e.afterResultForDefaultRequest, g = e.visitorConstructor, m = !0 === e.disableCORS, I = !0 === e.ignoreHardDependencyOnVisitorAPI, a && DIL.errorModule.activate(), I && y.push("Warning: this instance is configured to ignore the hard dependency on the VisitorAPI service. This means that no URL destinations will be fired if the instance has no connection to VisitorAPI. If the VisitorAPI service is not instantiated, ID syncs will not be fired either.");
      var v = !0 === window._dil_unit_tests;
      if ((t = arguments[1]) && y.push(t + ""), !r || "string" != typeof r) {
        var b = {
          name: "error",
          message: t = "DIL partner is invalid or not specified in initConfig",
          filename: "dil.js"
        };
        return DIL.errorModule.handleError(b), new Error(t);
      }
      if (t = "DIL containerNSID is invalid or not specified in initConfig, setting to default of 0", (s || "number" == typeof s) && (s = parseInt(s, 10), !isNaN(s) && s >= 0 && (t = "")), t && (s = 0, y.push(t), t = ""), (n = DIL.getDil(r, s)) instanceof DIL && n.api.getPartner() === r && n.api.getContainerNSID() === s) return n;
      if (!(this instanceof DIL)) return new DIL(e, "DIL was not instantiated with the 'new' operator, returning a valid instance with partner = " + r + " and containerNSID = " + s);
      DIL.registerDil(this, r, s);
      var O = {
        IS_HTTPS: l || "https:" === document.location.protocol,
        SIX_MONTHS_IN_MINUTES: 259200,
        IE_VERSION: function () {
          if (document.documentMode) return document.documentMode;
          for (var e = 7; e > 4; e--) {
            var t = document.createElement("div");
            if (t.innerHTML = "\x3c!--[if IE " + e + "]><span></span><![endif]--\x3e", t.getElementsByTagName("span").length) return t = null, e;
          }
          return null;
        }()
      };
      O.IS_IE_LESS_THAN_10 = "number" == typeof O.IE_VERSION && O.IE_VERSION < 10;
      var D = {
          stuffed: {}
        },
        _ = {},
        S = {
          firingQueue: [],
          fired: [],
          firing: !1,
          sent: [],
          errored: [],
          reservedKeys: {
            sids: !0,
            pdata: !0,
            logdata: !0,
            callback: !0,
            postCallbackFn: !0,
            useImageRequest: !0
          },
          firstRequestHasFired: !1,
          abortRequests: !1,
          num_of_cors_responses: 0,
          num_of_cors_errors: 0,
          corsErrorSources: [],
          num_of_img_responses: 0,
          num_of_img_errors: 0,
          platformParams: {
            d_nsid: s + "",
            d_rtbd: "json",
            d_jsonv: DIL.jsonVersion + "",
            d_dst: "1"
          },
          nonModStatsParams: {
            d_rtbd: !0,
            d_dst: !0,
            d_cts: !0,
            d_rs: !0
          },
          modStatsParams: null,
          adms: {
            TIME_TO_CATCH_ALL_REQUESTS_RELEASE: 3e4,
            calledBack: !1,
            mid: null,
            noVisitorAPI: null,
            VisitorAPI: null,
            instance: null,
            releaseType: "no VisitorAPI",
            isOptedOut: !0,
            isOptedOutCallbackCalled: !1,
            admsProcessingStarted: !1,
            process: function (e) {
              try {
                if (this.admsProcessingStarted) return;
                this.admsProcessingStarted = !0;
                var t,
                  n,
                  r,
                  i,
                  o,
                  a = this,
                  u = d;
                if ("function" == typeof e && "function" == typeof e.getInstance) {
                  if (u !== Object(u) || !(t = u.namespace) || "string" != typeof t) throw this.releaseType = "no namespace", new Error("DIL.create() needs the initConfig property `visitorService`:{namespace:'<Experience Cloud Org ID>'}");
                  if ((n = e.getInstance(t, {
                    idSyncContainerID: s
                  })) === Object(n) && n instanceof e && "function" == typeof n.isAllowed && "function" == typeof n.getMarketingCloudVisitorID && "function" == typeof n.getCustomerIDs && "function" == typeof n.isOptedOut && "function" == typeof n.publishDestinations) return this.VisitorAPI = e, n.isAllowed() ? (this.instance = n, r = function (e) {
                    "VisitorAPI" !== a.releaseType && (a.mid = e, a.releaseType = "VisitorAPI", a.releaseRequests());
                  }, "string" == typeof (i = n.getMarketingCloudVisitorID(r)) && i.length ? void r(i) : void setTimeout(function () {
                    "VisitorAPI" !== a.releaseType && (a.releaseType = "timeout", a.releaseRequests());
                  }, this.getLoadTimeout())) : (this.releaseType = "VisitorAPI is not allowed to write cookies", void this.releaseRequests());
                  throw this.releaseType = "invalid instance", o = "Invalid Visitor instance.", n === Object(n) && "function" != typeof n.publishDestinations && (o += " In particular, visitorInstance.publishDestinations is not a function. This is needed to fire URL destinations in DIL v8.0+ and should be present in Visitor v3.3+ ."), new Error(o);
                }
                throw this.noVisitorAPI = !0, new Error("Visitor does not exist.");
              } catch (e) {
                if (!I) throw new Error("Error in processing Visitor API, which is a hard dependency for DIL v8.0+: " + e.message);
                this.releaseRequests();
              }
            },
            releaseRequests: function () {
              this.calledBack = !0, S.registerRequest();
            },
            getMarketingCloudVisitorID: function () {
              return this.instance ? this.instance.getMarketingCloudVisitorID() : null;
            },
            getMIDQueryString: function () {
              var e = E.isPopulatedString,
                t = this.getMarketingCloudVisitorID();
              return e(this.mid) && this.mid === t || (this.mid = t), e(this.mid) ? "d_mid=" + this.mid + "&" : "";
            },
            getCustomerIDs: function () {
              return this.instance ? this.instance.getCustomerIDs() : null;
            },
            getCustomerIDsQueryString: function (e) {
              if (e === Object(e)) {
                var t,
                  n,
                  r,
                  s,
                  i = "",
                  o = [],
                  a = [];
                for (t in e) e.hasOwnProperty(t) && (a[0] = t, (n = e[t]) === Object(n) && (a[1] = n.id || "", a[2] = n.authState || 0, o.push(a), a = []));
                if (s = o.length) for (r = 0; r < s; r++) i += "&d_cid_ic=" + P.encodeAndBuildRequest(o[r], "%01");
                return i;
              }
              return "";
            },
            getIsOptedOut: function () {
              this.instance ? this.instance.isOptedOut([this, this.isOptedOutCallback], this.VisitorAPI.OptOut.GLOBAL, !0) : (this.isOptedOut = !1, this.isOptedOutCallbackCalled = !0);
            },
            isOptedOutCallback: function (e) {
              this.isOptedOut = e, this.isOptedOutCallbackCalled = !0, S.registerRequest();
            },
            getLoadTimeout: function () {
              var e = this.instance;
              if (e) {
                if ("function" == typeof e.getLoadTimeout) return e.getLoadTimeout();
                if (void 0 !== e.loadTimeout) return e.loadTimeout;
              }
              return this.TIME_TO_CATCH_ALL_REQUESTS_RELEASE;
            }
          },
          declaredId: {
            declaredId: {
              init: null,
              request: null
            },
            declaredIdCombos: {},
            setDeclaredId: function (e, t) {
              var n = E.isPopulatedString,
                r = encodeURIComponent;
              if (e === Object(e) && n(t)) {
                var s = e.dpid,
                  i = e.dpuuid,
                  o = null;
                if (n(s) && n(i)) return o = r(s) + "$" + r(i), !0 === this.declaredIdCombos[o] ? "setDeclaredId: combo exists for type '" + t + "'" : (this.declaredIdCombos[o] = !0, this.declaredId[t] = {
                  dpid: s,
                  dpuuid: i
                }, "setDeclaredId: succeeded for type '" + t + "'");
              }
              return "setDeclaredId: failed for type '" + t + "'";
            },
            getDeclaredIdQueryString: function () {
              var e = this.declaredId.request,
                t = this.declaredId.init,
                n = encodeURIComponent,
                r = "";
              return null !== e ? r = "&d_dpid=" + n(e.dpid) + "&d_dpuuid=" + n(e.dpuuid) : null !== t && (r = "&d_dpid=" + n(t.dpid) + "&d_dpuuid=" + n(t.dpuuid)), r;
            }
          },
          registerRequest: function (e) {
            var t,
              n = this.firingQueue;
            e === Object(e) && n.push(e), this.firing || !n.length || c && !DIL.windowLoaded || (this.adms.isOptedOutCallbackCalled || this.adms.getIsOptedOut(), this.adms.calledBack && !this.adms.isOptedOut && this.adms.isOptedOutCallbackCalled && (this.adms.isOptedOutCallbackCalled = !1, (t = n.shift()).src = t.src.replace(/demdex.net\/event\?d_nsid=/, "demdex.net/event?" + this.adms.getMIDQueryString() + "d_nsid="), E.isPopulatedString(t.corsPostData) && (t.corsPostData = t.corsPostData.replace(/^d_nsid=/, this.adms.getMIDQueryString() + "d_nsid=")), w.fireRequest(t), this.firstRequestHasFired || "script" !== t.tag && "cors" !== t.tag || (this.firstRequestHasFired = !0)));
          },
          processVisitorAPI: function () {
            this.adms.process(g || window.Visitor);
          },
          getCoopQueryString: function () {
            var e = "";
            return !0 === f ? e = "&d_coop_safe=1" : !1 === f && (e = "&d_coop_unsafe=1"), e;
          }
        },
        C = {
          sendingMessages: !1,
          messages: [],
          messagesPosted: [],
          messagesReceived: [],
          jsonForComparison: [],
          jsonDuplicates: [],
          jsonWaiting: [],
          jsonProcessed: [],
          requestToProcess: function (e, t) {
            var n,
              r = this;
            function s() {
              r.jsonForComparison.push(e), r.jsonWaiting.push([e, t]);
            }
            if (e && !E.isEmptyObject(e)) if (n = JSON.stringify(e.dests || []), this.jsonForComparison.length) {
              var i,
                o,
                a,
                d = !1;
              for (i = 0, o = this.jsonForComparison.length; i < o; i++) if (a = this.jsonForComparison[i], n === JSON.stringify(a.dests || [])) {
                d = !0;
                break;
              }
              d ? this.jsonDuplicates.push(e) : s();
            } else s();
            if (this.jsonWaiting.length) {
              var u = this.jsonWaiting.shift();
              this.process(u[0], u[1]), this.requestToProcess();
            }
            this.messages.length && !this.sendingMessages && this.sendMessages();
          },
          process: function (e, t) {
            var n,
              r,
              s,
              i,
              o,
              a = encodeURIComponent;
            if (t === Object(t) && P.encodeAndBuildRequest(["", t.dpid || "", t.dpuuid || ""], ","), (n = e.dests) && n instanceof Array && (r = n.length)) for (s = 0; s < r; s++) i = n[s], o = [a("dests"), a(i.id || ""), a(i.y || ""), a(i.c || "")], this.addMessage(o.join("|"));
            this.jsonProcessed.push(e);
          },
          addMessage: function (e) {
            this.messages.push(e);
          },
          sendMessages: function () {
            this.sendingMessages || (this.sendingMessages = !0, this.messages.length ? (this.publishDestinations(this.messages), this.messages = [], this.sendingMessages = !1) : this.sendingMessages = !1);
          },
          publishDestinations: function (e) {
            var t = S.adms.instance;
            t && "function" == typeof t.publishDestinations && t.publishDestinations(r, e, function (e) {
              y.push("visitor.publishDestinations() result: " + (e.error || e.message));
            }), Array.prototype.push.apply(this.messagesPosted, e);
          }
        },
        R = {
          traits: function (e) {
            return E.isValidPdata(e) && (_.sids instanceof Array || (_.sids = []), P.extendArray(_.sids, e)), this;
          },
          pixels: function (e) {
            return E.isValidPdata(e) && (_.pdata instanceof Array || (_.pdata = []), P.extendArray(_.pdata, e)), this;
          },
          logs: function (e) {
            return E.isValidLogdata(e) && (_.logdata !== Object(_.logdata) && (_.logdata = {}), P.extendObject(_.logdata, e)), this;
          },
          customQueryParams: function (e) {
            return E.isEmptyObject(e) || P.extendObject(_, e, S.reservedKeys), this;
          },
          signals: function (e, t) {
            var n,
              r = e;
            if (!E.isEmptyObject(r)) {
              if (t && "string" == typeof t) for (n in r = {}, e) e.hasOwnProperty(n) && (r[t + n] = e[n]);
              P.extendObject(_, r, S.reservedKeys);
            }
            return this;
          },
          declaredId: function (e) {
            return S.declaredId.setDeclaredId(e, "request"), this;
          },
          result: function (e) {
            return "function" == typeof e && (_.callback = e), this;
          },
          afterResult: function (e) {
            return "function" == typeof e && (_.postCallbackFn = e), this;
          },
          useImageRequest: function () {
            return _.useImageRequest = !0, this;
          },
          clearData: function () {
            return _ = {}, this;
          },
          submit: function () {
            return w.submitRequest(_), _ = {}, this;
          },
          getPartner: function () {
            return r;
          },
          getContainerNSID: function () {
            return s;
          },
          getEventLog: function () {
            return y;
          },
          getState: function () {
            var t = {},
              n = {};
            return P.extendObject(t, S, {
              registerRequest: !0
            }), P.extendObject(n, C, {
              requestToProcess: !0,
              process: !0,
              sendMessages: !0
            }), {
              initConfig: e,
              pendingRequest: _,
              otherRequestInfo: t,
              destinationPublishingInfo: n,
              log: y
            };
          },
          idSync: function () {
            throw new Error("Please use the `idSyncByURL` method of the Experience Cloud ID Service (Visitor) instance");
          },
          aamIdSync: function () {
            throw new Error("Please use the `idSyncByDataSource` method of the Experience Cloud ID Service (Visitor) instance");
          },
          passData: function (e) {
            return E.isEmptyObject(e) ? "Error: json is empty or not an object" : (w.defaultCallback(e), e);
          },
          getPlatformParams: function () {
            return S.platformParams;
          },
          getEventCallConfigParams: function () {
            var e,
              t = S,
              n = t.modStatsParams,
              r = t.platformParams;
            if (!n) {
              for (e in n = {}, r) r.hasOwnProperty(e) && !t.nonModStatsParams[e] && (n[e.replace(/^d_/, "")] = r[e]);
              !0 === f ? n.coop_safe = 1 : !1 === f && (n.coop_unsafe = 1), t.modStatsParams = n;
            }
            return n;
          },
          setAsCoopSafe: function () {
            return f = !0, this;
          },
          setAsCoopUnsafe: function () {
            return f = !1, this;
          }
        },
        w = {
          corsMetadata: function () {
            var e = "none";
            return "undefined" != typeof XMLHttpRequest && XMLHttpRequest === Object(XMLHttpRequest) && ("withCredentials" in new XMLHttpRequest() ? e = "XMLHttpRequest" : new Function("/*@cc_on return /^10/.test(@_jscript_version) @*/")() && (e = "XMLHttpRequest")), {
              corsType: e
            };
          }(),
          getCORSInstance: function () {
            return "none" === this.corsMetadata.corsType ? null : new window[this.corsMetadata.corsType]();
          },
          submitRequest: function (e) {
            return S.registerRequest(w.createQueuedRequest(e)), !0;
          },
          createQueuedRequest: function (e) {
            var t,
              n,
              r,
              s,
              o,
              a = e.callback,
              d = "img";
            if (!E.isEmptyObject(i)) for (r in i) if (i.hasOwnProperty(r)) {
              if (null == (s = i[r]) || "" === s) continue;
              if (r in e && !(s in e) && !(s in S.reservedKeys)) {
                if (null == (o = e[r]) || "" === o) continue;
                e[s] = o;
              }
            }
            return E.isValidPdata(e.sids) || (e.sids = []), E.isValidPdata(e.pdata) || (e.pdata = []), E.isValidLogdata(e.logdata) || (e.logdata = {}), e.logdataArray = P.convertObjectToKeyValuePairs(e.logdata, "=", !0), e.logdataArray.push("_ts=" + new Date().getTime()), "function" != typeof a && (a = this.defaultCallback), t = this.makeRequestSrcData(e), (n = this.getCORSInstance()) && !0 !== e.useImageRequest && (d = "cors"), {
              tag: d,
              src: t.src,
              corsSrc: t.corsSrc,
              callbackFn: a,
              postCallbackFn: e.postCallbackFn,
              useImageRequest: !!e.useImageRequest,
              requestData: e,
              corsInstance: n,
              corsPostData: t.corsPostData
            };
          },
          defaultCallback: function (e, t) {
            var n, r, s, i, a, d, u, c, l;
            if ((n = e.stuff) && n instanceof Array && (r = n.length)) for (s = 0; s < r; s++) (i = n[s]) && i === Object(i) && (a = i.cn, d = i.cv, void 0 !== (u = i.ttl) && "" !== u || (u = Math.floor(P.getMaxCookieExpiresInMinutes() / 60 / 24)), c = i.dmn || "." + document.domain.replace(/^www\./, ""), l = i.type, a && (d || "number" == typeof d) && ("var" !== l && (u = parseInt(u, 10)) && !isNaN(u) && P.setCookie(a, d, 24 * u * 60, "/", c, !1), D.stuffed[a] = d));
            var f,
              p,
              h = e.uuid;
            E.isPopulatedString(h) && (E.isEmptyObject(o) || ("string" == typeof (f = o.path) && f.length || (f = "/"), p = parseInt(o.days, 10), isNaN(p) && (p = 100), P.setCookie(o.name || "aam_did", h, 24 * p * 60, f, o.domain || "." + document.domain.replace(/^www\./, ""), !0 === o.secure))), S.abortRequests || C.requestToProcess(e, t);
          },
          makeRequestSrcData: function (e) {
            e.sids = E.removeEmptyArrayValues(e.sids || []), e.pdata = E.removeEmptyArrayValues(e.pdata || []);
            var t = S,
              n = t.platformParams,
              s = P.encodeAndBuildRequest(e.sids, ","),
              i = P.encodeAndBuildRequest(e.pdata, ","),
              o = (e.logdataArray || []).join("&");
            delete e.logdataArray;
            var a,
              d,
              u,
              c = O.IS_HTTPS ? "https://" : "http://",
              l = t.declaredId.getDeclaredIdQueryString(),
              f = t.adms.instance ? t.adms.getCustomerIDsQueryString(t.adms.getCustomerIDs()) : "",
              p = function () {
                var n,
                  r,
                  s,
                  i,
                  o = [];
                for (n in e) if (!(n in t.reservedKeys) && e.hasOwnProperty(n)) if (r = e[n], n = encodeURIComponent(n), r instanceof Array) for (s = 0, i = r.length; s < i; s++) o.push(n + "=" + encodeURIComponent(r[s]));else o.push(n + "=" + encodeURIComponent(r));
                return o.length ? "&" + o.join("&") : "";
              }(),
              h = "d_nsid=" + n.d_nsid + t.getCoopQueryString() + l + f + (s.length ? "&d_sid=" + s : "") + (i.length ? "&d_px=" + i : "") + (o.length ? "&d_ld=" + encodeURIComponent(o) : ""),
              g = "&d_rtbd=" + n.d_rtbd + "&d_jsonv=" + n.d_jsonv + "&d_dst=" + n.d_dst;
            return u = d = (a = c + r + ".demdex.net/event") + "?" + h + g + p, d.length > 2048 && (d = d.substring(0, 2048).substring(0, d.lastIndexOf("&"))), {
              corsSrc: a + "?_ts=" + new Date().getTime(),
              src: d,
              originalSrc: u,
              corsPostData: h + g + p,
              isDeclaredIdCall: "" !== l
            };
          },
          fireRequest: function (e) {
            if ("img" === e.tag) this.fireImage(e);else {
              var t = S.declaredId,
                n = t.declaredId.request || t.declaredId.init || {},
                r = {
                  dpid: n.dpid || "",
                  dpuuid: n.dpuuid || ""
                };
              this.fireCORS(e, r);
            }
          },
          fireImage: function (e) {
            var n,
              r,
              s = S;
            s.abortRequests || (s.firing = !0, n = new Image(0, 0), s.sent.push(e), n.onload = function () {
              s.firing = !1, s.fired.push(e), s.num_of_img_responses++, s.registerRequest();
            }, r = function (n) {
              t = "imgAbortOrErrorHandler received the event of type " + n.type, y.push(t), s.abortRequests = !0, s.firing = !1, s.errored.push(e), s.num_of_img_errors++, s.registerRequest();
            }, n.addEventListener("error", r), n.addEventListener("abort", r), n.src = e.src);
          },
          fireCORS: function (e, n) {
            var s = this,
              i = S,
              o = this.corsMetadata.corsType,
              a = e.corsSrc,
              d = e.corsInstance,
              u = e.corsPostData,
              c = e.postCallbackFn,
              l = "function" == typeof c;
            if (!i.abortRequests && !m) {
              i.firing = !0;
              try {
                d.open("post", a, !0), "XMLHttpRequest" === o && (d.withCredentials = !0, d.setRequestHeader("Content-Type", "application/x-www-form-urlencoded"), d.onreadystatechange = function () {
                  4 === this.readyState && 200 === this.status && function (o) {
                    var a;
                    try {
                      if ((a = JSON.parse(o)) !== Object(a)) return void s.handleCORSError(e, n, "Response is not JSON");
                    } catch (t) {
                      return void s.handleCORSError(e, n, "Error parsing response as JSON");
                    }
                    try {
                      var d = e.callbackFn;
                      i.firing = !1, i.fired.push(e), i.num_of_cors_responses++, d(a, n), l && c(a, n);
                    } catch (e) {
                      e.message = "DIL handleCORSResponse caught error with message " + e.message, t = e.message, y.push(t), e.filename = e.filename || "dil.js", e.partner = r, DIL.errorModule.handleError(e);
                      try {
                        d({
                          error: e.name + "|" + e.message
                        }, n), l && c({
                          error: e.name + "|" + e.message
                        }, n);
                      } catch (e) {}
                    } finally {
                      i.registerRequest();
                    }
                  }(this.responseText);
                }), d.onerror = function () {
                  s.handleCORSError(e, n, "onerror");
                }, d.ontimeout = function () {
                  s.handleCORSError(e, n, "ontimeout");
                }, d.send(u);
              } catch (t) {
                this.handleCORSError(e, n, "try-catch");
              }
              i.sent.push(e), i.declaredId.declaredId.request = null;
            }
          },
          handleCORSError: function (e, t, n) {
            S.num_of_cors_errors++, S.corsErrorSources.push(n);
          },
          handleRequestError: function (e, t) {
            var n = S;
            y.push(e), n.abortRequests = !0, n.firing = !1, n.errored.push(t), n.registerRequest();
          }
        },
        E = {
          isValidPdata: function (e) {
            return !!(e instanceof Array && this.removeEmptyArrayValues(e).length);
          },
          isValidLogdata: function (e) {
            return !this.isEmptyObject(e);
          },
          isEmptyObject: function (e) {
            if (e !== Object(e)) return !0;
            var t;
            for (t in e) if (e.hasOwnProperty(t)) return !1;
            return !0;
          },
          removeEmptyArrayValues: function (e) {
            var t,
              n = 0,
              r = e.length,
              s = [];
            for (n = 0; n < r; n++) void 0 !== (t = e[n]) && null !== t && "" !== t && s.push(t);
            return s;
          },
          isPopulatedString: function (e) {
            return "string" == typeof e && e.length;
          }
        },
        P = {
          convertObjectToKeyValuePairs: function (e, t, n) {
            var r,
              s,
              i = [];
            for (r in t || (t = "="), e) e.hasOwnProperty(r) && void 0 !== (s = e[r]) && null !== s && "" !== s && i.push(r + t + (n ? encodeURIComponent(s) : s));
            return i;
          },
          encodeAndBuildRequest: function (e, t) {
            return e.map(function (e) {
              return encodeURIComponent(e);
            }).join(t);
          },
          getCookie: function (e) {
            var t,
              n,
              r,
              s = e + "=",
              i = document.cookie.split(";");
            for (t = 0, n = i.length; t < n; t++) {
              for (r = i[t]; " " === r.charAt(0);) r = r.substring(1, r.length);
              if (0 === r.indexOf(s)) return decodeURIComponent(r.substring(s.length, r.length));
            }
            return null;
          },
          setCookie: function (e, t, n, r, s, i) {
            var o = new Date();
            n && (n = 1e3 * n * 60), document.cookie = e + "=" + encodeURIComponent(t) + (n ? ";expires=" + new Date(o.getTime() + n).toUTCString() : "") + (r ? ";path=" + r : "") + (s ? ";domain=" + s : "") + (i ? ";secure" : "");
          },
          extendArray: function (e, t) {
            return e instanceof Array && t instanceof Array && (Array.prototype.push.apply(e, t), !0);
          },
          extendObject: function (e, t, n) {
            var r;
            if (e === Object(e) && t === Object(t)) {
              for (r in t) if (t.hasOwnProperty(r)) {
                if (!E.isEmptyObject(n) && r in n) continue;
                e[r] = t[r];
              }
              return !0;
            }
            return !1;
          },
          getMaxCookieExpiresInMinutes: function () {
            return O.SIX_MONTHS_IN_MINUTES;
          },
          replaceMethodsWithFunction: function (e, t) {
            var n;
            if (e === Object(e) && "function" == typeof t) for (n in e) e.hasOwnProperty(n) && "function" == typeof e[n] && (e[n] = t);
          }
        };
      "error" === r && 0 === s && window.addEventListener("load", function () {
        DIL.windowLoaded = !0;
      });
      var L = !1,
        j = function () {
          L || (L = !0, S.registerRequest(), q());
        },
        q = function () {
          setTimeout(function () {
            p || S.firstRequestHasFired || ("function" == typeof h ? R.afterResult(h).submit() : R.submit());
          }, DIL.constants.TIME_TO_DEFAULT_REQUEST);
        },
        T = document;
      "error" !== r && (DIL.windowLoaded ? j() : "complete" !== T.readyState && "loaded" !== T.readyState ? window.addEventListener("load", function () {
        DIL.windowLoaded = !0, j();
      }) : (DIL.windowLoaded = !0, j())), S.declaredId.setDeclaredId(u, "init"), S.processVisitorAPI();
      O.IS_IE_LESS_THAN_10 && P.replaceMethodsWithFunction(R, function () {
        return this;
      }), this.api = R, this.getStuffedVariable = function (e) {
        var t = D.stuffed[e];
        return t || "number" == typeof t || (t = P.getCookie(e)) || "number" == typeof t || (t = ""), t;
      }, this.validators = E, this.helpers = P, this.constants = O, this.log = y, v && (this.pendingRequest = _, this.requestController = S, this.destinationPublishing = C, this.requestProcs = w, this.variables = D, this.callWindowLoadFunctions = j);
    }, DIL.extendStaticPropertiesAndMethods = function (e) {
      var t;
      if (e === Object(e)) for (t in e) e.hasOwnProperty(t) && (this[t] = e[t]);
    }, DIL.extendStaticPropertiesAndMethods({
      version: "8.0",
      jsonVersion: 1,
      constants: {
        TIME_TO_DEFAULT_REQUEST: 50
      },
      variables: {
        scriptNodeList: document.getElementsByTagName("script")
      },
      windowLoaded: !1,
      dils: {},
      isAddedPostWindowLoad: function () {
        var e = arguments[0];
        this.windowLoaded = "function" == typeof e ? !!e() : "boolean" != typeof e || e;
      },
      create: function (e) {
        try {
          return new DIL(e);
        } catch (e) {
          throw new Error("Error in attempt to create DIL instance with DIL.create(): " + e.message);
        }
      },
      registerDil: function (e, t, n) {
        var r = t + "$" + n;
        r in this.dils || (this.dils[r] = e);
      },
      getDil: function (e, t) {
        var n;
        return "string" != typeof e && (e = ""), t || (t = 0), (n = e + "$" + t) in this.dils ? this.dils[n] : new Error("The DIL instance with partner = " + e + " and containerNSID = " + t + " was not found");
      },
      dexGetQSVars: function (e, t, n) {
        var r = this.getDil(t, n);
        return r instanceof this ? r.getStuffedVariable(e) : "";
      }
    }), DIL.errorModule = function () {
      var e = DIL.create({
          partner: "error",
          containerNSID: 0,
          ignoreHardDependencyOnVisitorAPI: !0
        }),
        t = {
          harvestererror: 14138,
          destpuberror: 14139,
          dpmerror: 14140,
          generalerror: 14137,
          error: 14137,
          noerrortypedefined: 15021,
          evalerror: 15016,
          rangeerror: 15017,
          referenceerror: 15018,
          typeerror: 15019,
          urierror: 15020
        },
        n = !1;
      return {
        activate: function () {
          n = !0;
        },
        handleError: function (r) {
          if (!n) return "DIL error module has not been activated";
          r !== Object(r) && (r = {});
          var s = r.name ? (r.name + "").toLowerCase() : "",
            i = s in t ? t[s] : t.noerrortypedefined,
            o = [],
            a = {
              name: s,
              filename: r.filename ? r.filename + "" : "",
              partner: r.partner ? r.partner + "" : "no_partner",
              site: r.site ? r.site + "" : document.location.href,
              message: r.message ? r.message + "" : ""
            };
          return o.push(i), e.api.pixels(o).logs(a).useImageRequest().submit(), "DIL error report sent";
        },
        pixelMap: t
      };
    }(), DIL.tools = {}, DIL.modules = {
      helpers: {
        handleModuleError: function (e, t, n) {
          var r = "",
            s = t || "Error caught in DIL module/submodule: ";
          return e === Object(e) ? r = s + (e.message || "err has no message") : (r = s + "err is not a valid object", e = {}), e.message = r, n instanceof DIL && (e.partner = n.api.getPartner()), DIL.errorModule.handleError(e), this.errorMessage = r, r;
        }
      }
    });
  }]);
  /*
   ============== DO NOT ALTER ANYTHING BELOW THIS LINE ! ===============
  
  AppMeasurement for JavaScript version: 2.6.0
  Copyright 1996-2016 Adobe, Inc. All Rights Reserved
  More info available at http://www.adobe.com/marketing-cloud.html
  */
  function AppMeasurement(r) {
    var a = this;
    a.version = "2.6.0";
    var k = window;
    k.s_c_in || (k.s_c_il = [], k.s_c_in = 0);
    a._il = k.s_c_il;
    a._in = k.s_c_in;
    a._il[a._in] = a;
    k.s_c_in++;
    a._c = "s_c";
    var p = k.AppMeasurement.Pb;
    p || (p = null);
    var n = k,
      m,
      s;
    try {
      for (m = n.parent, s = n.location; m && m.location && s && "" + m.location != "" + s && n.location && "" + m.location != "" + n.location && m.location.host == s.host;) n = m, m = n.parent;
    } catch (u) {}
    a.F = function (a) {
      try {
        console.log(a);
      } catch (b) {}
    };
    a.Ma = function (a) {
      return "" + parseInt(a) == "" + a;
    };
    a.replace = function (a, b, d) {
      return !a || 0 > a.indexOf(b) ? a : a.split(b).join(d);
    };
    a.escape = function (c) {
      var b, d;
      if (!c) return c;
      c = encodeURIComponent(c);
      for (b = 0; 7 > b; b++) d = "+~!*()'".substring(b, b + 1), 0 <= c.indexOf(d) && (c = a.replace(c, d, "%" + d.charCodeAt(0).toString(16).toUpperCase()));
      return c;
    };
    a.unescape = function (c) {
      if (!c) return c;
      c = 0 <= c.indexOf("+") ? a.replace(c, "+", " ") : c;
      try {
        return decodeURIComponent(c);
      } catch (b) {}
      return unescape(c);
    };
    a.wb = function () {
      var c = k.location.hostname,
        b = a.fpCookieDomainPeriods,
        d;
      b || (b = a.cookieDomainPeriods);
      if (c && !a.Ea && !/^[0-9.]+$/.test(c) && (b = b ? parseInt(b) : 2, b = 2 < b ? b : 2, d = c.lastIndexOf("."), 0 <= d)) {
        for (; 0 <= d && 1 < b;) d = c.lastIndexOf(".", d - 1), b--;
        a.Ea = 0 < d ? c.substring(d) : c;
      }
      return a.Ea;
    };
    a.c_r = a.cookieRead = function (c) {
      c = a.escape(c);
      var b = " " + a.d.cookie,
        d = b.indexOf(" " + c + "="),
        f = 0 > d ? d : b.indexOf(";", d);
      c = 0 > d ? "" : a.unescape(b.substring(d + 2 + c.length, 0 > f ? b.length : f));
      return "[[B]]" != c ? c : "";
    };
    a.c_w = a.cookieWrite = function (c, b, d) {
      var f = a.wb(),
        e = a.cookieLifetime,
        g;
      b = "" + b;
      e = e ? ("" + e).toUpperCase() : "";
      d && "SESSION" != e && "NONE" != e && ((g = "" != b ? parseInt(e ? e : 0) : -60) ? (d = new Date(), d.setTime(d.getTime() + 1E3 * g)) : 1 == d && (d = new Date(), g = d.getYear(), d.setYear(g + 5 + (1900 > g ? 1900 : 0))));
      return c && "NONE" != e ? (a.d.cookie = a.escape(c) + "=" + a.escape("" != b ? b : "[[B]]") + "; path=/;" + (d && "SESSION" != e ? " expires=" + d.toUTCString() + ";" : "") + (f ? " domain=" + f + ";" : ""), a.cookieRead(c) == b) : 0;
    };
    a.L = [];
    a.ia = function (c, b, d) {
      if (a.Fa) return 0;
      a.maxDelay || (a.maxDelay = 250);
      var f = 0,
        e = new Date().getTime() + a.maxDelay,
        g = a.d.visibilityState,
        h = ["webkitvisibilitychange", "visibilitychange"];
      g || (g = a.d.webkitVisibilityState);
      if (g && "prerender" == g) {
        if (!a.ja) for (a.ja = 1, d = 0; d < h.length; d++) a.d.addEventListener(h[d], function () {
          var c = a.d.visibilityState;
          c || (c = a.d.webkitVisibilityState);
          "visible" == c && (a.ja = 0, a.delayReady());
        });
        f = 1;
        e = 0;
      } else d || a.p("_d") && (f = 1);
      f && (a.L.push({
        m: c,
        a: b,
        t: e
      }), a.ja || setTimeout(a.delayReady, a.maxDelay));
      return f;
    };
    a.delayReady = function () {
      var c = new Date().getTime(),
        b = 0,
        d;
      for (a.p("_d") ? b = 1 : a.xa(); 0 < a.L.length;) {
        d = a.L.shift();
        if (b && !d.t && d.t > c) {
          a.L.unshift(d);
          setTimeout(a.delayReady, parseInt(a.maxDelay / 2));
          break;
        }
        a.Fa = 1;
        a[d.m].apply(a, d.a);
        a.Fa = 0;
      }
    };
    a.setAccount = a.sa = function (c) {
      var b, d;
      if (!a.ia("setAccount", arguments)) if (a.account = c, a.allAccounts) for (b = a.allAccounts.concat(c.split(",")), a.allAccounts = [], b.sort(), d = 0; d < b.length; d++) 0 != d && b[d - 1] == b[d] || a.allAccounts.push(b[d]);else a.allAccounts = c.split(",");
    };
    a.foreachVar = function (c, b) {
      var d,
        f,
        e,
        g,
        h = "";
      e = f = "";
      if (a.lightProfileID) d = a.P, (h = a.lightTrackVars) && (h = "," + h + "," + a.na.join(",") + ",");else {
        d = a.g;
        if (a.pe || a.linkType) h = a.linkTrackVars, f = a.linkTrackEvents, a.pe && (e = a.pe.substring(0, 1).toUpperCase() + a.pe.substring(1), a[e] && (h = a[e].Nb, f = a[e].Mb));
        h && (h = "," + h + "," + a.H.join(",") + ",");
        f && h && (h += ",events,");
      }
      b && (b = "," + b + ",");
      for (f = 0; f < d.length; f++) e = d[f], (g = a[e]) && (!h || 0 <= h.indexOf("," + e + ",")) && (!b || 0 <= b.indexOf("," + e + ",")) && c(e, g);
    };
    a.r = function (c, b, d, f, e) {
      var g = "",
        h,
        l,
        k,
        q,
        m = 0;
      "contextData" == c && (c = "c");
      if (b) {
        for (h in b) if (!(Object.prototype[h] || e && h.substring(0, e.length) != e) && b[h] && (!d || 0 <= d.indexOf("," + (f ? f + "." : "") + h + ","))) {
          k = !1;
          if (m) for (l = 0; l < m.length; l++) h.substring(0, m[l].length) == m[l] && (k = !0);
          if (!k && ("" == g && (g += "&" + c + "."), l = b[h], e && (h = h.substring(e.length)), 0 < h.length)) if (k = h.indexOf("."), 0 < k) l = h.substring(0, k), k = (e ? e : "") + l + ".", m || (m = []), m.push(k), g += a.r(l, b, d, f, k);else if ("boolean" == typeof l && (l = l ? "true" : "false"), l) {
            if ("retrieveLightData" == f && 0 > e.indexOf(".contextData.")) switch (k = h.substring(0, 4), q = h.substring(4), h) {
              case "transactionID":
                h = "xact";
                break;
              case "channel":
                h = "ch";
                break;
              case "campaign":
                h = "v0";
                break;
              default:
                a.Ma(q) && ("prop" == k ? h = "c" + q : "eVar" == k ? h = "v" + q : "list" == k ? h = "l" + q : "hier" == k && (h = "h" + q, l = l.substring(0, 255)));
            }
            g += "&" + a.escape(h) + "=" + a.escape(l);
          }
        }
        "" != g && (g += "&." + c);
      }
      return g;
    };
    a.usePostbacks = 0;
    a.zb = function () {
      var c = "",
        b,
        d,
        f,
        e,
        g,
        h,
        l,
        k,
        q = "",
        m = "",
        n = e = "";
      if (a.lightProfileID) b = a.P, (q = a.lightTrackVars) && (q = "," + q + "," + a.na.join(",") + ",");else {
        b = a.g;
        if (a.pe || a.linkType) q = a.linkTrackVars, m = a.linkTrackEvents, a.pe && (e = a.pe.substring(0, 1).toUpperCase() + a.pe.substring(1), a[e] && (q = a[e].Nb, m = a[e].Mb));
        q && (q = "," + q + "," + a.H.join(",") + ",");
        m && (m = "," + m + ",", q && (q += ",events,"));
        a.events2 && (n += ("" != n ? "," : "") + a.events2);
      }
      if (a.visitor && a.visitor.getCustomerIDs) {
        e = p;
        if (g = a.visitor.getCustomerIDs()) for (d in g) Object.prototype[d] || (f = g[d], "object" == typeof f && (e || (e = {}), f.id && (e[d + ".id"] = f.id), f.authState && (e[d + ".as"] = f.authState)));
        e && (c += a.r("cid", e));
      }
      a.AudienceManagement && a.AudienceManagement.isReady() && (c += a.r("d", a.AudienceManagement.getEventCallConfigParams()));
      for (d = 0; d < b.length; d++) {
        e = b[d];
        g = a[e];
        f = e.substring(0, 4);
        h = e.substring(4);
        g || ("events" == e && n ? (g = n, n = "") : "marketingCloudOrgID" == e && a.visitor && (g = a.visitor.marketingCloudOrgID));
        if (g && (!q || 0 <= q.indexOf("," + e + ","))) {
          switch (e) {
            case "customerPerspective":
              e = "cp";
              break;
            case "marketingCloudOrgID":
              e = "mcorgid";
              break;
            case "supplementalDataID":
              e = "sdid";
              break;
            case "timestamp":
              e = "ts";
              break;
            case "dynamicVariablePrefix":
              e = "D";
              break;
            case "visitorID":
              e = "vid";
              break;
            case "marketingCloudVisitorID":
              e = "mid";
              break;
            case "analyticsVisitorID":
              e = "aid";
              break;
            case "audienceManagerLocationHint":
              e = "aamlh";
              break;
            case "audienceManagerBlob":
              e = "aamb";
              break;
            case "authState":
              e = "as";
              break;
            case "pageURL":
              e = "g";
              255 < g.length && (a.pageURLRest = g.substring(255), g = g.substring(0, 255));
              break;
            case "pageURLRest":
              e = "-g";
              break;
            case "referrer":
              e = "r";
              break;
            case "vmk":
            case "visitorMigrationKey":
              e = "vmt";
              break;
            case "visitorMigrationServer":
              e = "vmf";
              a.ssl && a.visitorMigrationServerSecure && (g = "");
              break;
            case "visitorMigrationServerSecure":
              e = "vmf";
              !a.ssl && a.visitorMigrationServer && (g = "");
              break;
            case "charSet":
              e = "ce";
              break;
            case "visitorNamespace":
              e = "ns";
              break;
            case "cookieDomainPeriods":
              e = "cdp";
              break;
            case "cookieLifetime":
              e = "cl";
              break;
            case "variableProvider":
              e = "vvp";
              break;
            case "currencyCode":
              e = "cc";
              break;
            case "channel":
              e = "ch";
              break;
            case "transactionID":
              e = "xact";
              break;
            case "campaign":
              e = "v0";
              break;
            case "latitude":
              e = "lat";
              break;
            case "longitude":
              e = "lon";
              break;
            case "resolution":
              e = "s";
              break;
            case "colorDepth":
              e = "c";
              break;
            case "javascriptVersion":
              e = "j";
              break;
            case "javaEnabled":
              e = "v";
              break;
            case "cookiesEnabled":
              e = "k";
              break;
            case "browserWidth":
              e = "bw";
              break;
            case "browserHeight":
              e = "bh";
              break;
            case "connectionType":
              e = "ct";
              break;
            case "homepage":
              e = "hp";
              break;
            case "events":
              n && (g += ("" != g ? "," : "") + n);
              if (m) for (h = g.split(","), g = "", f = 0; f < h.length; f++) l = h[f], k = l.indexOf("="), 0 <= k && (l = l.substring(0, k)), k = l.indexOf(":"), 0 <= k && (l = l.substring(0, k)), 0 <= m.indexOf("," + l + ",") && (g += (g ? "," : "") + h[f]);
              break;
            case "events2":
              g = "";
              break;
            case "contextData":
              c += a.r("c", a[e], q, e);
              g = "";
              break;
            case "lightProfileID":
              e = "mtp";
              break;
            case "lightStoreForSeconds":
              e = "mtss";
              a.lightProfileID || (g = "");
              break;
            case "lightIncrementBy":
              e = "mti";
              a.lightProfileID || (g = "");
              break;
            case "retrieveLightProfiles":
              e = "mtsr";
              break;
            case "deleteLightProfiles":
              e = "mtsd";
              break;
            case "retrieveLightData":
              a.retrieveLightProfiles && (c += a.r("mts", a[e], q, e));
              g = "";
              break;
            default:
              a.Ma(h) && ("prop" == f ? e = "c" + h : "eVar" == f ? e = "v" + h : "list" == f ? e = "l" + h : "hier" == f && (e = "h" + h, g = g.substring(0, 255)));
          }
          g && (c += "&" + e + "=" + ("pev" != e.substring(0, 3) ? a.escape(g) : g));
        }
        "pev3" == e && a.e && (c += a.e);
      }
      return c;
    };
    a.D = function (a) {
      var b = a.tagName;
      if ("undefined" != "" + a.Sb || "undefined" != "" + a.Ib && "HTML" != ("" + a.Ib).toUpperCase()) return "";
      b = b && b.toUpperCase ? b.toUpperCase() : "";
      "SHAPE" == b && (b = "");
      b && (("INPUT" == b || "BUTTON" == b) && a.type && a.type.toUpperCase ? b = a.type.toUpperCase() : !b && a.href && (b = "A"));
      return b;
    };
    a.Ia = function (a) {
      var b = k.location,
        d = a.href ? a.href : "",
        f,
        e,
        g;
      f = d.indexOf(":");
      e = d.indexOf("?");
      g = d.indexOf("/");
      d && (0 > f || 0 <= e && f > e || 0 <= g && f > g) && (e = a.protocol && 1 < a.protocol.length ? a.protocol : b.protocol ? b.protocol : "", f = b.pathname.lastIndexOf("/"), d = (e ? e + "//" : "") + (a.host ? a.host : b.host ? b.host : "") + ("/" != d.substring(0, 1) ? b.pathname.substring(0, 0 > f ? 0 : f) + "/" : "") + d);
      return d;
    };
    a.M = function (c) {
      var b = a.D(c),
        d,
        f,
        e = "",
        g = 0;
      return b && (d = c.protocol, f = c.onclick, !c.href || "A" != b && "AREA" != b || f && d && !(0 > d.toLowerCase().indexOf("javascript")) ? f ? (e = a.replace(a.replace(a.replace(a.replace("" + f, "\r", ""), "\n", ""), "\t", ""), " ", ""), g = 2) : "INPUT" == b || "SUBMIT" == b ? (c.value ? e = c.value : c.innerText ? e = c.innerText : c.textContent && (e = c.textContent), g = 3) : "IMAGE" == b && c.src && (e = c.src) : e = a.Ia(c), e) ? {
        id: e.substring(0, 100),
        type: g
      } : 0;
    };
    a.Qb = function (c) {
      for (var b = a.D(c), d = a.M(c); c && !d && "BODY" != b;) if (c = c.parentElement ? c.parentElement : c.parentNode) b = a.D(c), d = a.M(c);
      d && "BODY" != b || (c = 0);
      c && (b = c.onclick ? "" + c.onclick : "", 0 <= b.indexOf(".tl(") || 0 <= b.indexOf(".trackLink(")) && (c = 0);
      return c;
    };
    a.Hb = function () {
      var c,
        b,
        d = a.linkObject,
        f = a.linkType,
        e = a.linkURL,
        g,
        h;
      a.oa = 1;
      d || (a.oa = 0, d = a.clickObject);
      if (d) {
        c = a.D(d);
        for (b = a.M(d); d && !b && "BODY" != c;) if (d = d.parentElement ? d.parentElement : d.parentNode) c = a.D(d), b = a.M(d);
        b && "BODY" != c || (d = 0);
        if (d && !a.linkObject) {
          var l = d.onclick ? "" + d.onclick : "";
          if (0 <= l.indexOf(".tl(") || 0 <= l.indexOf(".trackLink(")) d = 0;
        }
      } else a.oa = 1;
      !e && d && (e = a.Ia(d));
      e && !a.linkLeaveQueryString && (g = e.indexOf("?"), 0 <= g && (e = e.substring(0, g)));
      if (!f && e) {
        var m = 0,
          q = 0,
          n;
        if (a.trackDownloadLinks && a.linkDownloadFileTypes) for (l = e.toLowerCase(), g = l.indexOf("?"), h = l.indexOf("#"), 0 <= g ? 0 <= h && h < g && (g = h) : g = h, 0 <= g && (l = l.substring(0, g)), g = a.linkDownloadFileTypes.toLowerCase().split(","), h = 0; h < g.length; h++) (n = g[h]) && l.substring(l.length - (n.length + 1)) == "." + n && (f = "d");
        if (a.trackExternalLinks && !f && (l = e.toLowerCase(), a.La(l) && (a.linkInternalFilters || (a.linkInternalFilters = k.location.hostname), g = 0, a.linkExternalFilters ? (g = a.linkExternalFilters.toLowerCase().split(","), m = 1) : a.linkInternalFilters && (g = a.linkInternalFilters.toLowerCase().split(",")), g))) {
          for (h = 0; h < g.length; h++) n = g[h], 0 <= l.indexOf(n) && (q = 1);
          q ? m && (f = "e") : m || (f = "e");
        }
      }
      a.linkObject = d;
      a.linkURL = e;
      a.linkType = f;
      if (a.trackClickMap || a.trackInlineStats) a.e = "", d && (f = a.pageName, e = 1, d = d.sourceIndex, f || (f = a.pageURL, e = 0), k.s_objectID && (b.id = k.s_objectID, d = b.type = 1), f && b && b.id && c && (a.e = "&pid=" + a.escape(f.substring(0, 255)) + (e ? "&pidt=" + e : "") + "&oid=" + a.escape(b.id.substring(0, 100)) + (b.type ? "&oidt=" + b.type : "") + "&ot=" + c + (d ? "&oi=" + d : "")));
    };
    a.Ab = function () {
      var c = a.oa,
        b = a.linkType,
        d = a.linkURL,
        f = a.linkName;
      b && (d || f) && (b = b.toLowerCase(), "d" != b && "e" != b && (b = "o"), a.pe = "lnk_" + b, a.pev1 = d ? a.escape(d) : "", a.pev2 = f ? a.escape(f) : "", c = 1);
      a.abort && (c = 0);
      if (a.trackClickMap || a.trackInlineStats || a.ActivityMap) {
        var b = {},
          d = 0,
          e = a.cookieRead("s_sq"),
          g = e ? e.split("&") : 0,
          h,
          l,
          k,
          e = 0;
        if (g) for (h = 0; h < g.length; h++) l = g[h].split("="), f = a.unescape(l[0]).split(","), l = a.unescape(l[1]), b[l] = f;
        f = a.account.split(",");
        h = {};
        for (k in a.contextData) k && !Object.prototype[k] && "a.activitymap." == k.substring(0, 14) && (h[k] = a.contextData[k], a.contextData[k] = "");
        a.e = a.r("c", h) + (a.e ? a.e : "");
        if (c || a.e) {
          c && !a.e && (e = 1);
          for (l in b) if (!Object.prototype[l]) for (k = 0; k < f.length; k++) for (e && (g = b[l].join(","), g == a.account && (a.e += ("&" != l.charAt(0) ? "&" : "") + l, b[l] = [], d = 1)), h = 0; h < b[l].length; h++) g = b[l][h], g == f[k] && (e && (a.e += "&u=" + a.escape(g) + ("&" != l.charAt(0) ? "&" : "") + l + "&u=0"), b[l].splice(h, 1), d = 1);
          c || (d = 1);
          if (d) {
            e = "";
            h = 2;
            !c && a.e && (e = a.escape(f.join(",")) + "=" + a.escape(a.e), h = 1);
            for (l in b) !Object.prototype[l] && 0 < h && 0 < b[l].length && (e += (e ? "&" : "") + a.escape(b[l].join(",")) + "=" + a.escape(l), h--);
            a.cookieWrite("s_sq", e);
          }
        }
      }
      return c;
    };
    a.Bb = function () {
      if (!a.Lb) {
        var c = new Date(),
          b = n.location,
          d,
          f,
          e = f = d = "",
          g = "",
          h = "",
          l = "1.2",
          k = a.cookieWrite("s_cc", "true", 0) ? "Y" : "N",
          m = "",
          p = "";
        if (c.setUTCDate && (l = "1.3", 0 .toPrecision && (l = "1.5", c = [], c.forEach))) {
          l = "1.6";
          f = 0;
          d = {};
          try {
            f = new Iterator(d), f.next && (l = "1.7", c.reduce && (l = "1.8", l.trim && (l = "1.8.1", Date.parse && (l = "1.8.2", Object.create && (l = "1.8.5")))));
          } catch (r) {}
        }
        d = screen.width + "x" + screen.height;
        e = navigator.javaEnabled() ? "Y" : "N";
        f = screen.pixelDepth ? screen.pixelDepth : screen.colorDepth;
        g = a.w.innerWidth ? a.w.innerWidth : a.d.documentElement.offsetWidth;
        h = a.w.innerHeight ? a.w.innerHeight : a.d.documentElement.offsetHeight;
        try {
          a.b.addBehavior("#default#homePage"), m = a.b.Rb(b) ? "Y" : "N";
        } catch (s) {}
        try {
          a.b.addBehavior("#default#clientCaps"), p = a.b.connectionType;
        } catch (t) {}
        a.resolution = d;
        a.colorDepth = f;
        a.javascriptVersion = l;
        a.javaEnabled = e;
        a.cookiesEnabled = k;
        a.browserWidth = g;
        a.browserHeight = h;
        a.connectionType = p;
        a.homepage = m;
        a.Lb = 1;
      }
    };
    a.Q = {};
    a.loadModule = function (c, b) {
      var d = a.Q[c];
      if (!d) {
        d = k["AppMeasurement_Module_" + c] ? new k["AppMeasurement_Module_" + c](a) : {};
        a.Q[c] = a[c] = d;
        d.eb = function () {
          return d.ib;
        };
        d.jb = function (b) {
          if (d.ib = b) a[c + "_onLoad"] = b, a.ia(c + "_onLoad", [a, d], 1) || b(a, d);
        };
        try {
          Object.defineProperty ? Object.defineProperty(d, "onLoad", {
            get: d.eb,
            set: d.jb
          }) : d._olc = 1;
        } catch (f) {
          d._olc = 1;
        }
      }
      b && (a[c + "_onLoad"] = b, a.ia(c + "_onLoad", [a, d], 1) || b(a, d));
    };
    a.p = function (c) {
      var b, d;
      for (b in a.Q) if (!Object.prototype[b] && (d = a.Q[b]) && (d._olc && d.onLoad && (d._olc = 0, d.onLoad(a, d)), d[c] && d[c]())) return 1;
      return 0;
    };
    a.Db = function () {
      var c = Math.floor(1E13 * Math.random()),
        b = a.visitorSampling,
        d = a.visitorSamplingGroup,
        d = "s_vsn_" + (a.visitorNamespace ? a.visitorNamespace : a.account) + (d ? "_" + d : ""),
        f = a.cookieRead(d);
      if (b) {
        b *= 100;
        f && (f = parseInt(f));
        if (!f) {
          if (!a.cookieWrite(d, c)) return 0;
          f = c;
        }
        if (f % 1E4 > b) return 0;
      }
      return 1;
    };
    a.R = function (c, b) {
      var d, f, e, g, h, l;
      for (d = 0; 2 > d; d++) for (f = 0 < d ? a.Aa : a.g, e = 0; e < f.length; e++) if (g = f[e], (h = c[g]) || c["!" + g]) {
        if (!b && ("contextData" == g || "retrieveLightData" == g) && a[g]) for (l in a[g]) h[l] || (h[l] = a[g][l]);
        a[g] = h;
      }
    };
    a.Va = function (c, b) {
      var d, f, e, g;
      for (d = 0; 2 > d; d++) for (f = 0 < d ? a.Aa : a.g, e = 0; e < f.length; e++) g = f[e], c[g] = a[g], b || c[g] || (c["!" + g] = 1);
    };
    a.vb = function (a) {
      var b,
        d,
        f,
        e,
        g,
        h = 0,
        l,
        k = "",
        m = "";
      if (a && 255 < a.length && (b = "" + a, d = b.indexOf("?"), 0 < d && (l = b.substring(d + 1), b = b.substring(0, d), e = b.toLowerCase(), f = 0, "http://" == e.substring(0, 7) ? f += 7 : "https://" == e.substring(0, 8) && (f += 8), d = e.indexOf("/", f), 0 < d && (e = e.substring(f, d), g = b.substring(d), b = b.substring(0, d), 0 <= e.indexOf("google") ? h = ",q,ie,start,search_key,word,kw,cd," : 0 <= e.indexOf("yahoo.co") && (h = ",p,ei,"), h && l)))) {
        if ((a = l.split("&")) && 1 < a.length) {
          for (f = 0; f < a.length; f++) e = a[f], d = e.indexOf("="), 0 < d && 0 <= h.indexOf("," + e.substring(0, d) + ",") ? k += (k ? "&" : "") + e : m += (m ? "&" : "") + e;
          k && m ? l = k + "&" + m : m = "";
        }
        d = 253 - (l.length - m.length) - b.length;
        a = b + (0 < d ? g.substring(0, d) : "") + "?" + l;
      }
      return a;
    };
    a.ab = function (c) {
      var b = a.d.visibilityState,
        d = ["webkitvisibilitychange", "visibilitychange"];
      b || (b = a.d.webkitVisibilityState);
      if (b && "prerender" == b) {
        if (c) for (b = 0; b < d.length; b++) a.d.addEventListener(d[b], function () {
          var b = a.d.visibilityState;
          b || (b = a.d.webkitVisibilityState);
          "visible" == b && c();
        });
        return !1;
      }
      return !0;
    };
    a.ea = !1;
    a.J = !1;
    a.lb = function () {
      a.J = !0;
      a.j();
    };
    a.ca = !1;
    a.V = !1;
    a.hb = function (c) {
      a.marketingCloudVisitorID = c;
      a.V = !0;
      a.j();
    };
    a.fa = !1;
    a.W = !1;
    a.mb = function (c) {
      a.visitorOptedOut = c;
      a.W = !0;
      a.j();
    };
    a.Z = !1;
    a.S = !1;
    a.Xa = function (c) {
      a.analyticsVisitorID = c;
      a.S = !0;
      a.j();
    };
    a.ba = !1;
    a.U = !1;
    a.Za = function (c) {
      a.audienceManagerLocationHint = c;
      a.U = !0;
      a.j();
    };
    a.aa = !1;
    a.T = !1;
    a.Ya = function (c) {
      a.audienceManagerBlob = c;
      a.T = !0;
      a.j();
    };
    a.$a = function (c) {
      a.maxDelay || (a.maxDelay = 250);
      return a.p("_d") ? (c && setTimeout(function () {
        c();
      }, a.maxDelay), !1) : !0;
    };
    a.da = !1;
    a.I = !1;
    a.xa = function () {
      a.I = !0;
      a.j();
    };
    a.isReadyToTrack = function () {
      var c = !0,
        b = a.visitor,
        d,
        f,
        e;
      a.ea || a.J || (a.ab(a.lb) ? a.J = !0 : a.ea = !0);
      if (a.ea && !a.J) return !1;
      b && b.isAllowed() && (a.ca || a.marketingCloudVisitorID || !b.getMarketingCloudVisitorID || (a.ca = !0, a.marketingCloudVisitorID = b.getMarketingCloudVisitorID([a, a.hb]), a.marketingCloudVisitorID && (a.V = !0)), a.fa || a.visitorOptedOut || !b.isOptedOut || (a.fa = !0, a.visitorOptedOut = b.isOptedOut([a, a.mb]), a.visitorOptedOut != p && (a.W = !0)), a.Z || a.analyticsVisitorID || !b.getAnalyticsVisitorID || (a.Z = !0, a.analyticsVisitorID = b.getAnalyticsVisitorID([a, a.Xa]), a.analyticsVisitorID && (a.S = !0)), a.ba || a.audienceManagerLocationHint || !b.getAudienceManagerLocationHint || (a.ba = !0, a.audienceManagerLocationHint = b.getAudienceManagerLocationHint([a, a.Za]), a.audienceManagerLocationHint && (a.U = !0)), a.aa || a.audienceManagerBlob || !b.getAudienceManagerBlob || (a.aa = !0, a.audienceManagerBlob = b.getAudienceManagerBlob([a, a.Ya]), a.audienceManagerBlob && (a.T = !0)), c = a.ca && !a.V && !a.marketingCloudVisitorID, b = a.Z && !a.S && !a.analyticsVisitorID, d = a.ba && !a.U && !a.audienceManagerLocationHint, f = a.aa && !a.T && !a.audienceManagerBlob, e = a.fa && !a.W, c = c || b || d || f || e ? !1 : !0);
      a.da || a.I || (a.$a(a.xa) ? a.I = !0 : a.da = !0);
      a.da && !a.I && (c = !1);
      return c;
    };
    a.o = p;
    a.u = 0;
    a.callbackWhenReadyToTrack = function (c, b, d) {
      var f;
      f = {};
      f.qb = c;
      f.pb = b;
      f.nb = d;
      a.o == p && (a.o = []);
      a.o.push(f);
      0 == a.u && (a.u = setInterval(a.j, 100));
    };
    a.j = function () {
      var c;
      if (a.isReadyToTrack() && (a.kb(), a.o != p)) for (; 0 < a.o.length;) c = a.o.shift(), c.pb.apply(c.qb, c.nb);
    };
    a.kb = function () {
      a.u && (clearInterval(a.u), a.u = 0);
    };
    a.fb = function (c) {
      var b,
        d,
        f = p,
        e = p;
      if (!a.isReadyToTrack()) {
        b = [];
        if (c != p) for (d in f = {}, c) f[d] = c[d];
        e = {};
        a.Va(e, !0);
        b.push(f);
        b.push(e);
        a.callbackWhenReadyToTrack(a, a.track, b);
        return !0;
      }
      return !1;
    };
    a.xb = function () {
      var c = a.cookieRead("s_fid"),
        b = "",
        d = "",
        f;
      f = 8;
      var e = 4;
      if (!c || 0 > c.indexOf("-")) {
        for (c = 0; 16 > c; c++) f = Math.floor(Math.random() * f), b += "0123456789ABCDEF".substring(f, f + 1), f = Math.floor(Math.random() * e), d += "0123456789ABCDEF".substring(f, f + 1), f = e = 16;
        c = b + "-" + d;
      }
      a.cookieWrite("s_fid", c, 1) || (c = 0);
      return c;
    };
    a.t = a.track = function (c, b) {
      var d,
        f = new Date(),
        e = "s" + Math.floor(f.getTime() / 108E5) % 10 + Math.floor(1E13 * Math.random()),
        g = f.getYear(),
        g = "t=" + a.escape(f.getDate() + "/" + f.getMonth() + "/" + (1900 > g ? g + 1900 : g) + " " + f.getHours() + ":" + f.getMinutes() + ":" + f.getSeconds() + " " + f.getDay() + " " + f.getTimezoneOffset());
      a.visitor && a.visitor.getAuthState && (a.authState = a.visitor.getAuthState());
      a.p("_s");
      a.fb(c) || (b && a.R(b), c && (d = {}, a.Va(d, 0), a.R(c)), a.Db() && !a.visitorOptedOut && (a.analyticsVisitorID || a.marketingCloudVisitorID || (a.fid = a.xb()), a.Hb(), a.usePlugins && a.doPlugins && a.doPlugins(a), a.account && (a.abort || (a.trackOffline && !a.timestamp && (a.timestamp = Math.floor(f.getTime() / 1E3)), f = k.location, a.pageURL || (a.pageURL = f.href ? f.href : f), a.referrer || a.Wa || (f = a.Util.getQueryParam("adobe_mc_ref", null, null, !0), a.referrer = f || void 0 === f ? void 0 === f ? "" : f : n.document.referrer), a.Wa = 1, a.referrer = a.vb(a.referrer), a.p("_g")), a.Ab() && !a.abort && (a.visitor && !a.supplementalDataID && a.visitor.getSupplementalDataID && (a.supplementalDataID = a.visitor.getSupplementalDataID("AppMeasurement:" + a._in, a.expectSupplementalData ? !1 : !0)), a.Bb(), g += a.zb(), a.Gb(e, g), a.p("_t"), a.referrer = ""))), c && a.R(d, 1));
      a.abort = a.supplementalDataID = a.timestamp = a.pageURLRest = a.linkObject = a.clickObject = a.linkURL = a.linkName = a.linkType = k.s_objectID = a.pe = a.pev1 = a.pev2 = a.pev3 = a.e = a.lightProfileID = 0;
    };
    a.za = [];
    a.registerPreTrackCallback = function (c) {
      for (var b = [], d = 1; d < arguments.length; d++) b.push(arguments[d]);
      "function" == typeof c ? a.za.push([c, b]) : a.debugTracking && a.F("DEBUG: Non function type passed to registerPreTrackCallback");
    };
    a.cb = function (c) {
      a.wa(a.za, c);
    };
    a.ya = [];
    a.registerPostTrackCallback = function (c) {
      for (var b = [], d = 1; d < arguments.length; d++) b.push(arguments[d]);
      "function" == typeof c ? a.ya.push([c, b]) : a.debugTracking && a.F("DEBUG: Non function type passed to registerPostTrackCallback");
    };
    a.bb = function (c) {
      a.wa(a.ya, c);
    };
    a.wa = function (c, b) {
      if ("object" == typeof c) for (var d = 0; d < c.length; d++) {
        var f = c[d][0],
          e = c[d][1];
        e.unshift(b);
        if ("function" == typeof f) try {
          f.apply(null, e);
        } catch (g) {
          a.debugTracking && a.F(g.message);
        }
      }
    };
    a.tl = a.trackLink = function (c, b, d, f, e) {
      a.linkObject = c;
      a.linkType = b;
      a.linkName = d;
      e && (a.l = c, a.A = e);
      return a.track(f);
    };
    a.trackLight = function (c, b, d, f) {
      a.lightProfileID = c;
      a.lightStoreForSeconds = b;
      a.lightIncrementBy = d;
      return a.track(f);
    };
    a.clearVars = function () {
      var c, b;
      for (c = 0; c < a.g.length; c++) if (b = a.g[c], "prop" == b.substring(0, 4) || "eVar" == b.substring(0, 4) || "hier" == b.substring(0, 4) || "list" == b.substring(0, 4) || "channel" == b || "events" == b || "eventList" == b || "products" == b || "productList" == b || "purchaseID" == b || "transactionID" == b || "state" == b || "zip" == b || "campaign" == b) a[b] = void 0;
    };
    a.tagContainerMarker = "";
    a.Gb = function (c, b) {
      var d,
        f = a.trackingServer;
      d = "";
      var e = a.dc,
        g = "sc.",
        h = a.visitorNamespace;
      f ? a.trackingServerSecure && a.ssl && (f = a.trackingServerSecure) : (h || (h = a.account, f = h.indexOf(","), 0 <= f && (h = h.substring(0, f)), h = h.replace(/[^A-Za-z0-9]/g, "")), d || (d = "2o7.net"), e = e ? ("" + e).toLowerCase() : "d1", "2o7.net" == d && ("d1" == e ? e = "112" : "d2" == e && (e = "122"), g = ""), f = h + "." + e + "." + g + d);
      d = a.ssl ? "https://" : "http://";
      e = a.AudienceManagement && a.AudienceManagement.isReady() || 0 != a.usePostbacks;
      d += f + "/b/ss/" + a.account + "/" + (a.mobile ? "5." : "") + (e ? "10" : "1") + "/JS-" + a.version + (a.Kb ? "T" : "") + (a.tagContainerMarker ? "-" + a.tagContainerMarker : "") + "/" + c + "?AQB=1&ndh=1&pf=1&" + (e ? "callback=s_c_il[" + a._in + "].doPostbacks&et=1&" : "") + b + "&AQE=1";
      a.cb(d);
      a.tb(d);
      a.ka();
    };
    a.Ua = /{(%?)(.*?)(%?)}/;
    a.Ob = RegExp(a.Ua.source, "g");
    a.ub = function (c) {
      if ("object" == typeof c.dests) for (var b = 0; b < c.dests.length; ++b) {
        var d = c.dests[b];
        if ("string" == typeof d.c && "aa." == d.id.substr(0, 3)) for (var f = d.c.match(a.Ob), e = 0; e < f.length; ++e) {
          var g = f[e],
            h = g.match(a.Ua),
            k = "";
          "%" == h[1] && "timezone_offset" == h[2] ? k = new Date().getTimezoneOffset() : "%" == h[1] && "timestampz" == h[2] && (k = a.yb());
          d.c = d.c.replace(g, a.escape(k));
        }
      }
    };
    a.yb = function () {
      var c = new Date(),
        b = new Date(6E4 * Math.abs(c.getTimezoneOffset()));
      return a.k(4, c.getFullYear()) + "-" + a.k(2, c.getMonth() + 1) + "-" + a.k(2, c.getDate()) + "T" + a.k(2, c.getHours()) + ":" + a.k(2, c.getMinutes()) + ":" + a.k(2, c.getSeconds()) + (0 < c.getTimezoneOffset() ? "-" : "+") + a.k(2, b.getUTCHours()) + ":" + a.k(2, b.getUTCMinutes());
    };
    a.k = function (a, b) {
      return (Array(a + 1).join(0) + b).slice(-a);
    };
    a.ta = {};
    a.doPostbacks = function (c) {
      if ("object" == typeof c) if (a.ub(c), "object" == typeof a.AudienceManagement && "function" == typeof a.AudienceManagement.isReady && a.AudienceManagement.isReady() && "function" == typeof a.AudienceManagement.passData) a.AudienceManagement.passData(c);else if ("object" == typeof c && "object" == typeof c.dests) for (var b = 0; b < c.dests.length; ++b) {
        var d = c.dests[b];
        "object" == typeof d && "string" == typeof d.c && "string" == typeof d.id && "aa." == d.id.substr(0, 3) && (a.ta[d.id] = new Image(), a.ta[d.id].alt = "", a.ta[d.id].src = d.c);
      }
    };
    a.tb = function (c) {
      a.i || a.Cb();
      a.i.push(c);
      a.ma = a.C();
      a.Sa();
    };
    a.Cb = function () {
      a.i = a.Eb();
      a.i || (a.i = []);
    };
    a.Eb = function () {
      var c, b;
      if (a.ra()) {
        try {
          (b = k.localStorage.getItem(a.pa())) && (c = k.JSON.parse(b));
        } catch (d) {}
        return c;
      }
    };
    a.ra = function () {
      var c = !0;
      a.trackOffline && a.offlineFilename && k.localStorage && k.JSON || (c = !1);
      return c;
    };
    a.Ja = function () {
      var c = 0;
      a.i && (c = a.i.length);
      a.q && c++;
      return c;
    };
    a.ka = function () {
      if (a.q && (a.B && a.B.complete && a.B.G && a.B.va(), a.q)) return;
      a.Ka = p;
      if (a.qa) a.ma > a.O && a.Qa(a.i), a.ua(500);else {
        var c = a.ob();
        if (0 < c) a.ua(c);else if (c = a.Ga()) a.q = 1, a.Fb(c), a.Jb(c);
      }
    };
    a.ua = function (c) {
      a.Ka || (c || (c = 0), a.Ka = setTimeout(a.ka, c));
    };
    a.ob = function () {
      var c;
      if (!a.trackOffline || 0 >= a.offlineThrottleDelay) return 0;
      c = a.C() - a.Pa;
      return a.offlineThrottleDelay < c ? 0 : a.offlineThrottleDelay - c;
    };
    a.Ga = function () {
      if (0 < a.i.length) return a.i.shift();
    };
    a.Fb = function (c) {
      if (a.debugTracking) {
        var b = "AppMeasurement Debug: " + c;
        c = c.split("&");
        var d;
        for (d = 0; d < c.length; d++) b += "\n\t" + a.unescape(c[d]);
        a.F(b);
      }
    };
    a.gb = function () {
      return a.marketingCloudVisitorID || a.analyticsVisitorID;
    };
    a.Y = !1;
    var t;
    try {
      t = JSON.parse('{"x":"y"}');
    } catch (w) {
      t = null;
    }
    t && "y" == t.x ? (a.Y = !0, a.X = function (a) {
      return JSON.parse(a);
    }) : k.$ && k.$.parseJSON ? (a.X = function (a) {
      return k.$.parseJSON(a);
    }, a.Y = !0) : a.X = function () {
      return null;
    };
    a.Jb = function (c) {
      var b, d, f;
      a.gb() && ("undefined" != typeof XMLHttpRequest && (b = new XMLHttpRequest(), "withCredentials" in b ? d = 1 : b = 0), b || "undefined" == typeof XDomainRequest || (b = new XDomainRequest(), d = 2), b && (a.AudienceManagement && a.AudienceManagement.isReady() || 0 != a.usePostbacks) && (a.Y ? b.Ba = !0 : b = 0));
      !b;
      !b && a.d.createElement && (0 != a.usePostbacks || a.AudienceManagement && a.AudienceManagement.isReady()) && (b = a.d.createElement("SCRIPT")) && "async" in b && ((f = (f = a.d.getElementsByTagName("HEAD")) && f[0] ? f[0] : a.d.body) ? (b.type = "text/javascript", b.setAttribute("async", "async"), d = 3) : b = 0);
      b || (b = new Image(), b.alt = "", b.abort || "undefined" === typeof k.InstallTrigger || (b.abort = function () {
        b.src = p;
      }));
      b.Da = function () {
        try {
          b.G && (clearTimeout(b.G), b.G = 0);
        } catch (a) {}
      };
      b.onload = b.va = function () {
        a.bb(c);
        b.Da();
        a.sb();
        a.ga();
        a.q = 0;
        a.ka();
        if (b.Ba) {
          b.Ba = !1;
          try {
            a.doPostbacks(a.X(b.responseText));
          } catch (d) {}
        }
      };
      b.onabort = b.onerror = b.Ha = function () {
        b.Da();
        (a.trackOffline || a.qa) && a.q && a.i.unshift(a.rb);
        a.q = 0;
        a.ma > a.O && a.Qa(a.i);
        a.ga();
        a.ua(500);
      };
      b.onreadystatechange = function () {
        4 == b.readyState && (200 == b.status ? b.va() : b.Ha());
      };
      a.Pa = a.C();
      if (1 == d || 2 == d) {
        var e = c.indexOf("?");
        f = c.substring(0, e);
        e = c.substring(e + 1);
        e = e.replace(/&callback=[a-zA-Z0-9_.\[\]]+/, "");
        1 == d ? (b.open("POST", f, !0), b.send(e)) : 2 == d && (b.open("POST", f), b.send(e));
      } else if (b.src = c, 3 == d) {
        if (a.Na) try {
          f.removeChild(a.Na);
        } catch (g) {}
        f.firstChild ? f.insertBefore(b, f.firstChild) : f.appendChild(b);
        a.Na = a.B;
      }
      b.G = setTimeout(function () {
        b.G && (b.complete ? b.va() : (a.trackOffline && b.abort && b.abort(), b.Ha()));
      }, 5E3);
      a.rb = c;
      a.B = k["s_i_" + a.replace(a.account, ",", "_")] = b;
      if (a.useForcedLinkTracking && a.K || a.A) a.forcedLinkTrackingTimeout || (a.forcedLinkTrackingTimeout = 250), a.ha = setTimeout(a.ga, a.forcedLinkTrackingTimeout);
    };
    a.sb = function () {
      if (a.ra() && !(a.Oa > a.O)) try {
        k.localStorage.removeItem(a.pa()), a.Oa = a.C();
      } catch (c) {}
    };
    a.Qa = function (c) {
      if (a.ra()) {
        a.Sa();
        try {
          k.localStorage.setItem(a.pa(), k.JSON.stringify(c)), a.O = a.C();
        } catch (b) {}
      }
    };
    a.Sa = function () {
      if (a.trackOffline) {
        if (!a.offlineLimit || 0 >= a.offlineLimit) a.offlineLimit = 10;
        for (; a.i.length > a.offlineLimit;) a.Ga();
      }
    };
    a.forceOffline = function () {
      a.qa = !0;
    };
    a.forceOnline = function () {
      a.qa = !1;
    };
    a.pa = function () {
      return a.offlineFilename + "-" + a.visitorNamespace + a.account;
    };
    a.C = function () {
      return new Date().getTime();
    };
    a.La = function (a) {
      a = a.toLowerCase();
      return 0 != a.indexOf("#") && 0 != a.indexOf("about:") && 0 != a.indexOf("opera:") && 0 != a.indexOf("javascript:") ? !0 : !1;
    };
    a.setTagContainer = function (c) {
      var b, d, f;
      a.Kb = c;
      for (b = 0; b < a._il.length; b++) if ((d = a._il[b]) && "s_l" == d._c && d.tagContainerName == c) {
        a.R(d);
        if (d.lmq) for (b = 0; b < d.lmq.length; b++) f = d.lmq[b], a.loadModule(f.n);
        if (d.ml) for (f in d.ml) if (a[f]) for (b in c = a[f], f = d.ml[f], f) !Object.prototype[b] && ("function" != typeof f[b] || 0 > ("" + f[b]).indexOf("s_c_il")) && (c[b] = f[b]);
        if (d.mmq) for (b = 0; b < d.mmq.length; b++) f = d.mmq[b], a[f.m] && (c = a[f.m], c[f.f] && "function" == typeof c[f.f] && (f.a ? c[f.f].apply(c, f.a) : c[f.f].apply(c)));
        if (d.tq) for (b = 0; b < d.tq.length; b++) a.track(d.tq[b]);
        d.s = a;
        break;
      }
    };
    a.Util = {
      urlEncode: a.escape,
      urlDecode: a.unescape,
      cookieRead: a.cookieRead,
      cookieWrite: a.cookieWrite,
      getQueryParam: function (c, b, d, f) {
        var e,
          g = "";
        b || (b = a.pageURL ? a.pageURL : k.location);
        d = d ? d : "&";
        if (!c || !b) return g;
        b = "" + b;
        e = b.indexOf("?");
        if (0 > e) return g;
        b = d + b.substring(e + 1) + d;
        if (!f || !(0 <= b.indexOf(d + c + d) || 0 <= b.indexOf(d + c + "=" + d))) {
          e = b.indexOf("#");
          0 <= e && (b = b.substr(0, e) + d);
          e = b.indexOf(d + c + "=");
          if (0 > e) return g;
          b = b.substring(e + d.length + c.length + 1);
          e = b.indexOf(d);
          0 <= e && (b = b.substring(0, e));
          0 < b.length && (g = a.unescape(b));
          return g;
        }
      }
    };
    a.H = "supplementalDataID timestamp dynamicVariablePrefix visitorID marketingCloudVisitorID analyticsVisitorID audienceManagerLocationHint authState fid vmk visitorMigrationKey visitorMigrationServer visitorMigrationServerSecure charSet visitorNamespace cookieDomainPeriods fpCookieDomainPeriods cookieLifetime pageName pageURL customerPerspective referrer contextData currencyCode lightProfileID lightStoreForSeconds lightIncrementBy retrieveLightProfiles deleteLightProfiles retrieveLightData".split(" ");
    a.g = a.H.concat("purchaseID variableProvider channel server pageType transactionID campaign state zip events events2 products audienceManagerBlob tnt".split(" "));
    a.na = "timestamp charSet visitorNamespace cookieDomainPeriods cookieLifetime contextData lightProfileID lightStoreForSeconds lightIncrementBy".split(" ");
    a.P = a.na.slice(0);
    a.Aa = "account allAccounts debugTracking visitor visitorOptedOut trackOffline offlineLimit offlineThrottleDelay offlineFilename usePlugins doPlugins configURL visitorSampling visitorSamplingGroup linkObject clickObject linkURL linkName linkType trackDownloadLinks trackExternalLinks trackClickMap trackInlineStats linkLeaveQueryString linkTrackVars linkTrackEvents linkDownloadFileTypes linkExternalFilters linkInternalFilters useForcedLinkTracking forcedLinkTrackingTimeout trackingServer trackingServerSecure ssl abort mobile dc lightTrackVars maxDelay expectSupplementalData usePostbacks registerPreTrackCallback registerPostTrackCallback AudienceManagement".split(" ");
    for (m = 0; 250 >= m; m++) 76 > m && (a.g.push("prop" + m), a.P.push("prop" + m)), a.g.push("eVar" + m), a.P.push("eVar" + m), 6 > m && a.g.push("hier" + m), 4 > m && a.g.push("list" + m);
    m = "pe pev1 pev2 pev3 latitude longitude resolution colorDepth javascriptVersion javaEnabled cookiesEnabled browserWidth browserHeight connectionType homepage pageURLRest marketingCloudOrgID".split(" ");
    a.g = a.g.concat(m);
    a.H = a.H.concat(m);
    a.ssl = 0 <= k.location.protocol.toLowerCase().indexOf("https");
    a.charSet = "UTF-8";
    a.contextData = {};
    a.offlineThrottleDelay = 0;
    a.offlineFilename = "AppMeasurement.offline";
    a.Pa = 0;
    a.ma = 0;
    a.O = 0;
    a.Oa = 0;
    a.linkDownloadFileTypes = "exe,zip,wav,mp3,mov,mpg,avi,wmv,pdf,doc,docx,xls,xlsx,ppt,pptx";
    a.w = k;
    a.d = k.document;
    try {
      if (a.Ta = !1, navigator) {
        var v = navigator.userAgent;
        if ("Microsoft Internet Explorer" == navigator.appName || 0 <= v.indexOf("MSIE ") || 0 <= v.indexOf("Trident/") && 0 <= v.indexOf("Windows NT 6")) a.Ta = !0;
      }
    } catch (x) {}
    a.ga = function () {
      a.ha && (k.clearTimeout(a.ha), a.ha = p);
      a.l && a.K && a.l.dispatchEvent(a.K);
      a.A && ("function" == typeof a.A ? a.A() : a.l && a.l.href && (a.d.location = a.l.href));
      a.l = a.K = a.A = 0;
    };
    a.Ra = function () {
      a.b = a.d.body;
      a.b ? (a.v = function (c) {
        var b, d, f, e, g;
        if (!(a.d && a.d.getElementById("cppXYctnr") || c && c["s_fe_" + a._in])) {
          if (a.Ca) {
            if (a.useForcedLinkTracking) a.b.removeEventListener("click", a.v, !1);else {
              a.b.removeEventListener("click", a.v, !0);
              a.Ca = a.useForcedLinkTracking = 0;
              return;
            }
          } else a.useForcedLinkTracking = 0;
          a.clickObject = c.srcElement ? c.srcElement : c.target;
          try {
            if (!a.clickObject || a.N && a.N == a.clickObject || !(a.clickObject.tagName || a.clickObject.parentElement || a.clickObject.parentNode)) a.clickObject = 0;else {
              var h = a.N = a.clickObject;
              a.la && (clearTimeout(a.la), a.la = 0);
              a.la = setTimeout(function () {
                a.N == h && (a.N = 0);
              }, 1E4);
              f = a.Ja();
              a.track();
              if (f < a.Ja() && a.useForcedLinkTracking && c.target) {
                for (e = c.target; e && e != a.b && "A" != e.tagName.toUpperCase() && "AREA" != e.tagName.toUpperCase();) e = e.parentNode;
                if (e && (g = e.href, a.La(g) || (g = 0), d = e.target, c.target.dispatchEvent && g && (!d || "_self" == d || "_top" == d || "_parent" == d || k.name && d == k.name))) {
                  try {
                    b = a.d.createEvent("MouseEvents");
                  } catch (l) {
                    b = new k.MouseEvent();
                  }
                  if (b) {
                    try {
                      b.initMouseEvent("click", c.bubbles, c.cancelable, c.view, c.detail, c.screenX, c.screenY, c.clientX, c.clientY, c.ctrlKey, c.altKey, c.shiftKey, c.metaKey, c.button, c.relatedTarget);
                    } catch (m) {
                      b = 0;
                    }
                    b && (b["s_fe_" + a._in] = b.s_fe = 1, c.stopPropagation(), c.stopImmediatePropagation && c.stopImmediatePropagation(), c.preventDefault(), a.l = c.target, a.K = b);
                  }
                }
              }
            }
          } catch (n) {
            a.clickObject = 0;
          }
        }
      }, a.b && a.b.attachEvent ? a.b.attachEvent("onclick", a.v) : a.b && a.b.addEventListener && (navigator && (0 <= navigator.userAgent.indexOf("WebKit") && a.d.createEvent || 0 <= navigator.userAgent.indexOf("Firefox/2") && k.MouseEvent) && (a.Ca = 1, a.useForcedLinkTracking = 1, a.b.addEventListener("click", a.v, !0)), a.b.addEventListener("click", a.v, !1))) : setTimeout(a.Ra, 30);
    };
    a.Ra();
    r ? a.setAccount(r) : a.F("Error, missing Report Suite ID in AppMeasurement initialization");
    a.loadModule("ActivityMap");
  }
  function s_gi(r) {
    var a,
      k = window.s_c_il,
      p,
      n,
      m = r.split(","),
      s,
      u,
      t = 0;
    if (k) for (p = 0; !t && p < k.length;) {
      a = k[p];
      if ("s_c" == a._c && (a.account || a.oun)) if (a.account && a.account == r) t = 1;else for (n = a.account ? a.account : a.oun, n = a.allAccounts ? a.allAccounts : n.split(","), s = 0; s < m.length; s++) for (u = 0; u < n.length; u++) m[s] == n[u] && (t = 1);
      p++;
    }
    t ? a.setAccount && a.setAccount(r) : a = new AppMeasurement(r);
    return a;
  }
  AppMeasurement.getInstance = s_gi;
  function s_pgicq() {
    var r = window,
      a = r.s_giq,
      k,
      p,
      n;
    if (a) for (k = 0; k < a.length; k++) p = a[k], n = s_gi(p.oun), n.setAccount(p.un), n.setTagContainer(p.tagContainerName);
    r.s_giq = 0;
  }
  function importScript() {
    if (typeof window !== 'undefined') {
      window.AppMeasurement = AppMeasurement;
      window.s_gi = s_gi;
      window.s_pgicq = s_pgicq;
      window.s_objectID || (window.s_objectID = 0);
      s_pgicq();
      window['AppMeasurement_Module_AudienceManagement'] = AppMeasurement_Module_AudienceManagement;
    }
  }
  importScript();

  /***/
}), (/* 21 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  };
  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }
    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();
  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  var environment = __webpack_require__(2);
  var _require = __webpack_require__(1),
    toLogStore = _require.toLogStore;
  var TEALIUM_OFF = 'TEALIUM_OFF';
  var pageNamesRegex = new RegExp('page.affhub.home|page.affhub.programs', 'i');
  var TealiumPublisher = function () {
    function TealiumPublisher() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        tealiumAccountDetails: {},
        env: undefined,
        isDebugEnabled: undefined
      };
      _classCallCheck(this, TealiumPublisher);
      if (!environment.isBrowser()) {
        throw new Error('Tealium is only supported on a browser');
      }
      this.isDebugEnabled = params.isDebugEnabled;
      this.tAccount = 'expedia';
      if (params.tealiumAccountDetails && params.tealiumAccountDetails.tealiumAccountName) {
        this.tAccount = params.tealiumAccountDetails.tealiumAccountName;
      }
      this.tProfile = 'main';
      if (params.tealiumAccountDetails && params.tealiumAccountDetails.tealiumProfileName) {
        this.tProfile = params.tealiumAccountDetails.tealiumProfileName;
      }
      this.env = environment.isTestEnvironment() ? 'dev' : 'prod';
    }
    _createClass(TealiumPublisher, [{
      key: 'publish',
      value: function publish(data) {
        if (this.tAccount === TEALIUM_OFF || this.tProfile === TEALIUM_OFF) {
          return Promise.resolve();
        }
        if (data && data.context && data.context.clientInfo && data.context.clientInfo.requestMadeByBot) {
          return Promise.resolve();
        }
        if (data && data.pageInfo && data.pageInfo.pageName && pageNamesRegex.test(data.pageInfo.pageName)) {
          return Promise.resolve();
        }
        return addTag(data, this.tAccount, this.tProfile, this.env, this.isDebugEnabled);
      }
    }]);
    return TealiumPublisher;
  }();
  function addTag(data, tAccount, tProfile, env, isDebugEnabled) {
    return new Promise(function (resolve) {
      if (document.body) {
        publishToTealium(data, tAccount, tProfile, env, isDebugEnabled);
        resolve();
      } else {
        document.onreadystatechange = function () {
          if (document.readyState === 'complete') {
            publishToTealium(data, tAccount, tProfile, env, isDebugEnabled);
            resolve();
          }
        };
      }
    });
  }
  function publishToTealium(data, account, profile, env, isDebugEnabled) {
    window.utag_data = data;
    if (!document.getElementById('tealiumjs')) {
      addScript(account, profile, env);
    } else if (_typeof(window.utag) === 'object' && typeof window.utag.view === 'function') {
      window.utag.view(data);
    }
    var _ref = data.pageInfo || {},
      pageName = _ref.pageName;
    toLogStore(data, 'tealium', 'view', pageName, isDebugEnabled);
  }
  function addScript(account, profile, env) {
    var _this = this;
    var script = document.createElement('script');
    script.setAttribute('id', 'tealiumjs');
    script.setAttribute('async', '');
    script.onerror = function (error) {
      console.error('Error loading Tealium script', error); // eslint-disable-line no-console
      toLogStore(error, 'tealium', 'view', 'error', _this.isDebugEnabled);
    };
    script.src = '//tags.tiqcdn.com/utag/' + account + '/' + profile + '/' + env + '/utag.js';
    document.body.appendChild(script);
  }
  module.exports = TealiumPublisher;

  /***/
}), (/* 22 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }
    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();
  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  var environment = __webpack_require__(2);
  var _require = __webpack_require__(1),
    toLogStore = _require.toLogStore;
  var TagCommanderPublisher = function () {
    function TagCommanderPublisher(_ref) {
      var _ref$config = _ref.config,
        config = _ref$config === undefined ? {} : _ref$config,
        isDebugEnabled = _ref.isDebugEnabled;
      _classCallCheck(this, TagCommanderPublisher);
      if (!environment.isBrowser()) {
        throw new Error('TagCommander is only supported on a browser');
      }
      this.isDebugEnabled = isDebugEnabled;
      this.enabled = config.enabled || false;
      this.url = config.tcContainerUrl;
    }
    _createClass(TagCommanderPublisher, [{
      key: 'publish',
      value: function publish(tcVars) {
        if (!this.enabled) {
          return;
        }
        addTag(this.url, tcVars, this.isDebugEnabled);
      }
    }]);
    return TagCommanderPublisher;
  }();
  function addTag(url, tcVars, isDebugEnabled) {
    if (!url) {
      return;
    }
    if (document.body) {
      setTcVars(tcVars);
      addScript(url, isDebugEnabled);
    } else {
      window.addEventListener('load', function () {
        setTcVars(tcVars);
        addScript(url, isDebugEnabled);
      });
    }
    var pageName = tcVars && tcVars.page_name ? tcVars.page_name : '';
    toLogStore(tcVars, 'tagCommander', 'view', pageName, isDebugEnabled);
  }
  function setTcVars(tcVars) {
    window.tc_vars = tcVars;
  }
  function addScript(url, isDebugEnabled) {
    if (window.self !== window.top) {
      return;
    }
    var script = document.createElement('script');
    script.setAttribute('id', 'tcjs');
    script.setAttribute('async', '');
    script.onerror = function (error) {
      toLogStore(error, 'tagCommander', 'view', 'error', isDebugEnabled);
    };
    var delay = getDelayForMVT();
    if (delay) {
      setTimeout(function () {
        script.src = url;
        document.body.appendChild(script);
      }, delay);
    } else {
      script.src = url;
      document.body.appendChild(script);
    }
  }
  function getDelayForMVT() {
    var mvt = void 0;
    var mvtConfig = {
      1: 1500,
      2: 2000
    };
    if (typeof window !== 'undefined' && typeof window.__PLUGIN_STATE__ !== 'undefined' && typeof window.__PLUGIN_STATE__['experiment-store'] !== 'undefined' && typeof window.__PLUGIN_STATE__['experiment-store'].experimentStore !== 'undefined' && typeof window.__PLUGIN_STATE__['experiment-store'].experimentStore.exposures !== 'undefined' && typeof window.__PLUGIN_STATE__['experiment-store'].experimentStore.exposures.Lodging_Tag_Commander_Delay !== 'undefined' && typeof window.__PLUGIN_STATE__['experiment-store'].experimentStore.exposures.Lodging_Tag_Commander_Delay.bucket !== 'undefined' && typeof window.__PLUGIN_STATE__['experiment-store'].experimentStore.exposures.Lodging_Tag_Commander_Delay.bucket === 'number') {
      mvt = window.__PLUGIN_STATE__['experiment-store'].experimentStore.exposures.Lodging_Tag_Commander_Delay.bucket;
    }
    return mvtConfig[mvt];
  }
  module.exports = {
    TagCommanderPublisher: TagCommanderPublisher,
    getDelayForMVT: getDelayForMVT,
    addScript: addScript
  };

  /***/
}), (/* 23 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }
    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();
  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  var config = __webpack_require__(7);
  var environment = __webpack_require__(2);
  var adobeLibrariesLoader = __webpack_require__(4);
  var appMeasurementLoader = __webpack_require__(5);
  var travelPixelLoader = __webpack_require__(24);
  var browser = __webpack_require__(3);
  var _require = __webpack_require__(1),
    toLogStore = _require.toLogStore;
  var TravelPixelPublisher = function () {
    function TravelPixelPublisher(isDebugEnabled) {
      var _this = this;
      _classCallCheck(this, TravelPixelPublisher);
      this.isDebugEnabled = isDebugEnabled;
      this.hostname = typeof window !== 'undefined' ? window.location.hostname : 'localhost';
      this.readyToPublish = Promise.all([adobeLibrariesLoader.load(), appMeasurementLoader.load(), travelPixelLoader.load(environment)]).then(function (results) {
        _this.s = results[1];
        _this.s.visitor = results[0];
        _this.trvlPixApi = results[2];
      });
    }
    _createClass(TravelPixelPublisher, [{
      key: 'publish',
      value: function publish(uim) {
        var _this2 = this;
        return this.readyToPublish.then(function () {
          try {
            var userData = uim && uim.context && uim.context.user || {};
            var siteData = uim && uim.context && uim.context.site || {};
            var mcmId = browser.fetchMarketingIdFromCookie('AMCV_' + config.ADOBE_MARKETING_CLOUD_ORGANIZATION_ID);
            var result = _this2.trvlPixApi.loadXdidApi({
              guid: userData.guid,
              tpid: siteData.tpid,
              eapid: siteData.eapid,
              expUserId: userData.expUserProfileId,
              amcv: mcmId,
              inAuthId: browser.getCookie('IAID'),
              emailHash: userData.xVisitorId,
              serverPlatform: 'bexg'
            });
            var debugLabel = ((uim || {}).pageInfo || {}).pageName;
            toLogStore({
              response: result || {}
            }, 'travelpixel', 'view', debugLabel, _this2.isDebugEnabled);
            return result;
          } catch (err) {
            console.log(err.stack);
            return err;
          }
        });
      }
    }]);
    return TravelPixelPublisher;
  }();
  module.exports = TravelPixelPublisher;

  /***/
}), (/* 24 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  var _require = __webpack_require__(1),
    toLogStore = _require.toLogStore;
  var _require2 = __webpack_require__(2),
    getConfiguration = _require2.getConfiguration;
  var trvlPxConfig = getConfiguration().travelPixel;
  module.exports = {
    load: loadTravelPixelApi
  };
  var travelPixelApiLibrary = void 0;
  var travelPixelService = void 0;
  function loadTravelPixelApi() {
    if (!travelPixelApiLibrary) {
      travelPixelApiLibrary = loadTravelScriptService();
    }
    return travelPixelApiLibrary;
  }
  function initTravelPixelAPI() {
    var trvlPx = window.travelPixel;
    var trvlPxApi = typeof trvlPx !== 'undefined' && new trvlPx.Waiter(trvlPxConfig.domain, trvlPxConfig.environment);
    toLogStore('TravelPixel', 'tpw', 'load', 'travelPixel', false);
    return trvlPxApi;
  }

  // Documented here: https://marketing.adobe.com/resources/help/en_US/mcvid/mcvid-setup-analytics.html
  function loadTravelScriptService() {
    if (!travelPixelService) {
      travelPixelService = new Promise(function (resolve, reject) {
        var onTravelApiReady = function onTravelApiReady() {
          resolve(initTravelPixelAPI());
        };
        if (typeof window.travelPixel === 'undefined') {
          var script = document.createElement('script');
          script.onload = onTravelApiReady;
          script.setAttribute('id', 'trvlpxjs');
          script.setAttribute('async', '');
          script.onerror = function (error) {
            console.error('Error loading TravelPixel script', error); // eslint-disable-line no-console
            reject(error);
          };
          script.src = trvlPxConfig.url;
          document.getElementsByTagName('head')[0].appendChild(script);
        } else {
          onTravelApiReady();
        }
      });
    }
    return travelPixelService;
  }

  /***/
}), (/* 25 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  var adobePopulator = __webpack_require__(26);
  var appMeasurementLoader = __webpack_require__(5);
  var browser = __webpack_require__(3);
  function getAllClientSideSchemas() {
    var overridenMicroMessages = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var analyticsPayload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var adobeData = {};
    var capturedSchema = [];
    var pageName = analyticsPayload[0].context.pageName;
    captureMergeTraces(capturedSchema, analyticsPayload);
    getLibraryVersionsSchema(analyticsPayload[0].version, adobeData);
    if (overridenMicroMessages.length > 0) {
      overridenMicroMessages.forEach(function (schema) {
        capturedSchema.push(schema);
      });
    }
    populateVisitorId(adobeData);
    return appMeasurementLoader.load().then(function (appMeasurement) {
      if (pageName && pageName.length > 0) {
        getScrollDepthSchema(analyticsPayload, appMeasurement, pageName, adobeData);
      }
      return {
        adobeData: adobeData,
        schema: capturedSchema
      };
    });
  }
  var getLocalStorage = function getLocalStorage() {
    if (typeof localStorage === 'undefined') {
      return {
        setItem: function setItem() {},
        getItem: function getItem() {}
      };
    }
    return localStorage;
  };
  function populateVisitorId(adobeData) {
    var visitorId = browser.getQueryParameterByName('adobe_aa_vid', window.location.href) || getLocalStorage().getItem('adobe_aa_vid');
    if (visitorId) {
      getLocalStorage().setItem('adobe_aa_vid', visitorId);
      adobeData.visitorID = visitorId;
    }
  }
  function updateAdobeLibParameters(libVersion, adobeData) {
    adobeData.prop41 = getUiToolkitVersion().match(/^v(\d+\.\d+\.\d+)/) ? RegExp.$1 : 'unknown';
    adobeData.prop50 = 'PLATFORM-ANALYTICS-PRIME-JAVA ' + libVersion + '|PLATFORM-ANALYTICS-PRIME-JS ' + "1.16.3";
  }
  function getLibraryVersionsSchema(libVersion, adobeData) {
    updateAdobeLibParameters(libVersion, adobeData);
  }
  function updateAdobeScollDepthParameters(adobePopulatorValues, adobeData) {
    adobeData.prop21 = adobePopulatorValues.previousPageName;
    adobeData.prop22 = adobePopulatorValues.scrollDepth;
  }
  function getScrollDepthSchema(analyticsPayload, appMeasurement, pageName, adobeData) {
    if (analyticsPayload) {
      var payload = analyticsPayload[0];
      if (payload && payload.context) {
        appMeasurement.cookieDomainPeriods = payload.context.cookieDomainPeriods;
        appMeasurement.fpCookieDomainPeriods = payload.context.fpCookieDomainPeriods;
      }
    }
    var data = {
      pageName: pageName,
      appMeasurement: appMeasurement
    };
    var adobePopulatorValues = adobePopulator.populate(data);
    updateAdobeScollDepthParameters(adobePopulatorValues, adobeData);
  }
  function captureMergeTraces(capturedSchema, analyticsPayload) {
    if (analyticsPayload.length > 1) {
      var traceIdSet = new Set();
      analyticsPayload.forEach(function (payload) {
        if (payload.traceId) {
          traceIdSet.add(payload.traceId);
        }
      });
      var traceIds = [];
      traceIdSet.forEach(function (traceId) {
        traceIds.push(traceId);
      });
      if (traceIds.length > 1) {
        capturedSchema.push({
          schemaName: 'mergeTraces',
          messageContent: {
            traceIds: traceIds
          }
        });
      }
    }
  }
  function getUiToolkitVersion() {
    var uitkVersion = document.documentElement.getAttribute('data-version');
    if (uitkVersion) {
      return uitkVersion;
    }
    if (window.uitk && window.uitk.version) {
      return window.uitk.version;
    }
    return 'unknown';
  }
  module.exports = {
    getAllSchemas: getAllClientSideSchemas,
    populateVisitorId: populateVisitorId,
    captureMergeTraces: captureMergeTraces,
    updateAdobeScollDepthParameters: updateAdobeScollDepthParameters
  };

  /***/
}), (/* 26 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  /* WEBPACK VAR INJECTION */
  (function (global) {
    var MAX_PERCENT_VIEWED_INDEX = 1;
    var INITIAL_PERCENT_VIEWED_INDEX = 2;
    function getTotalPercentVisitorScrolled(percentPageViewed) {
      return percentPageViewed[MAX_PERCENT_VIEWED_INDEX] - percentPageViewed[INITIAL_PERCENT_VIEWED_INDEX];
    }

    /**
     * @param {Object} data === s (adobe lib)
     * @param {string} data.pageName === s.pageName
     * @param {function} data.getPreviousValue === s.getPreviousValue
     * @param {function} data.getPercentPageViewed === s.getPercentPageViewed
     */
    function populateScrollDepthTrackingData(data) {
      var capturedData = {};
      var previousPageName = data.appMeasurement.getPreviousValue(data.pageName, 's_ppn');
      capturedData.previousPageName = previousPageName;
      var percentPageViewed = [];
      var domain = (global.location || {}).hostname || undefined;
      try {
        if (domain && domain.indexOf('chase.com') < 0) {
          percentPageViewed = data.appMeasurement.getPercentPageViewed(previousPageName);
        }
        // clear max % viewed if no prev page view
        var scrollDepth = !data.pageName || data.pageName === 'no value' || !percentPageViewed ? '' : percentPageViewed[MAX_PERCENT_VIEWED_INDEX] + '|' + getTotalPercentVisitorScrolled(percentPageViewed);
        capturedData.scrollDepth = scrollDepth === 'undefined|NaN' ? '' : scrollDepth;
      } catch (err) {
        // if AppMeasurement is loaded before the DOM getPercentPageViewed may throw an error
        console.log(err);
        capturedData.scrollDepth = '';
      }
      return capturedData;
    }
    module.exports.populate = populateScrollDepthTrackingData;
    /* WEBPACK VAR INJECTION */
  }).call(this, __webpack_require__(0));

  /***/
}), (/* 27 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  var _require = __webpack_require__(1),
    toLogStore = _require.toLogStore;
  var PAGE_IDENTITY_SCHEMA = 'pageIdentity';
  var PARENT_VIEW_SCHEMA = 'parentView';
  var EVENTS_SCHEMA = 'events';
  var NEW_VISIT_EVENT = 'NewVisit';
  var ENTRY_PAGE_VIEW_EVENT = 'EntryPageView';
  function addPageIdentity(microMessages, context) {
    if (!(findMicroMessage(microMessages, PAGE_IDENTITY_SCHEMA).length > 0)) {
      if (!context.pageIdentity) {
        var errorMessage = 'PlatformAnalyticsPrime: pageIdentity not available in PlatformAnalytics instance';
        console.error(errorMessage);
        toLogStore(errorMessage, 'PlatformAnalyticsPrime', 'track', 'error', false);
      } else {
        microMessages.push({
          schemaName: PAGE_IDENTITY_SCHEMA,
          messageContent: context.pageIdentity
        });
      }
    }
  }
  function addParentView(microMessages, context) {
    if (!(findMicroMessage(microMessages, PARENT_VIEW_SCHEMA).length > 0)) {
      microMessages.push({
        schemaName: PARENT_VIEW_SCHEMA,
        messageContent: {
          applicationNameOfTheView: context.applicationName,
          traceIdOfTheView: context.traceIdOfTheView
        }
      });
    }
  }
  function addVisitEvents(microMessages, context) {
    if (context.newVisit) {
      addEventMicroMessage(microMessages, NEW_VISIT_EVENT);
    }
    if (context.entryPageView) {
      addEventMicroMessage(microMessages, ENTRY_PAGE_VIEW_EVENT);
    }
  }
  function addEventMicroMessage(microMessages, eventName) {
    var eventMicroMessage = findEventMicroMessage(microMessages, eventName);
    if (eventMicroMessage.length === 0) {
      eventMicroMessage = {
        schemaName: EVENTS_SCHEMA,
        messageContent: {
          name: eventName
        }
      };
      microMessages.push(eventMicroMessage);
    }
  }
  function findEventMicroMessage(microMessagesArray, targetEvent) {
    return microMessagesArray.filter(function (microMessage) {
      return microMessage.schemaName === EVENTS_SCHEMA && microMessage.messageContent.name === targetEvent;
    });
  }
  function findMicroMessage(microMessagesArray, targetSchemaName) {
    return microMessagesArray.filter(function (microMessage) {
      return microMessage.schemaName === targetSchemaName;
    });
  }
  module.exports = {
    addPageIdentity: addPageIdentity,
    addParentView: addParentView,
    addVisitEvents: addVisitEvents
  };

  /***/
}), (/* 28 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }
    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();
  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  var ContextualInfo = function () {
    function ContextualInfo() {
      var platformAnalyticsInstance = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      _classCallCheck(this, ContextualInfo);
      this.platformAnalyticsInstance = platformAnalyticsInstance;
    }
    _createClass(ContextualInfo, [{
      key: "pageName",
      get: function get() {
        return this.platformAnalyticsInstance._ctx.pageName;
      }
    }]);
    return ContextualInfo;
  }();
  module.exports = ContextualInfo;

  /***/
}), (/* 29 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  var environment = __webpack_require__(2);
  var browser = __webpack_require__(3);
  var util = __webpack_require__(6);
  var UNSPECIFIED = 'unknown';
  function updateContextualInfoWithFirstPayload(_ctx, payload) {
    _ctx = _ctx || {};
    if (payload) {
      if (payload.applicationName) {
        _ctx.applicationName = payload.applicationName;
      }
      if (payload.traceId) {
        _ctx.traceIdOfTheView = payload.traceId;
      }
      if (payload.context) {
        Object.keys(payload.context).forEach(function (key) {
          if ((key !== 'pageIdentity' || !_ctx.pageIdentity) && key !== 'pageName') {
            _ctx[key] = payload.context[key];
          }
        });
      }
      if (payload.tealiumContext) {
        _ctx.tealiumContext = _ctx.tealiumContext || {};
        Object.keys(payload.tealiumContext).forEach(function (key) {
          _ctx.tealiumContext[key] = payload.tealiumContext[key];
        });
      }
    }
  }
  function createContextualInfo(params) {
    var context = {};
    context.env = environment.isTestEnvironment() ? 'dev' : 'prod';
    context.overridenMicroMessages = params && params.overridenMicroMessages || [];
    context.deviceId = params && params.deviceId || getDeviceIdFromCookie();
    if (context.overridenMicroMessages) {
      var overridePageSchema = util.searchPageIdentity(context.overridenMicroMessages);
      if (overridePageSchema) {
        context.pageIdentity = overridePageSchema.messageContent;
      }
    }
    context.pageName = context.pageIdentity ? context.pageIdentity.pageIdentifier : UNSPECIFIED;
    context.hasPub = false;
    context.isPwa = !!params.isPwa;
    context.isClientSidePageLoad = false;
    context.isCrossSite = params.isCrossSite;
    context.traceIdOfTheView = params.traceIdOfTheView;
    context.applicationName = params.applicationName;
    context.isAutomaticAdobePageViewDisabled = !!params.isAutomaticAdobePageViewDisabled;
    context.additionalHeaders = params && params.additionalHeaders || {};
    return context;
  }
  function updatePageName(pa, payload) {
    var pageName = pa._ctx.pageName;
    if (pageName === UNSPECIFIED) {
      if (payload.context && payload.context.pageIdentity) {
        pageName = payload.context.pageIdentity.pageIdentifier;
      } else if (payload.adobeMappedData && payload.adobeMappedData.pageName) {
        pageName = payload.adobeMappedData.pageName;
      } else if (payload.tealiumUtagData && payload.tealiumUtagData.pageInfo && payload.tealiumUtagData.pageInfo.pageName) {
        pageName = ((payload.tealiumUtagData || {}).pageInfo || {}).pageName;
      }
    }
    pa._ctx.pageName = pageName;
    pa.pageName = pageName;
    payload.context.pageName = pageName;
    if (payload.adobeMappedData && payload.adobeMappedData.pageName) {
      payload.adobeMappedData.pageName = pageName;
    }
    if (payload.tealiumUtagData && payload.tealiumUtagData.pageInfo && payload.tealiumUtagData.pageInfo.pageName) {
      payload.tealiumUtagData.pageInfo.pageName = pageName;
    }
    return pageName;
  }
  function getDeviceIdFromCookie() {
    return browser.getCookie('DUAID');
  }
  module.exports = {
    updateContextualInfoWithFirstPayload: updateContextualInfoWithFirstPayload,
    createContextualInfo: createContextualInfo,
    updatePageName: updatePageName,
    UNSPECIFIED: UNSPECIFIED
  };

  /***/
}), (/* 30 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  var _require = __webpack_require__(6),
    mergeObjects = _require.mergeObjects;
  var marketingExtractor = __webpack_require__(31);
  var adobeMapper = __webpack_require__(32);
  var tealiumMapper = __webpack_require__(33);
  function injectMarketingData(payload, isClientSidePageLoad) {
    if (!payload) return;
    var marketingData = marketingExtractor.getMarketingDataFromCesc();
    if (!payload.adobeMappedData) {
      payload.adobeMappedData = {};
    }
    adobeMapper.map(marketingData, payload.adobeMappedData, isClientSidePageLoad);
    if (payload.tealiumUtagData) {
      tealiumMapper.map(marketingData, payload.tealiumUtagData);
    }
  }

  /**
   * if payload.debug object exists, update payload.debug.adobeMappedData with payload.adobeMappedData
   * @param {object} payload - object that follows pre-defined schema
   */
  function updateDebugData(payload) {
    if (!payload.debug) {
      return;
    }
    payload.adobeMappedData = payload.adobeMappedData || {};
    payload.debug.adobeMappedData = payload.debug.adobeMappedData || {};
    mergeObjects(payload.debug.adobeMappedData, payload.adobeMappedData);
    payload.tealiumUtagData = payload.tealiumUtagData || {};
    payload.debug.tealiumUtagData = payload.debug.tealiumUtagData || {};
    mergeObjects(payload.debug.tealiumUtagData, payload.tealiumUtagData);
  }
  module.exports = {
    injectMarketingData: injectMarketingData,
    updateDebugData: updateDebugData
  };

  /***/
}), (/* 31 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }
    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();
  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  var Campaign = function () {
    function Campaign(campaignValue, timestamp) {
      _classCallCheck(this, Campaign);
      this.campaignValue = campaignValue;
      this.timestamp = timestamp;
    }
    _createClass(Campaign, [{
      key: 'getCampaignValue',
      value: function getCampaignValue() {
        return this.campaignValue;
      }
    }, {
      key: 'getTimestamp',
      value: function getTimestamp() {
        return this.timestamp;
      }
    }, {
      key: 'exists',
      value: function exists() {
        return this.campaignValue && this.timestamp !== null;
      }
    }]);
    return Campaign;
  }();
  function getCescCookieAsJson() {
    var cescValue = getCescCookie();
    if (cescValue && cescValue.length > 1) {
      return JSON.parse(cescValue);
    }
    return {};
  }
  function getCescCookie() {
    var name = 'cesc=';
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for (var i = 0; i < ca.length; i += 1) {
      var c = ca[i];
      while (c.charAt(0) === ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length);
      }
    }
    return '';
  }
  function getQueryParameterByName(key, url) {
    if (key && url) {
      var param = decodeURIComponent(url.replace(new RegExp('^(?:.*[&\\?]' + encodeURIComponent(key).replace(/[\\.\\+\\*]/g, '\\$&') + '(?:\\=([^&]*))?)?.*$', 'i'), '$1'));
      return param !== '' ? param : null;
    }
    return null;
  }
  var EML = 'eml';
  var DPS = 'dps';
  var SEM = 'sem';
  var SEM_DTL = 'semdtl';
  var AFF = 'aff';
  var OLA = 'ola';
  var ICM = 'icm';
  var ENTRY_PAGE = 'entryPage';
  var CID = 'cid';
  var CID_VISIT = 'cidVisit';
  var GCLID = 'gclid';
  var SEO = 'seo';
  var MCI_CID = 'mcicid';
  var VISIT_NUMBER = 'visitNumber';
  var HIT_NUMBER = 'hitNumber';
  var MARKETING_CLICK = 'marketingClick';
  function toMarketingData(cescJson) {
    var marketingData = {};
    var cidVisit = getCampaign(cescJson, CID_VISIT);
    marketingData.campaignIdVisit = cidVisit.getCampaignValue();
    marketingData.campaignIdVisitTimestamp = cidVisit.getTimestamp();
    marketingData.hitLevelCampaignId = cidVisit.getCampaignValue();
    var cid = getCampaign(cescJson, CID);
    marketingData.campaignId30Day = cid.getCampaignValue();
    marketingData.campaignId30DayTimestamp = cid.getTimestamp();
    var eml = getCampaign(cescJson, EML);
    marketingData.emailMarketingCode = eml.getCampaignValue();
    marketingData.emailMarketingCodeTimestamp = eml.getTimestamp();
    var dps = getCampaign(cescJson, DPS);
    marketingData.distributionPartner = dps.getCampaignValue();
    marketingData.distributionPartnerTimestamp = dps.getTimestamp();
    var sem = getCampaign(cescJson, SEM);
    marketingData.searchEngineMarketingCode = sem.getCampaignValue();
    marketingData.searchEngineMarketingCodeTimestamp = sem.getTimestamp();
    var aff = getCampaign(cescJson, AFF);
    marketingData.affiliateMarketingCode = aff.getCampaignValue();
    marketingData.affiliateMarketingCodeTimestamp = aff.getTimestamp();
    var ola = getCampaign(cescJson, OLA);
    marketingData.onlineAdvertisingCode = ola.getCampaignValue();
    marketingData.onlineAdvertisingCodeTimestamp = ola.getTimestamp();
    var icm = getCampaign(cescJson, ICM);
    marketingData.intraCompanyMarketingCode = icm.getCampaignValue();
    marketingData.intraCompanyMarketingCodeTimestamp = icm.getTimestamp();
    marketingData.campaignIdInternalVisit = getQueryParameterByName(MCI_CID, window.location.href);
    var semDtl = getCampaign(cescJson, SEM_DTL);
    marketingData.searchEngineMarketingDetails = semDtl.getCampaignValue();
    marketingData.searchEngineMarketingDetailsTimestamp = semDtl.getTimestamp();
    var gclid = getCampaign(cescJson, GCLID);
    marketingData.googleClickIdentifier = gclid.getCampaignValue();
    marketingData.googleClickIdentifierTimestamp = gclid.getTimestamp();
    var seo = getCampaign(cescJson, SEO);
    marketingData.searchEngineOptimisationCodeTimestamp = seo.getTimestamp();
    var marketingClick = getCampaign(cescJson, MARKETING_CLICK);
    marketingData.marketingClick = marketingClick.getCampaignValue();
    var entryPage = getCampaign(cescJson, ENTRY_PAGE);
    marketingData.entryPage = entryPage.getCampaignValue();
    var visitNumber = getCampaign(cescJson, VISIT_NUMBER);
    marketingData.visitNumber = visitNumber.getCampaignValue();
    var hitNumber = getCampaign(cescJson, HIT_NUMBER);
    marketingData.hitNumber = hitNumber.getCampaignValue();
    return marketingData;
  }
  function getCampaign(cescJson, campaignKey) {
    if (cescJson[campaignKey]) {
      try {
        var jsonArray = cescJson[campaignKey];
        return new Campaign(jsonArray[0], jsonArray[1]);
      } catch (err) {
        console.error("Campaign '{}' does not exist in cesc {}", campaignKey, cescJson);
      }
    }
    return new Campaign(null, null);
  }
  function getMarketingDataFromCesc() {
    return toMarketingData(getCescCookieAsJson());
  }
  module.exports = {
    getCescCookieAsJson: getCescCookieAsJson,
    toMarketingData: toMarketingData,
    getMarketingDataFromCesc: getMarketingDataFromCesc
  };

  /***/
}), (/* 32 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  function map(sourceMessage, output, isClientSidePageLoad) {
    output.eVar10 = getOmnitureValue(sourceMessage.campaignId30Day);
    output.eVar12 = getOmnitureValue(sourceMessage.campaignIdInternalVisit);
    output.eVar13 = getOmnitureValue(sourceMessage.emailMarketingCode);
    output.eVar14 = getOmnitureValue(sourceMessage.distributionPartner);
    output.eVar15 = getOmnitureValue(sourceMessage.searchEngineMarketingCode);
    output.eVar16 = getOmnitureValue(sourceMessage.affiliateMarketingCode);
    output.eVar17 = getOmnitureValue(sourceMessage.entryPage);
    output.eVar19 = getOmnitureValue(sourceMessage.onlineAdvertisingCode);
    output.eVar21 = getOmnitureValue(sourceMessage.intraCompanyMarketingCode);
    output.eVar23 = getOmnitureValue(sourceMessage.visitNumber);
    output.eVar36 = getOmnitureValue(sourceMessage.searchEngineMarketingDetails);
    output.eVar26 = getOmnitureValue(sourceMessage.googleClickIdentifier);
    output.campaign = getOmnitureValue(sourceMessage.campaignIdVisit);
    if (sourceMessage.hitLevelCampaignId && sourceMessage.marketingClick === 'true' && !isClientSidePageLoad) {
      output.eVar22 = sourceMessage.hitLevelCampaignId;
      output.eVar27 = sourceMessage.hitLevelCampaignId;
      output.eVar33 = sourceMessage.hitLevelCampaignId;
      addEvent(output, 'event227');
    } else {
      delete output.eVar22;
      delete output.eVar27;
      delete output.eVar33;
    }
  }
  function addEvent(output, event) {
    if (!output.events) {
      output.events = event;
    } else if (!output.events.includes(event)) {
      output.events += ',' + event;
    }
  }
  function getOmnitureValue(value) {
    if (value) {
      return value;
    }
    return 'NA';
  }
  module.exports = {
    map: map
  };

  /***/
}), (/* 33 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  function map(sourceMessage, output) {
    if (!output.context) {
      output.context = {};
    }
    if (!output.context.marketingAttribution) {
      output.context.marketingAttribution = {};
    }
    if (sourceMessage.emailMarketingCode && sourceMessage.emailMarketingCodeTimestamp) {
      output.context.marketingAttribution.emailId = sourceMessage.emailMarketingCode;
      output.context.marketingAttribution.emailIdTimestamp = sourceMessage.emailMarketingCodeTimestamp;
    }
    if (sourceMessage.distributionPartner && sourceMessage.distributionPartnerTimestamp) {
      output.context.marketingAttribution.distributionPartners = sourceMessage.distributionPartner;
      output.context.marketingAttribution.distributionPartnersTimestamp = sourceMessage.distributionPartnerTimestamp;
    }
    if (sourceMessage.searchEngineMarketingCode && sourceMessage.searchEngineMarketingCodeTimestamp) {
      output.context.marketingAttribution.searchEngineMarketingCode = sourceMessage.searchEngineMarketingCode;
      output.context.marketingAttribution.searchEngineMarketingCodeTimestamp = sourceMessage.searchEngineMarketingCodeTimestamp;
    }
    if (sourceMessage.googleClickIdentifier && sourceMessage.googleClickIdentifierTimestamp) {
      output.context.marketingAttribution.googleClickIdentifier = sourceMessage.googleClickIdentifier;
      output.context.marketingAttribution.googleClickIdentifierTimestamp = sourceMessage.googleClickIdentifierTimestamp;
    }
    if (sourceMessage.searchEngineMarketingDetails && sourceMessage.searchEngineMarketingDetailsTimestamp) {
      output.context.marketingAttribution.searchEngineMarketingDetails = sourceMessage.searchEngineMarketingDetails;
      output.context.marketingAttribution.searchEngineMarketingDetailsTimestamp = sourceMessage.searchEngineMarketingDetailsTimestamp;
    }
    if (sourceMessage.affiliateMarketingCode && sourceMessage.affiliateMarketingCodeTimestamp) {
      output.context.marketingAttribution.affiliateMarketingCode = sourceMessage.affiliateMarketingCode;
      output.context.marketingAttribution.affiliateMarketingCodeTimestamp = sourceMessage.affiliateMarketingCodeTimestamp;
    }
    if (sourceMessage.onlineAdvertisingCode && sourceMessage.onlineAdvertisingCodeTimestamp) {
      output.context.marketingAttribution.onlineAdvertisingCode = sourceMessage.onlineAdvertisingCode;
      output.context.marketingAttribution.onlineAdvertisingCodeTimestamp = sourceMessage.onlineAdvertisingCodeTimestamp;
    }
    if (sourceMessage.intraCompanyMarketingCode && sourceMessage.intraCompanyMarketingCodeTimestamp) {
      output.context.marketingAttribution.intraCompanyMarketingCode = sourceMessage.intraCompanyMarketingCode;
      output.context.marketingAttribution.intraCompanyMarketingCodeTimestamp = sourceMessage.intraCompanyMarketingCodeTimestamp;
    }
    if (sourceMessage.campaignIdVisit && sourceMessage.campaignIdVisitTimestamp) {
      output.context.marketingAttribution.campaignIdVisit = sourceMessage.campaignIdVisit;
      output.context.marketingAttribution.campaignIdVisitTimestamp = sourceMessage.campaignIdVisitTimestamp;
    }
    if (sourceMessage.campaignId30Day && sourceMessage.campaignId30DayTimestamp) {
      output.context.marketingAttribution.campaignId = sourceMessage.campaignId30Day;
      output.context.marketingAttribution.campaignIdTimestamp = sourceMessage.campaignId30DayTimestamp;
    }
    if (sourceMessage.entryPage) {
      output.context.marketingAttribution.entryPage = sourceMessage.entryPage;
    }
    output.context.marketingAttribution.pageName = 'D=pageName';
  }
  module.exports = {
    map: map
  };

  /***/
}
/******/)]);